/* eslint-disable */
// tslint:disable
/**
 * StackState API
 * This API documentation page describes the StackState server API. The StackState UI and CLI use the StackState server API to configure and query StackState. 
You can use the API for similar purposes.

Each request sent to the StackState server API must be authenticated using one of the available authentication methods. 

*Note that the StackState receiver API, used to send topology, telemetry and traces to StackState, is not described on this page and requires a different authentication method.*

For more information on StackState, refer to the [StackState documentation](https://docs.stackstate.com).

 *
 * OpenAPI spec version: 5.2.0
 * Contact: info@stackstate.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";

import { HTTPError, request as requestFetch, stringifyUrl, toResponseObservableWithMeta, toResponsePromiseWithMeta, ParamsMeta } from "../../generic/request";

import { Api } from "./models";
import { BASE_PATH, COLLECTION_FORMATS, FetchArgs } from "./runtime";

/**
 * AgentLeasesApi - fetch parameter creator
 * @export
 */
export const AgentLeasesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} agentId The identifier of an agent
		 * @param {Api.CheckLeaseRequest} request
		 * @param {*} [options] Override http request option.
		 */
		agentCheckLease(agentId: string, request: Api.CheckLeaseRequest, options: any = {}): FetchArgs {
			const localVarPath = `/agents/{agentId}/checkLease`
				.replace('{agentId}', encodeURIComponent(String(agentId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* AgentLeases
*/
export interface AgentCheckLeaseParams {
  agentId: string;
  body: Api.CheckLeaseRequest;
}

export type AgentCheckLeaseSuccess = Api.AgentRegistration;
export type AgentCheckLeaseError = HTTPError | "Forbidden" | Api.AgentRegistration | Api.GenericErrorsResponse;

/**
 * AgentCheckLeaseApi - functional programming interface
 * <p>Checks the lease of an agent and might register it if it does not exist yet.</p>
 * @export
 */
export const agentCheckLeaseFn = ({
  agentId,
 body,
 }: AgentCheckLeaseParams, options: any = {}, configuration?: Configuration): Promise<AgentCheckLeaseSuccess> => {
  const localVarFetchArgs = AgentLeasesApiFetchParamCreator(configuration).agentCheckLease(agentId, body, options);
  return requestFetch<AgentCheckLeaseSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const agentCheckLease = toResponsePromiseWithMeta<
  AgentCheckLeaseError,
  AgentCheckLeaseSuccess,
  AgentCheckLeaseParams
>(agentCheckLeaseFn);

export const agentCheckLeaseObservable = toResponseObservableWithMeta<
  AgentCheckLeaseError,
  AgentCheckLeaseSuccess,
  AgentCheckLeaseParams
>(agentCheckLeaseFn);

/**
 * AgentRegistrationsApi - fetch parameter creator
 * @export
 */
export const AgentRegistrationsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		allAgentRegistrations(options: any = {}): FetchArgs {
			const localVarPath = `/agents`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* AgentRegistrations
*/
export interface AllAgentRegistrationsParams {
}

export type AllAgentRegistrationsSuccess = Api.AgentRegistrations;
export type AllAgentRegistrationsError = HTTPError | "Forbidden" | Api.GenericErrorsResponse;

/**
 * AllAgentRegistrationsApi - functional programming interface
 * <p>Give an overview of all registered agents</p>
 * @export
 */
export const allAgentRegistrationsFn = ({
 }: AllAgentRegistrationsParams, options: any = {}, configuration?: Configuration): Promise<AllAgentRegistrationsSuccess> => {
  const localVarFetchArgs = AgentRegistrationsApiFetchParamCreator(configuration).allAgentRegistrations(options);
  return requestFetch<AllAgentRegistrationsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const allAgentRegistrations = toResponsePromiseWithMeta<
  AllAgentRegistrationsError,
  AllAgentRegistrationsSuccess,
  AllAgentRegistrationsParams
>(allAgentRegistrationsFn);

export const allAgentRegistrationsObservable = toResponseObservableWithMeta<
  AllAgentRegistrationsError,
  AllAgentRegistrationsSuccess,
  AllAgentRegistrationsParams
>(allAgentRegistrationsFn);

/**
 * ApiTokenApi - fetch parameter creator
 * @export
 */
export const ApiTokenApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		getCurrentUserApiTokens(options: any = {}): FetchArgs {
			const localVarPath = `/user/profile/tokens`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* ApiToken
*/
export interface GetCurrentUserApiTokensParams {
}

export type GetCurrentUserApiTokensSuccess = Api.ApiToken[];
export type GetCurrentUserApiTokensError = HTTPError | Api.UserNotFoundError | Api.GenericErrorsResponse;

/**
 * GetCurrentUserApiTokensApi - functional programming interface
 * <p>Get all API token of the logged-in user.</p>
 * @export
 */
export const getCurrentUserApiTokensFn = ({
 }: GetCurrentUserApiTokensParams, options: any = {}, configuration?: Configuration): Promise<GetCurrentUserApiTokensSuccess> => {
  const localVarFetchArgs = ApiTokenApiFetchParamCreator(configuration).getCurrentUserApiTokens(options);
  return requestFetch<GetCurrentUserApiTokensSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getCurrentUserApiTokens = toResponsePromiseWithMeta<
  GetCurrentUserApiTokensError,
  GetCurrentUserApiTokensSuccess,
  GetCurrentUserApiTokensParams
>(getCurrentUserApiTokensFn);

export const getCurrentUserApiTokensObservable = toResponseObservableWithMeta<
  GetCurrentUserApiTokensError,
  GetCurrentUserApiTokensSuccess,
  GetCurrentUserApiTokensParams
>(getCurrentUserApiTokensFn);

/**
 * ComponentApi - fetch parameter creator
 * @export
 */
export const ComponentApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} componentIdOrIdentifier The id or identifier (urn) of a component
		 * @param {number} [topologyTime] A timestamp at which resources will be queried. If not given the resources are queried at current time.
		 * @param {Api.BoundMetricId} request
		 * @param {*} [options] Override http request option.
		 */
		getComponentBoundMetric(componentIdOrIdentifier: string, topologyTime: number | undefined, request: Api.BoundMetricId, options: any = {}): FetchArgs {
			const localVarPath = `/components/{componentIdOrIdentifier}/bindmetric`
				.replace('{componentIdOrIdentifier}', encodeURIComponent(String(componentIdOrIdentifier)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} componentIdOrIdentifier The id or identifier (urn) of a component
		 * @param {number} startTime The start time of a time range to query resources.
		 * @param {number} [endTime] The end time of a time range to query resources. If not given the endTime is set to current time.
		 * @param {*} [options] Override http request option.
		 */
		getComponentCheckStates(componentIdOrIdentifier: string, startTime: number, endTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/components/{componentIdOrIdentifier}/checkStates`
				.replace('{componentIdOrIdentifier}', encodeURIComponent(String(componentIdOrIdentifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (startTime !== undefined) {
				localVarQueryParameter['startTime'] = startTime;
			}
			if (endTime !== undefined) {
				localVarQueryParameter['endTime'] = endTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} componentIdOrIdentifier The id or identifier (urn) of a component
		 * @param {number} startTime The start time of a time range to query resources.
		 * @param {number} [endTime] The end time of a time range to query resources. If not given the endTime is set to current time.
		 * @param {*} [options] Override http request option.
		 */
		getComponentHealthHistory(componentIdOrIdentifier: string, startTime: number, endTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/components/{componentIdOrIdentifier}/healthHistory`
				.replace('{componentIdOrIdentifier}', encodeURIComponent(String(componentIdOrIdentifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (startTime !== undefined) {
				localVarQueryParameter['startTime'] = startTime;
			}
			if (endTime !== undefined) {
				localVarQueryParameter['endTime'] = endTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} componentIdOrIdentifier The id or identifier (urn) of a component
		 * @param {number} [topologyTime] A timestamp at which resources will be queried. If not given the resources are queried at current time.
		 * @param {*} [options] Override http request option.
		 */
		getFullComponent(componentIdOrIdentifier: string, topologyTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/components/{componentIdOrIdentifier}`
				.replace('{componentIdOrIdentifier}', encodeURIComponent(String(componentIdOrIdentifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} componentIdOrIdentifier The id or identifier (urn) of a component
		 * @param {number} [topologyTime] A timestamp at which resources will be queried. If not given the resources are queried at current time.
		 * @param {number} startTime The start time of a time range to query resources.
		 * @param {number} endTime The end time of a time range to query resources.
		 * @param {*} [options] Override http request option.
		 */
		getMetricPerspectiveData(componentIdOrIdentifier: string, topologyTime: number | undefined, startTime: number, endTime: number, options: any = {}): FetchArgs {
			const localVarPath = `/components/{componentIdOrIdentifier}/metricPerspectiveData`
				.replace('{componentIdOrIdentifier}', encodeURIComponent(String(componentIdOrIdentifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			if (startTime !== undefined) {
				localVarQueryParameter['startTime'] = startTime;
			}
			if (endTime !== undefined) {
				localVarQueryParameter['endTime'] = endTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Component
*/
export interface GetComponentBoundMetricParams {
  componentIdOrIdentifier: string;
  topologyTime?: number;
  body: Api.BoundMetricId;
}

export type GetComponentBoundMetricSuccess = Api.BoundMetric;
export type GetComponentBoundMetricError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetComponentBoundMetricApi - functional programming interface
 * <p>Bind the variables in a metric binding to a component to get valid queries for fetching metric data</p>
 * @export
 */
export const getComponentBoundMetricFn = ({
  componentIdOrIdentifier,
  topologyTime,
 body,
 }: GetComponentBoundMetricParams, options: any = {}, configuration?: Configuration): Promise<GetComponentBoundMetricSuccess> => {
  const localVarFetchArgs = ComponentApiFetchParamCreator(configuration).getComponentBoundMetric(componentIdOrIdentifier, topologyTime, body, options);
  return requestFetch<GetComponentBoundMetricSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getComponentBoundMetric = toResponsePromiseWithMeta<
  GetComponentBoundMetricError,
  GetComponentBoundMetricSuccess,
  GetComponentBoundMetricParams
>(getComponentBoundMetricFn);

export const getComponentBoundMetricObservable = toResponseObservableWithMeta<
  GetComponentBoundMetricError,
  GetComponentBoundMetricSuccess,
  GetComponentBoundMetricParams
>(getComponentBoundMetricFn);

export interface GetComponentCheckStatesParams {
  componentIdOrIdentifier: string;
  startTime: number;
  endTime?: number;
}

export type GetComponentCheckStatesSuccess = Api.ComponentCheckStates;
export type GetComponentCheckStatesError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetComponentCheckStatesApi - functional programming interface
 * <p>Get a component checkstates for a defined period of time by id or identifier</p>
 * @export
 */
export const getComponentCheckStatesFn = ({
  componentIdOrIdentifier,
  startTime,
  endTime,
 }: GetComponentCheckStatesParams, options: any = {}, configuration?: Configuration): Promise<GetComponentCheckStatesSuccess> => {
  const localVarFetchArgs = ComponentApiFetchParamCreator(configuration).getComponentCheckStates(componentIdOrIdentifier, startTime, endTime, options);
  return requestFetch<GetComponentCheckStatesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getComponentCheckStates = toResponsePromiseWithMeta<
  GetComponentCheckStatesError,
  GetComponentCheckStatesSuccess,
  GetComponentCheckStatesParams
>(getComponentCheckStatesFn);

export const getComponentCheckStatesObservable = toResponseObservableWithMeta<
  GetComponentCheckStatesError,
  GetComponentCheckStatesSuccess,
  GetComponentCheckStatesParams
>(getComponentCheckStatesFn);

export interface GetComponentHealthHistoryParams {
  componentIdOrIdentifier: string;
  startTime: number;
  endTime?: number;
}

export type GetComponentHealthHistorySuccess = Api.ComponentHealthHistory;
export type GetComponentHealthHistoryError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetComponentHealthHistoryApi - functional programming interface
 * <p>Get a component health history for a defined period of time by id or identifier</p>
 * @export
 */
export const getComponentHealthHistoryFn = ({
  componentIdOrIdentifier,
  startTime,
  endTime,
 }: GetComponentHealthHistoryParams, options: any = {}, configuration?: Configuration): Promise<GetComponentHealthHistorySuccess> => {
  const localVarFetchArgs = ComponentApiFetchParamCreator(configuration).getComponentHealthHistory(componentIdOrIdentifier, startTime, endTime, options);
  return requestFetch<GetComponentHealthHistorySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getComponentHealthHistory = toResponsePromiseWithMeta<
  GetComponentHealthHistoryError,
  GetComponentHealthHistorySuccess,
  GetComponentHealthHistoryParams
>(getComponentHealthHistoryFn);

export const getComponentHealthHistoryObservable = toResponseObservableWithMeta<
  GetComponentHealthHistoryError,
  GetComponentHealthHistorySuccess,
  GetComponentHealthHistoryParams
>(getComponentHealthHistoryFn);

export interface GetFullComponentParams {
  componentIdOrIdentifier: string;
  topologyTime?: number;
}

export type GetFullComponentSuccess = Api.FullComponent;
export type GetFullComponentError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetFullComponentApi - functional programming interface
 * <p>Get full component details</p>
 * @export
 */
export const getFullComponentFn = ({
  componentIdOrIdentifier,
  topologyTime,
 }: GetFullComponentParams, options: any = {}, configuration?: Configuration): Promise<GetFullComponentSuccess> => {
  const localVarFetchArgs = ComponentApiFetchParamCreator(configuration).getFullComponent(componentIdOrIdentifier, topologyTime, options);
  return requestFetch<GetFullComponentSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getFullComponent = toResponsePromiseWithMeta<
  GetFullComponentError,
  GetFullComponentSuccess,
  GetFullComponentParams
>(getFullComponentFn);

export const getFullComponentObservable = toResponseObservableWithMeta<
  GetFullComponentError,
  GetFullComponentSuccess,
  GetFullComponentParams
>(getFullComponentFn);

export interface GetMetricPerspectiveDataParams {
  componentIdOrIdentifier: string;
  topologyTime?: number;
  startTime: number;
  endTime: number;
}

export type GetMetricPerspectiveDataSuccess = Api.MetricPerspectiveData;
export type GetMetricPerspectiveDataError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetMetricPerspectiveDataApi - functional programming interface
 * <p>Bound metric bindings for metrics that have data for a component</p>
 * @export
 */
export const getMetricPerspectiveDataFn = ({
  componentIdOrIdentifier,
  topologyTime,
  startTime,
  endTime,
 }: GetMetricPerspectiveDataParams, options: any = {}, configuration?: Configuration): Promise<GetMetricPerspectiveDataSuccess> => {
  const localVarFetchArgs = ComponentApiFetchParamCreator(configuration).getMetricPerspectiveData(componentIdOrIdentifier, topologyTime, startTime, endTime, options);
  return requestFetch<GetMetricPerspectiveDataSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMetricPerspectiveData = toResponsePromiseWithMeta<
  GetMetricPerspectiveDataError,
  GetMetricPerspectiveDataSuccess,
  GetMetricPerspectiveDataParams
>(getMetricPerspectiveDataFn);

export const getMetricPerspectiveDataObservable = toResponseObservableWithMeta<
  GetMetricPerspectiveDataError,
  GetMetricPerspectiveDataSuccess,
  GetMetricPerspectiveDataParams
>(getMetricPerspectiveDataFn);

/**
 * ComponentPresentationApi - fetch parameter creator
 * @export
 */
export const ComponentPresentationApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteComponentPresentationByIdentifier(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/presentations/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		getComponentPresentationByIdentifier(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/presentations/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getComponentPresentations(options: any = {}): FetchArgs {
			const localVarPath = `/presentations`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} presentationOrViewUrn A Component Presentation Identifier, legacy View (QueryView, ViewType) URNs are supported for backward compatibility
		 * @param {*} [options] Override http request option.
		 */
		getPresentationFilters(presentationOrViewUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/presentations/{presentationOrViewUrn}/filters`
				.replace('{presentationOrViewUrn}', encodeURIComponent(String(presentationOrViewUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.ComponentPresentation} request
		 * @param {*} [options] Override http request option.
		 */
		upsertComponentPresentations(request: Api.ComponentPresentation, options: any = {}): FetchArgs {
			const localVarPath = `/presentations`;
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* ComponentPresentation
*/
export interface DeleteComponentPresentationByIdentifierParams {
  identifier: string;
}

export type DeleteComponentPresentationByIdentifierSuccess = void;
export type DeleteComponentPresentationByIdentifierError = HTTPError | "Unauthorized" | "Forbidden" | Api.ComponentPresentationApiError | Api.ComponentPresentationApiError;

/**
 * DeleteComponentPresentationByIdentifierApi - functional programming interface
 * @export
 */
export const deleteComponentPresentationByIdentifierFn = ({
  identifier,
 }: DeleteComponentPresentationByIdentifierParams, options: any = {}, configuration?: Configuration): Promise<DeleteComponentPresentationByIdentifierSuccess> => {
  const localVarFetchArgs = ComponentPresentationApiFetchParamCreator(configuration).deleteComponentPresentationByIdentifier(identifier, options);
  return requestFetch<DeleteComponentPresentationByIdentifierSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteComponentPresentationByIdentifier = toResponsePromiseWithMeta<
  DeleteComponentPresentationByIdentifierError,
  DeleteComponentPresentationByIdentifierSuccess,
  DeleteComponentPresentationByIdentifierParams
>(deleteComponentPresentationByIdentifierFn);

export const deleteComponentPresentationByIdentifierObservable = toResponseObservableWithMeta<
  DeleteComponentPresentationByIdentifierError,
  DeleteComponentPresentationByIdentifierSuccess,
  DeleteComponentPresentationByIdentifierParams
>(deleteComponentPresentationByIdentifierFn);

export interface GetComponentPresentationByIdentifierParams {
  identifier: string;
}

export type GetComponentPresentationByIdentifierSuccess = Api.ComponentPresentation;
export type GetComponentPresentationByIdentifierError = HTTPError | "Unauthorized" | "Forbidden" | Api.ComponentPresentationApiError | Api.ComponentPresentationApiError;

/**
 * GetComponentPresentationByIdentifierApi - functional programming interface
 * @export
 */
export const getComponentPresentationByIdentifierFn = ({
  identifier,
 }: GetComponentPresentationByIdentifierParams, options: any = {}, configuration?: Configuration): Promise<GetComponentPresentationByIdentifierSuccess> => {
  const localVarFetchArgs = ComponentPresentationApiFetchParamCreator(configuration).getComponentPresentationByIdentifier(identifier, options);
  return requestFetch<GetComponentPresentationByIdentifierSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getComponentPresentationByIdentifier = toResponsePromiseWithMeta<
  GetComponentPresentationByIdentifierError,
  GetComponentPresentationByIdentifierSuccess,
  GetComponentPresentationByIdentifierParams
>(getComponentPresentationByIdentifierFn);

export const getComponentPresentationByIdentifierObservable = toResponseObservableWithMeta<
  GetComponentPresentationByIdentifierError,
  GetComponentPresentationByIdentifierSuccess,
  GetComponentPresentationByIdentifierParams
>(getComponentPresentationByIdentifierFn);

export interface GetComponentPresentationsParams {
}

export type GetComponentPresentationsSuccess = Api.ComponentPresentation[];
export type GetComponentPresentationsError = HTTPError | "Unauthorized" | "Forbidden" | Api.ComponentPresentationApiError;

/**
 * GetComponentPresentationsApi - functional programming interface
 * @export
 */
export const getComponentPresentationsFn = ({
 }: GetComponentPresentationsParams, options: any = {}, configuration?: Configuration): Promise<GetComponentPresentationsSuccess> => {
  const localVarFetchArgs = ComponentPresentationApiFetchParamCreator(configuration).getComponentPresentations(options);
  return requestFetch<GetComponentPresentationsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getComponentPresentations = toResponsePromiseWithMeta<
  GetComponentPresentationsError,
  GetComponentPresentationsSuccess,
  GetComponentPresentationsParams
>(getComponentPresentationsFn);

export const getComponentPresentationsObservable = toResponseObservableWithMeta<
  GetComponentPresentationsError,
  GetComponentPresentationsSuccess,
  GetComponentPresentationsParams
>(getComponentPresentationsFn);

export interface GetPresentationFiltersParams {
  presentationOrViewUrn: string;
}

export type GetPresentationFiltersSuccess = Api.PresentationFiltersResponse;
export type GetPresentationFiltersError = HTTPError | Api.ComponentPresentationApiError | "Unauthorized" | "Forbidden" | Api.ComponentPresentationApiError | Api.ComponentPresentationApiError;

/**
 * GetPresentationFiltersApi - functional programming interface
 * <p>Returns the effective filter definitions after applying merge semantics
across matching ComponentPresentations. The result reflects which filters
the frontend should render for the given presentation.</p>
 * @export
 */
export const getPresentationFiltersFn = ({
  presentationOrViewUrn,
 }: GetPresentationFiltersParams, options: any = {}, configuration?: Configuration): Promise<GetPresentationFiltersSuccess> => {
  const localVarFetchArgs = ComponentPresentationApiFetchParamCreator(configuration).getPresentationFilters(presentationOrViewUrn, options);
  return requestFetch<GetPresentationFiltersSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getPresentationFilters = toResponsePromiseWithMeta<
  GetPresentationFiltersError,
  GetPresentationFiltersSuccess,
  GetPresentationFiltersParams
>(getPresentationFiltersFn);

export const getPresentationFiltersObservable = toResponseObservableWithMeta<
  GetPresentationFiltersError,
  GetPresentationFiltersSuccess,
  GetPresentationFiltersParams
>(getPresentationFiltersFn);

export interface UpsertComponentPresentationsParams {
  body: Api.ComponentPresentation;
}

export type UpsertComponentPresentationsSuccess = Api.ComponentPresentation;
export type UpsertComponentPresentationsError = HTTPError | Api.ComponentPresentationApiError | "Unauthorized" | "Forbidden" | Api.ComponentPresentationApiError;

/**
 * UpsertComponentPresentationsApi - functional programming interface
 * @export
 */
export const upsertComponentPresentationsFn = ({
 body,
 }: UpsertComponentPresentationsParams, options: any = {}, configuration?: Configuration): Promise<UpsertComponentPresentationsSuccess> => {
  const localVarFetchArgs = ComponentPresentationApiFetchParamCreator(configuration).upsertComponentPresentations(body, options);
  return requestFetch<UpsertComponentPresentationsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const upsertComponentPresentations = toResponsePromiseWithMeta<
  UpsertComponentPresentationsError,
  UpsertComponentPresentationsSuccess,
  UpsertComponentPresentationsParams
>(upsertComponentPresentationsFn);

export const upsertComponentPresentationsObservable = toResponseObservableWithMeta<
  UpsertComponentPresentationsError,
  UpsertComponentPresentationsSuccess,
  UpsertComponentPresentationsParams
>(upsertComponentPresentationsFn);

/**
 * DashboardsApi - fetch parameter creator
 * @export
 */
export const DashboardsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} dashboardIdOrUrn The identifier of a dashboard
		 * @param {Api.DashboardCloneSchema} request
		 * @param {*} [options] Override http request option.
		 */
		cloneDashboard(dashboardIdOrUrn: string, request: Api.DashboardCloneSchema, options: any = {}): FetchArgs {
			const localVarPath = `/dashboards/{dashboardIdOrUrn}/clone`
				.replace('{dashboardIdOrUrn}', encodeURIComponent(String(dashboardIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.DashboardWriteSchema} request
		 * @param {*} [options] Override http request option.
		 */
		createDashboard(request: Api.DashboardWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/dashboards`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} dashboardIdOrUrn The identifier of a dashboard
		 * @param {*} [options] Override http request option.
		 */
		deleteDashboard(dashboardIdOrUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/dashboards/{dashboardIdOrUrn}`
				.replace('{dashboardIdOrUrn}', encodeURIComponent(String(dashboardIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} dashboardIdOrUrn The identifier of a dashboard
		 * @param {boolean} [loadFullDashboard] If true, includes the full dashboard content in the response. Defaults to false (only metadata is returned) for retrieval endpoints. Defaults to true for create/update operations.
		 * @param {*} [options] Override http request option.
		 */
		getDashboard(dashboardIdOrUrn: string, loadFullDashboard: boolean | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/dashboards/{dashboardIdOrUrn}`
				.replace('{dashboardIdOrUrn}', encodeURIComponent(String(dashboardIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (loadFullDashboard !== undefined) {
				localVarQueryParameter['loadFullDashboard'] = loadFullDashboard;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {boolean} [loadFullDashboard] If true, includes the full dashboard content in the response. Defaults to false (only metadata is returned) for retrieval endpoints. Defaults to true for create/update operations.
		 * @param {*} [options] Override http request option.
		 */
		getDashboards(loadFullDashboard: boolean | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/dashboards`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (loadFullDashboard !== undefined) {
				localVarQueryParameter['loadFullDashboard'] = loadFullDashboard;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} dashboardIdOrUrn The identifier of a dashboard
		 * @param {Api.DashboardPatchSchema} request
		 * @param {*} [options] Override http request option.
		 */
		patchDashboard(dashboardIdOrUrn: string, request: Api.DashboardPatchSchema, options: any = {}): FetchArgs {
			const localVarPath = `/dashboards/{dashboardIdOrUrn}`
				.replace('{dashboardIdOrUrn}', encodeURIComponent(String(dashboardIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Dashboards
*/
export interface CloneDashboardParams {
  dashboardIdOrUrn: string;
  body: Api.DashboardCloneSchema;
}

export type CloneDashboardSuccess = Api.DashboardReadFullSchema;
export type CloneDashboardError = HTTPError | Api.DashboardClientErrors | Api.DashboardAuthorizationError | Api.DashboardNotFoundError | Api.GenericErrorsResponse;

/**
 * CloneDashboardApi - functional programming interface
 * <p>Clone a dashboard by its identifier.</p>
 * @export
 */
export const cloneDashboardFn = ({
  dashboardIdOrUrn,
 body,
 }: CloneDashboardParams, options: any = {}, configuration?: Configuration): Promise<CloneDashboardSuccess> => {
  const localVarFetchArgs = DashboardsApiFetchParamCreator(configuration).cloneDashboard(dashboardIdOrUrn, body, options);
  return requestFetch<CloneDashboardSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const cloneDashboard = toResponsePromiseWithMeta<
  CloneDashboardError,
  CloneDashboardSuccess,
  CloneDashboardParams
>(cloneDashboardFn);

export const cloneDashboardObservable = toResponseObservableWithMeta<
  CloneDashboardError,
  CloneDashboardSuccess,
  CloneDashboardParams
>(cloneDashboardFn);

export interface CreateDashboardParams {
  body: Api.DashboardWriteSchema;
}

export type CreateDashboardSuccess = Api.DashboardReadFullSchema;
export type CreateDashboardError = HTTPError | Api.DashboardClientErrors | Api.GenericErrorsResponse;

/**
 * CreateDashboardApi - functional programming interface
 * <p>Create a new dashboard. The dashboard can be private or public based on the scope parameter.</p>
 * @export
 */
export const createDashboardFn = ({
 body,
 }: CreateDashboardParams, options: any = {}, configuration?: Configuration): Promise<CreateDashboardSuccess> => {
  const localVarFetchArgs = DashboardsApiFetchParamCreator(configuration).createDashboard(body, options);
  return requestFetch<CreateDashboardSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createDashboard = toResponsePromiseWithMeta<
  CreateDashboardError,
  CreateDashboardSuccess,
  CreateDashboardParams
>(createDashboardFn);

export const createDashboardObservable = toResponseObservableWithMeta<
  CreateDashboardError,
  CreateDashboardSuccess,
  CreateDashboardParams
>(createDashboardFn);

export interface DeleteDashboardParams {
  dashboardIdOrUrn: string;
}

export type DeleteDashboardSuccess = void;
export type DeleteDashboardError = HTTPError | Api.DashboardClientErrors | Api.DashboardAuthorizationError | Api.DashboardNotFoundError | Api.GenericErrorsResponse;

/**
 * DeleteDashboardApi - functional programming interface
 * <p>Delete a dashboard by its identifier. Only user-owned dashboards can be deleted.</p>
 * @export
 */
export const deleteDashboardFn = ({
  dashboardIdOrUrn,
 }: DeleteDashboardParams, options: any = {}, configuration?: Configuration): Promise<DeleteDashboardSuccess> => {
  const localVarFetchArgs = DashboardsApiFetchParamCreator(configuration).deleteDashboard(dashboardIdOrUrn, options);
  return requestFetch<DeleteDashboardSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteDashboard = toResponsePromiseWithMeta<
  DeleteDashboardError,
  DeleteDashboardSuccess,
  DeleteDashboardParams
>(deleteDashboardFn);

export const deleteDashboardObservable = toResponseObservableWithMeta<
  DeleteDashboardError,
  DeleteDashboardSuccess,
  DeleteDashboardParams
>(deleteDashboardFn);

export interface GetDashboardParams {
  dashboardIdOrUrn: string;
  loadFullDashboard?: boolean;
}

export type GetDashboardSuccess = Api.DashboardReadSchema;
export type GetDashboardError = HTTPError | Api.DashboardClientErrors | Api.DashboardNotFoundError | Api.GenericErrorsResponse;

/**
 * GetDashboardApi - functional programming interface
 * <p>Get a dashboard by its identifier.</p>
 * @export
 */
export const getDashboardFn = ({
  dashboardIdOrUrn,
  loadFullDashboard,
 }: GetDashboardParams, options: any = {}, configuration?: Configuration): Promise<GetDashboardSuccess> => {
  const localVarFetchArgs = DashboardsApiFetchParamCreator(configuration).getDashboard(dashboardIdOrUrn, loadFullDashboard, options);
  return requestFetch<GetDashboardSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getDashboard = toResponsePromiseWithMeta<
  GetDashboardError,
  GetDashboardSuccess,
  GetDashboardParams
>(getDashboardFn);

export const getDashboardObservable = toResponseObservableWithMeta<
  GetDashboardError,
  GetDashboardSuccess,
  GetDashboardParams
>(getDashboardFn);

export interface GetDashboardsParams {
  loadFullDashboard?: boolean;
}

export type GetDashboardsSuccess = Api.DashboardList;
export type GetDashboardsError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetDashboardsApi - functional programming interface
 * <p>Get a list of dashboards, optionally filtered by name.</p>
 * @export
 */
export const getDashboardsFn = ({
  loadFullDashboard,
 }: GetDashboardsParams, options: any = {}, configuration?: Configuration): Promise<GetDashboardsSuccess> => {
  const localVarFetchArgs = DashboardsApiFetchParamCreator(configuration).getDashboards(loadFullDashboard, options);
  return requestFetch<GetDashboardsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getDashboards = toResponsePromiseWithMeta<
  GetDashboardsError,
  GetDashboardsSuccess,
  GetDashboardsParams
>(getDashboardsFn);

export const getDashboardsObservable = toResponseObservableWithMeta<
  GetDashboardsError,
  GetDashboardsSuccess,
  GetDashboardsParams
>(getDashboardsFn);

export interface PatchDashboardParams {
  dashboardIdOrUrn: string;
  body: Api.DashboardPatchSchema;
}

export type PatchDashboardSuccess = Api.DashboardReadFullSchema;
export type PatchDashboardError = HTTPError | Api.DashboardClientErrors | Api.DashboardAuthorizationError | Api.DashboardNotFoundError | Api.GenericErrorsResponse;

/**
 * PatchDashboardApi - functional programming interface
 * <p>Patch an existing dashboard by its identifier. Only user-owned dashboard can be patched.</p>
 * @export
 */
export const patchDashboardFn = ({
  dashboardIdOrUrn,
 body,
 }: PatchDashboardParams, options: any = {}, configuration?: Configuration): Promise<PatchDashboardSuccess> => {
  const localVarFetchArgs = DashboardsApiFetchParamCreator(configuration).patchDashboard(dashboardIdOrUrn, body, options);
  return requestFetch<PatchDashboardSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const patchDashboard = toResponsePromiseWithMeta<
  PatchDashboardError,
  PatchDashboardSuccess,
  PatchDashboardParams
>(patchDashboardFn);

export const patchDashboardObservable = toResponseObservableWithMeta<
  PatchDashboardError,
  PatchDashboardSuccess,
  PatchDashboardParams
>(patchDashboardFn);

/**
 * DummyApi - fetch parameter creator
 * @export
 */
export const DummyApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		dummy(options: any = {}): FetchArgs {
			const localVarPath = `/dummy/dummy`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Dummy
*/
export interface DummyParams {
}

export type DummySuccess = void;
export type DummyError = HTTPError | Api.StackElementNotFound;

/**
 * DummyApi - functional programming interface
 * @export
 */
export const dummyFn = ({
 }: DummyParams, options: any = {}, configuration?: Configuration): Promise<DummySuccess> => {
  const localVarFetchArgs = DummyApiFetchParamCreator(configuration).dummy(options);
  return requestFetch<DummySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const dummy = toResponsePromiseWithMeta<
  DummyError,
  DummySuccess,
  DummyParams
>(dummyFn);

export const dummyObservable = toResponseObservableWithMeta<
  DummyError,
  DummySuccess,
  DummyParams
>(dummyFn);

/**
 * EventApi - fetch parameter creator
 * @export
 */
export const EventApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} eventId The Identifier of an event.
		 * @param {number} startTimestampMs
		 * @param {number} endTimestampMs
		 * @param {number} [playHeadTimestampMs]
		 * @param {*} [options] Override http request option.
		 */
		getEvent(eventId: string, startTimestampMs: number, endTimestampMs: number, playHeadTimestampMs: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/events/{eventId}`
				.replace('{eventId}', encodeURIComponent(String(eventId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (startTimestampMs !== undefined) {
				localVarQueryParameter['startTimestampMs'] = startTimestampMs;
			}
			if (endTimestampMs !== undefined) {
				localVarQueryParameter['endTimestampMs'] = endTimestampMs;
			}
			if (playHeadTimestampMs !== undefined) {
				localVarQueryParameter['playHeadTimestampMs'] = playHeadTimestampMs;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.EventListRequest} request
		 * @param {*} [options] Override http request option.
		 */
		getEvents(request: Api.EventListRequest, options: any = {}): FetchArgs {
			const localVarPath = `/events`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.EventsHistogramRequest} request
		 * @param {*} [options] Override http request option.
		 */
		getEventsHistogram(request: Api.EventsHistogramRequest, options: any = {}): FetchArgs {
			const localVarPath = `/eventsHistogram`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} startTimestampMs
		 * @param {number} endTimestampMs
		 * @param {string} topologyQuery
		 * @param {boolean} [includeConnectedComponents]
		 * @param {number} [playHeadTimestampMs]
		 * @param {string[]} [eventTypes]
		 * @param {number} limit
		 * @param {Api.EventCategory[]} [eventCategories] The category labels of an event.
		 * @param {string[]} [eventSources]
		 * @param {string[]} [eventTags]
		 * @param {string} [match]
		 * @param {*} [options] Override http request option.
		 */
		getEventSources(startTimestampMs: number, endTimestampMs: number, topologyQuery: string, includeConnectedComponents: boolean | undefined, playHeadTimestampMs: number | undefined, eventTypes: string[] | undefined, limit: number, eventCategories: Api.EventCategory[] | undefined, eventSources: string[] | undefined, eventTags: string[] | undefined, match: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/eventSources`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (startTimestampMs !== undefined) {
				localVarQueryParameter['startTimestampMs'] = startTimestampMs;
			}
			if (endTimestampMs !== undefined) {
				localVarQueryParameter['endTimestampMs'] = endTimestampMs;
			}
			if (topologyQuery !== undefined) {
				localVarQueryParameter['topologyQuery'] = topologyQuery;
			}
			if (includeConnectedComponents !== undefined) {
				localVarQueryParameter['includeConnectedComponents'] = includeConnectedComponents;
			}
			if (playHeadTimestampMs !== undefined) {
				localVarQueryParameter['playHeadTimestampMs'] = playHeadTimestampMs;
			}
			if (eventTypes !== undefined) {
				localVarQueryParameter['eventTypes'] = eventTypes;
			}
			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			if (eventCategories !== undefined) {
				localVarQueryParameter['eventCategories'] = eventCategories;
			}
			if (eventSources !== undefined) {
				localVarQueryParameter['eventSources'] = eventSources;
			}
			if (eventTags !== undefined) {
				localVarQueryParameter['eventTags'] = eventTags;
			}
			if (match !== undefined) {
				localVarQueryParameter['match'] = match;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} startTimestampMs
		 * @param {number} endTimestampMs
		 * @param {string} topologyQuery
		 * @param {boolean} [includeConnectedComponents]
		 * @param {number} [playHeadTimestampMs]
		 * @param {string[]} [eventTypes]
		 * @param {number} limit
		 * @param {Api.EventCategory[]} [eventCategories] The category labels of an event.
		 * @param {string[]} [eventSources]
		 * @param {string[]} [eventTags]
		 * @param {string} [match]
		 * @param {*} [options] Override http request option.
		 */
		getEventTags(startTimestampMs: number, endTimestampMs: number, topologyQuery: string, includeConnectedComponents: boolean | undefined, playHeadTimestampMs: number | undefined, eventTypes: string[] | undefined, limit: number, eventCategories: Api.EventCategory[] | undefined, eventSources: string[] | undefined, eventTags: string[] | undefined, match: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/eventTags`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (startTimestampMs !== undefined) {
				localVarQueryParameter['startTimestampMs'] = startTimestampMs;
			}
			if (endTimestampMs !== undefined) {
				localVarQueryParameter['endTimestampMs'] = endTimestampMs;
			}
			if (topologyQuery !== undefined) {
				localVarQueryParameter['topologyQuery'] = topologyQuery;
			}
			if (includeConnectedComponents !== undefined) {
				localVarQueryParameter['includeConnectedComponents'] = includeConnectedComponents;
			}
			if (playHeadTimestampMs !== undefined) {
				localVarQueryParameter['playHeadTimestampMs'] = playHeadTimestampMs;
			}
			if (eventTypes !== undefined) {
				localVarQueryParameter['eventTypes'] = eventTypes;
			}
			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			if (eventCategories !== undefined) {
				localVarQueryParameter['eventCategories'] = eventCategories;
			}
			if (eventSources !== undefined) {
				localVarQueryParameter['eventSources'] = eventSources;
			}
			if (eventTags !== undefined) {
				localVarQueryParameter['eventTags'] = eventTags;
			}
			if (match !== undefined) {
				localVarQueryParameter['match'] = match;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} startTimestampMs
		 * @param {number} endTimestampMs
		 * @param {string} topologyQuery
		 * @param {boolean} [includeConnectedComponents]
		 * @param {number} [playHeadTimestampMs]
		 * @param {string[]} [eventTypes]
		 * @param {number} limit
		 * @param {Api.EventCategory[]} [eventCategories] The category labels of an event.
		 * @param {string[]} [eventSources]
		 * @param {string[]} [eventTags]
		 * @param {string} [match]
		 * @param {*} [options] Override http request option.
		 */
		getEventTypes(startTimestampMs: number, endTimestampMs: number, topologyQuery: string, includeConnectedComponents: boolean | undefined, playHeadTimestampMs: number | undefined, eventTypes: string[] | undefined, limit: number, eventCategories: Api.EventCategory[] | undefined, eventSources: string[] | undefined, eventTags: string[] | undefined, match: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/eventTypes`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (startTimestampMs !== undefined) {
				localVarQueryParameter['startTimestampMs'] = startTimestampMs;
			}
			if (endTimestampMs !== undefined) {
				localVarQueryParameter['endTimestampMs'] = endTimestampMs;
			}
			if (topologyQuery !== undefined) {
				localVarQueryParameter['topologyQuery'] = topologyQuery;
			}
			if (includeConnectedComponents !== undefined) {
				localVarQueryParameter['includeConnectedComponents'] = includeConnectedComponents;
			}
			if (playHeadTimestampMs !== undefined) {
				localVarQueryParameter['playHeadTimestampMs'] = playHeadTimestampMs;
			}
			if (eventTypes !== undefined) {
				localVarQueryParameter['eventTypes'] = eventTypes;
			}
			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			if (eventCategories !== undefined) {
				localVarQueryParameter['eventCategories'] = eventCategories;
			}
			if (eventSources !== undefined) {
				localVarQueryParameter['eventSources'] = eventSources;
			}
			if (eventTags !== undefined) {
				localVarQueryParameter['eventTags'] = eventTags;
			}
			if (match !== undefined) {
				localVarQueryParameter['match'] = match;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Event
*/
export interface GetEventParams {
  eventId: string;
  startTimestampMs: number;
  endTimestampMs: number;
  playHeadTimestampMs?: number;
}

export type GetEventSuccess = Api.TopologyEvent;
export type GetEventError = HTTPError | Api.RequestError | Api.EventNotFoundError | Api.GenericErrorsResponse;

/**
 * GetEventApi - functional programming interface
 * <p>Retrieves a specific event by its identifier.</p>
 * @export
 */
export const getEventFn = ({
  eventId,
  startTimestampMs,
  endTimestampMs,
  playHeadTimestampMs,
 }: GetEventParams, options: any = {}, configuration?: Configuration): Promise<GetEventSuccess> => {
  const localVarFetchArgs = EventApiFetchParamCreator(configuration).getEvent(eventId, startTimestampMs, endTimestampMs, playHeadTimestampMs, options);
  return requestFetch<GetEventSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEvent = toResponsePromiseWithMeta<
  GetEventError,
  GetEventSuccess,
  GetEventParams
>(getEventFn);

export const getEventObservable = toResponseObservableWithMeta<
  GetEventError,
  GetEventSuccess,
  GetEventParams
>(getEventFn);

export interface GetEventsParams {
  body: Api.EventListRequest;
}

export type GetEventsSuccess = Api.EventItemsWithTotal;
export type GetEventsError = HTTPError | Api.RequestError | Api.GenericErrorsResponse;

/**
 * GetEventsApi - functional programming interface
 * <p>Gets you a list of events that exist for topology and time selections.</p>
 * @export
 */
export const getEventsFn = ({
 body,
 }: GetEventsParams, options: any = {}, configuration?: Configuration): Promise<GetEventsSuccess> => {
  const localVarFetchArgs = EventApiFetchParamCreator(configuration).getEvents(body, options);
  return requestFetch<GetEventsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEvents = toResponsePromiseWithMeta<
  GetEventsError,
  GetEventsSuccess,
  GetEventsParams
>(getEventsFn);

export const getEventsObservable = toResponseObservableWithMeta<
  GetEventsError,
  GetEventsSuccess,
  GetEventsParams
>(getEventsFn);

export interface GetEventsHistogramParams {
  body: Api.EventsHistogramRequest;
}

export type GetEventsHistogramSuccess = Api.EventsHistogram;
export type GetEventsHistogramError = HTTPError | Api.RequestError | Api.GenericErrorsResponse;

/**
 * GetEventsHistogramApi - functional programming interface
 * <p>Gets you a histogram of events that exist for topology and time selections.</p>
 * @export
 */
export const getEventsHistogramFn = ({
 body,
 }: GetEventsHistogramParams, options: any = {}, configuration?: Configuration): Promise<GetEventsHistogramSuccess> => {
  const localVarFetchArgs = EventApiFetchParamCreator(configuration).getEventsHistogram(body, options);
  return requestFetch<GetEventsHistogramSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEventsHistogram = toResponsePromiseWithMeta<
  GetEventsHistogramError,
  GetEventsHistogramSuccess,
  GetEventsHistogramParams
>(getEventsHistogramFn);

export const getEventsHistogramObservable = toResponseObservableWithMeta<
  GetEventsHistogramError,
  GetEventsHistogramSuccess,
  GetEventsHistogramParams
>(getEventsHistogramFn);

export interface GetEventSourcesParams {
  startTimestampMs: number;
  endTimestampMs: number;
  topologyQuery: string;
  includeConnectedComponents?: boolean;
  playHeadTimestampMs?: number;
  eventTypes?: string[];
  limit: number;
  eventCategories?: Api.EventCategory[];
  eventSources?: string[];
  eventTags?: string[];
  match?: string;
}

export type GetEventSourcesSuccess = Api.StringItemsWithTotal;
export type GetEventSourcesError = HTTPError | Api.RequestError | Api.GenericErrorsResponse;

/**
 * GetEventSourcesApi - functional programming interface
 * <p>Get a list of event sources.</p>
 * @export
 */
export const getEventSourcesFn = ({
  startTimestampMs,
  endTimestampMs,
  topologyQuery,
  includeConnectedComponents,
  playHeadTimestampMs,
  eventTypes,
  limit,
  eventCategories,
  eventSources,
  eventTags,
  match,
 }: GetEventSourcesParams, options: any = {}, configuration?: Configuration): Promise<GetEventSourcesSuccess> => {
  const localVarFetchArgs = EventApiFetchParamCreator(configuration).getEventSources(startTimestampMs, endTimestampMs, topologyQuery, includeConnectedComponents, playHeadTimestampMs, eventTypes, limit, eventCategories, eventSources, eventTags, match, options);
  return requestFetch<GetEventSourcesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEventSources = toResponsePromiseWithMeta<
  GetEventSourcesError,
  GetEventSourcesSuccess,
  GetEventSourcesParams
>(getEventSourcesFn);

export const getEventSourcesObservable = toResponseObservableWithMeta<
  GetEventSourcesError,
  GetEventSourcesSuccess,
  GetEventSourcesParams
>(getEventSourcesFn);

export interface GetEventTagsParams {
  startTimestampMs: number;
  endTimestampMs: number;
  topologyQuery: string;
  includeConnectedComponents?: boolean;
  playHeadTimestampMs?: number;
  eventTypes?: string[];
  limit: number;
  eventCategories?: Api.EventCategory[];
  eventSources?: string[];
  eventTags?: string[];
  match?: string;
}

export type GetEventTagsSuccess = Api.StringItemsWithTotal;
export type GetEventTagsError = HTTPError | Api.RequestError | Api.GenericErrorsResponse;

/**
 * GetEventTagsApi - functional programming interface
 * <p>Gets a list of tags that exist in a list of events.</p>
 * @export
 */
export const getEventTagsFn = ({
  startTimestampMs,
  endTimestampMs,
  topologyQuery,
  includeConnectedComponents,
  playHeadTimestampMs,
  eventTypes,
  limit,
  eventCategories,
  eventSources,
  eventTags,
  match,
 }: GetEventTagsParams, options: any = {}, configuration?: Configuration): Promise<GetEventTagsSuccess> => {
  const localVarFetchArgs = EventApiFetchParamCreator(configuration).getEventTags(startTimestampMs, endTimestampMs, topologyQuery, includeConnectedComponents, playHeadTimestampMs, eventTypes, limit, eventCategories, eventSources, eventTags, match, options);
  return requestFetch<GetEventTagsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEventTags = toResponsePromiseWithMeta<
  GetEventTagsError,
  GetEventTagsSuccess,
  GetEventTagsParams
>(getEventTagsFn);

export const getEventTagsObservable = toResponseObservableWithMeta<
  GetEventTagsError,
  GetEventTagsSuccess,
  GetEventTagsParams
>(getEventTagsFn);

export interface GetEventTypesParams {
  startTimestampMs: number;
  endTimestampMs: number;
  topologyQuery: string;
  includeConnectedComponents?: boolean;
  playHeadTimestampMs?: number;
  eventTypes?: string[];
  limit: number;
  eventCategories?: Api.EventCategory[];
  eventSources?: string[];
  eventTags?: string[];
  match?: string;
}

export type GetEventTypesSuccess = Api.StringItemsWithTotal;
export type GetEventTypesError = HTTPError | Api.RequestError | Api.GenericErrorsResponse;

/**
 * GetEventTypesApi - functional programming interface
 * <p>Get a list of event types for a certain STQL query.</p>
 * @export
 */
export const getEventTypesFn = ({
  startTimestampMs,
  endTimestampMs,
  topologyQuery,
  includeConnectedComponents,
  playHeadTimestampMs,
  eventTypes,
  limit,
  eventCategories,
  eventSources,
  eventTags,
  match,
 }: GetEventTypesParams, options: any = {}, configuration?: Configuration): Promise<GetEventTypesSuccess> => {
  const localVarFetchArgs = EventApiFetchParamCreator(configuration).getEventTypes(startTimestampMs, endTimestampMs, topologyQuery, includeConnectedComponents, playHeadTimestampMs, eventTypes, limit, eventCategories, eventSources, eventTags, match, options);
  return requestFetch<GetEventTypesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEventTypes = toResponsePromiseWithMeta<
  GetEventTypesError,
  GetEventTypesSuccess,
  GetEventTypesParams
>(getEventTypesFn);

export const getEventTypesObservable = toResponseObservableWithMeta<
  GetEventTypesError,
  GetEventTypesSuccess,
  GetEventTypesParams
>(getEventTypesFn);

/**
 * ExportApi - fetch parameter creator
 * @export
 */
export const ExportApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {Api.Export} request
		 * @param {*} [options] Override http request option.
		 */
		exportSettings(request: Api.Export, options: any = {}): FetchArgs {
			const localVarPath = `/export`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Export
*/
export interface ExportSettingsParams {
  body: Api.Export;
}

export type ExportSettingsSuccess = string;
export type ExportSettingsError = HTTPError;

/**
 * ExportSettingsApi - functional programming interface
 * <p>Export setting nodes as StackState Templated YAML (STY).</p>
 * @export
 */
export const exportSettingsFn = ({
 body,
 }: ExportSettingsParams, options: any = {}, configuration?: Configuration): Promise<ExportSettingsSuccess> => {
  const localVarFetchArgs = ExportApiFetchParamCreator(configuration).exportSettings(body, options);
  return requestFetch<ExportSettingsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const exportSettings = toResponsePromiseWithMeta<
  ExportSettingsError,
  ExportSettingsSuccess,
  ExportSettingsParams
>(exportSettingsFn);

export const exportSettingsObservable = toResponseObservableWithMeta<
  ExportSettingsError,
  ExportSettingsSuccess,
  ExportSettingsParams
>(exportSettingsFn);

/**
 * HealthSynchronizationApi - fetch parameter creator
 * @export
 */
export const HealthSynchronizationApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} healthStreamUrn Urn of the health stream.
		 * @param {*} [options] Override http request option.
		 */
		deleteHealthSynchronizationStream(healthStreamUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams/{healthStreamUrn}`
				.replace('{healthStreamUrn}', encodeURIComponent(String(healthStreamUrn)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getHealthSynchronizationStreamsOverview(options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} healthStreamUrn Urn of the health stream.
		 * @param {*} [options] Override http request option.
		 */
		getHealthSynchronizationStreamStatus(healthStreamUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams/{healthStreamUrn}/status`
				.replace('{healthStreamUrn}', encodeURIComponent(String(healthStreamUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} healthStreamUrn Urn of the health stream.
		 * @param {*} [options] Override http request option.
		 */
		getHealthSynchronizationStreamTopologyMatches(healthStreamUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams/{healthStreamUrn}/topologyMatches`
				.replace('{healthStreamUrn}', encodeURIComponent(String(healthStreamUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} healthStreamUrn Urn of the health stream.
		 * @param {*} [options] Override http request option.
		 */
		getHealthSynchronizationSubStreamOverview(healthStreamUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams/{healthStreamUrn}/substreams`
				.replace('{healthStreamUrn}', encodeURIComponent(String(healthStreamUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} healthStreamUrn Urn of the health stream.
		 * @param {string} healthSyncSubStreamId Health synchronization sub stream id.
		 * @param {*} [options] Override http request option.
		 */
		getHealthSynchronizationSubStreamStatus(healthStreamUrn: string, healthSyncSubStreamId: string, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams/{healthStreamUrn}/substreams/{healthSyncSubStreamId}/status`
				.replace('{healthStreamUrn}', encodeURIComponent(String(healthStreamUrn)))
				.replace('{healthSyncSubStreamId}', encodeURIComponent(String(healthSyncSubStreamId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} healthStreamUrn Urn of the health stream.
		 * @param {string} healthSyncSubStreamId Health synchronization sub stream id.
		 * @param {*} [options] Override http request option.
		 */
		getHealthSynchronizationSubStreamTopologyMatches(healthStreamUrn: string, healthSyncSubStreamId: string, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams/{healthStreamUrn}/substreams/{healthSyncSubStreamId}/topologyMatches`
				.replace('{healthStreamUrn}', encodeURIComponent(String(healthStreamUrn)))
				.replace('{healthSyncSubStreamId}', encodeURIComponent(String(healthSyncSubStreamId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} healthStreamUrn Urn of the health stream.
		 * @param {*} [options] Override http request option.
		 */
		postHealthSynchronizationStreamClearErrors(healthStreamUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/health/streams/{healthStreamUrn}/clearErrors`
				.replace('{healthStreamUrn}', encodeURIComponent(String(healthStreamUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* HealthSynchronization
*/
export interface DeleteHealthSynchronizationStreamParams {
  healthStreamUrn: string;
}

export type DeleteHealthSynchronizationStreamSuccess = void;
export type DeleteHealthSynchronizationStreamError = HTTPError | Api.InvalidUrn | Api.HealthStreamNotFound;

/**
 * DeleteHealthSynchronizationStreamApi - functional programming interface
 * <p>Delete a health synchronization stream. Deletion will not be immediate.</p>
 * @export
 */
export const deleteHealthSynchronizationStreamFn = ({
  healthStreamUrn,
 }: DeleteHealthSynchronizationStreamParams, options: any = {}, configuration?: Configuration): Promise<DeleteHealthSynchronizationStreamSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).deleteHealthSynchronizationStream(healthStreamUrn, options);
  return requestFetch<DeleteHealthSynchronizationStreamSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteHealthSynchronizationStream = toResponsePromiseWithMeta<
  DeleteHealthSynchronizationStreamError,
  DeleteHealthSynchronizationStreamSuccess,
  DeleteHealthSynchronizationStreamParams
>(deleteHealthSynchronizationStreamFn);

export const deleteHealthSynchronizationStreamObservable = toResponseObservableWithMeta<
  DeleteHealthSynchronizationStreamError,
  DeleteHealthSynchronizationStreamSuccess,
  DeleteHealthSynchronizationStreamParams
>(deleteHealthSynchronizationStreamFn);

export interface GetHealthSynchronizationStreamsOverviewParams {
}

export type GetHealthSynchronizationStreamsOverviewSuccess = Api.StreamList;
export type GetHealthSynchronizationStreamsOverviewError = HTTPError;

/**
 * GetHealthSynchronizationStreamsOverviewApi - functional programming interface
 * <p>Status overview of the health synchronization streams.</p>
 * @export
 */
export const getHealthSynchronizationStreamsOverviewFn = ({
 }: GetHealthSynchronizationStreamsOverviewParams, options: any = {}, configuration?: Configuration): Promise<GetHealthSynchronizationStreamsOverviewSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).getHealthSynchronizationStreamsOverview(options);
  return requestFetch<GetHealthSynchronizationStreamsOverviewSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getHealthSynchronizationStreamsOverview = toResponsePromiseWithMeta<
  GetHealthSynchronizationStreamsOverviewError,
  GetHealthSynchronizationStreamsOverviewSuccess,
  GetHealthSynchronizationStreamsOverviewParams
>(getHealthSynchronizationStreamsOverviewFn);

export const getHealthSynchronizationStreamsOverviewObservable = toResponseObservableWithMeta<
  GetHealthSynchronizationStreamsOverviewError,
  GetHealthSynchronizationStreamsOverviewSuccess,
  GetHealthSynchronizationStreamsOverviewParams
>(getHealthSynchronizationStreamsOverviewFn);

export interface GetHealthSynchronizationStreamStatusParams {
  healthStreamUrn: string;
}

export type GetHealthSynchronizationStreamStatusSuccess = Api.HealthStreamStatus;
export type GetHealthSynchronizationStreamStatusError = HTTPError | Api.InvalidUrn | Api.HealthStreamNotFound;

/**
 * GetHealthSynchronizationStreamStatusApi - functional programming interface
 * <p>Status overview of a single health synchronization stream</p>
 * @export
 */
export const getHealthSynchronizationStreamStatusFn = ({
  healthStreamUrn,
 }: GetHealthSynchronizationStreamStatusParams, options: any = {}, configuration?: Configuration): Promise<GetHealthSynchronizationStreamStatusSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).getHealthSynchronizationStreamStatus(healthStreamUrn, options);
  return requestFetch<GetHealthSynchronizationStreamStatusSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getHealthSynchronizationStreamStatus = toResponsePromiseWithMeta<
  GetHealthSynchronizationStreamStatusError,
  GetHealthSynchronizationStreamStatusSuccess,
  GetHealthSynchronizationStreamStatusParams
>(getHealthSynchronizationStreamStatusFn);

export const getHealthSynchronizationStreamStatusObservable = toResponseObservableWithMeta<
  GetHealthSynchronizationStreamStatusError,
  GetHealthSynchronizationStreamStatusSuccess,
  GetHealthSynchronizationStreamStatusParams
>(getHealthSynchronizationStreamStatusFn);

export interface GetHealthSynchronizationStreamTopologyMatchesParams {
  healthStreamUrn: string;
}

export type GetHealthSynchronizationStreamTopologyMatchesSuccess = Api.TopologyMatchResult;
export type GetHealthSynchronizationStreamTopologyMatchesError = HTTPError | Api.InvalidUrn | Api.HealthSubStreamError;

/**
 * GetHealthSynchronizationStreamTopologyMatchesApi - functional programming interface
 * <p>Overview of check-states matched to topology on the main stream.</p>
 * @export
 */
export const getHealthSynchronizationStreamTopologyMatchesFn = ({
  healthStreamUrn,
 }: GetHealthSynchronizationStreamTopologyMatchesParams, options: any = {}, configuration?: Configuration): Promise<GetHealthSynchronizationStreamTopologyMatchesSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).getHealthSynchronizationStreamTopologyMatches(healthStreamUrn, options);
  return requestFetch<GetHealthSynchronizationStreamTopologyMatchesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getHealthSynchronizationStreamTopologyMatches = toResponsePromiseWithMeta<
  GetHealthSynchronizationStreamTopologyMatchesError,
  GetHealthSynchronizationStreamTopologyMatchesSuccess,
  GetHealthSynchronizationStreamTopologyMatchesParams
>(getHealthSynchronizationStreamTopologyMatchesFn);

export const getHealthSynchronizationStreamTopologyMatchesObservable = toResponseObservableWithMeta<
  GetHealthSynchronizationStreamTopologyMatchesError,
  GetHealthSynchronizationStreamTopologyMatchesSuccess,
  GetHealthSynchronizationStreamTopologyMatchesParams
>(getHealthSynchronizationStreamTopologyMatchesFn);

export interface GetHealthSynchronizationSubStreamOverviewParams {
  healthStreamUrn: string;
}

export type GetHealthSynchronizationSubStreamOverviewSuccess = Api.SubStreamList;
export type GetHealthSynchronizationSubStreamOverviewError = HTTPError | Api.InvalidUrn | Api.HealthStreamNotFound;

/**
 * GetHealthSynchronizationSubStreamOverviewApi - functional programming interface
 * <p>Overview of all sub-streams in a certain health stream.</p>
 * @export
 */
export const getHealthSynchronizationSubStreamOverviewFn = ({
  healthStreamUrn,
 }: GetHealthSynchronizationSubStreamOverviewParams, options: any = {}, configuration?: Configuration): Promise<GetHealthSynchronizationSubStreamOverviewSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).getHealthSynchronizationSubStreamOverview(healthStreamUrn, options);
  return requestFetch<GetHealthSynchronizationSubStreamOverviewSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getHealthSynchronizationSubStreamOverview = toResponsePromiseWithMeta<
  GetHealthSynchronizationSubStreamOverviewError,
  GetHealthSynchronizationSubStreamOverviewSuccess,
  GetHealthSynchronizationSubStreamOverviewParams
>(getHealthSynchronizationSubStreamOverviewFn);

export const getHealthSynchronizationSubStreamOverviewObservable = toResponseObservableWithMeta<
  GetHealthSynchronizationSubStreamOverviewError,
  GetHealthSynchronizationSubStreamOverviewSuccess,
  GetHealthSynchronizationSubStreamOverviewParams
>(getHealthSynchronizationSubStreamOverviewFn);

export interface GetHealthSynchronizationSubStreamStatusParams {
  healthStreamUrn: string;
  healthSyncSubStreamId: string;
}

export type GetHealthSynchronizationSubStreamStatusSuccess = Api.HealthSubStreamStatus;
export type GetHealthSynchronizationSubStreamStatusError = HTTPError | Api.InvalidUrn | Api.HealthSubStreamError;

/**
 * GetHealthSynchronizationSubStreamStatusApi - functional programming interface
 * <p>Status overview of a single health synchronization sub stream</p>
 * @export
 */
export const getHealthSynchronizationSubStreamStatusFn = ({
  healthStreamUrn,
  healthSyncSubStreamId,
 }: GetHealthSynchronizationSubStreamStatusParams, options: any = {}, configuration?: Configuration): Promise<GetHealthSynchronizationSubStreamStatusSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).getHealthSynchronizationSubStreamStatus(healthStreamUrn, healthSyncSubStreamId, options);
  return requestFetch<GetHealthSynchronizationSubStreamStatusSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getHealthSynchronizationSubStreamStatus = toResponsePromiseWithMeta<
  GetHealthSynchronizationSubStreamStatusError,
  GetHealthSynchronizationSubStreamStatusSuccess,
  GetHealthSynchronizationSubStreamStatusParams
>(getHealthSynchronizationSubStreamStatusFn);

export const getHealthSynchronizationSubStreamStatusObservable = toResponseObservableWithMeta<
  GetHealthSynchronizationSubStreamStatusError,
  GetHealthSynchronizationSubStreamStatusSuccess,
  GetHealthSynchronizationSubStreamStatusParams
>(getHealthSynchronizationSubStreamStatusFn);

export interface GetHealthSynchronizationSubStreamTopologyMatchesParams {
  healthStreamUrn: string;
  healthSyncSubStreamId: string;
}

export type GetHealthSynchronizationSubStreamTopologyMatchesSuccess = Api.TopologyMatchResult;
export type GetHealthSynchronizationSubStreamTopologyMatchesError = HTTPError | Api.InvalidUrn | Api.HealthSubStreamError;

/**
 * GetHealthSynchronizationSubStreamTopologyMatchesApi - functional programming interface
 * <p>Overview of check-states matched to topology on the main stream.</p>
 * @export
 */
export const getHealthSynchronizationSubStreamTopologyMatchesFn = ({
  healthStreamUrn,
  healthSyncSubStreamId,
 }: GetHealthSynchronizationSubStreamTopologyMatchesParams, options: any = {}, configuration?: Configuration): Promise<GetHealthSynchronizationSubStreamTopologyMatchesSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).getHealthSynchronizationSubStreamTopologyMatches(healthStreamUrn, healthSyncSubStreamId, options);
  return requestFetch<GetHealthSynchronizationSubStreamTopologyMatchesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getHealthSynchronizationSubStreamTopologyMatches = toResponsePromiseWithMeta<
  GetHealthSynchronizationSubStreamTopologyMatchesError,
  GetHealthSynchronizationSubStreamTopologyMatchesSuccess,
  GetHealthSynchronizationSubStreamTopologyMatchesParams
>(getHealthSynchronizationSubStreamTopologyMatchesFn);

export const getHealthSynchronizationSubStreamTopologyMatchesObservable = toResponseObservableWithMeta<
  GetHealthSynchronizationSubStreamTopologyMatchesError,
  GetHealthSynchronizationSubStreamTopologyMatchesSuccess,
  GetHealthSynchronizationSubStreamTopologyMatchesParams
>(getHealthSynchronizationSubStreamTopologyMatchesFn);

export interface PostHealthSynchronizationStreamClearErrorsParams {
  healthStreamUrn: string;
}

export type PostHealthSynchronizationStreamClearErrorsSuccess = void;
export type PostHealthSynchronizationStreamClearErrorsError = HTTPError | Api.InvalidUrn | Api.HealthStreamNotFound;

/**
 * PostHealthSynchronizationStreamClearErrorsApi - functional programming interface
 * <p>Clear all errors for a stream and its sub-streams.</p>
 * @export
 */
export const postHealthSynchronizationStreamClearErrorsFn = ({
  healthStreamUrn,
 }: PostHealthSynchronizationStreamClearErrorsParams, options: any = {}, configuration?: Configuration): Promise<PostHealthSynchronizationStreamClearErrorsSuccess> => {
  const localVarFetchArgs = HealthSynchronizationApiFetchParamCreator(configuration).postHealthSynchronizationStreamClearErrors(healthStreamUrn, options);
  return requestFetch<PostHealthSynchronizationStreamClearErrorsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postHealthSynchronizationStreamClearErrors = toResponsePromiseWithMeta<
  PostHealthSynchronizationStreamClearErrorsError,
  PostHealthSynchronizationStreamClearErrorsSuccess,
  PostHealthSynchronizationStreamClearErrorsParams
>(postHealthSynchronizationStreamClearErrorsFn);

export const postHealthSynchronizationStreamClearErrorsObservable = toResponseObservableWithMeta<
  PostHealthSynchronizationStreamClearErrorsError,
  PostHealthSynchronizationStreamClearErrorsSuccess,
  PostHealthSynchronizationStreamClearErrorsParams
>(postHealthSynchronizationStreamClearErrorsFn);

/**
 * ImportApi - fetch parameter creator
 * @export
 */
export const ImportApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {number} [timeoutSeconds]
		 * @param {string} [namespace]
		 * @param {Api.ImportSettingsUnlockedEnum} [unlocked]
		 * @param {Api.ImportSettingsLockedEnum} [locked]
		 * @param {string} request
		 * @param {*} [options] Override http request option.
		 */
		importSettings(timeoutSeconds: number | undefined, namespace: string | undefined, unlocked: Api.ImportSettingsUnlockedEnum | undefined, locked: Api.ImportSettingsLockedEnum | undefined, request: string, options: any = {}): FetchArgs {
			const localVarPath = `/import`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (timeoutSeconds !== undefined) {
				localVarQueryParameter['timeoutSeconds'] = timeoutSeconds;
			}
			if (namespace !== undefined) {
				localVarQueryParameter['namespace'] = namespace;
			}
			if (unlocked !== undefined) {
				localVarQueryParameter['unlocked'] = unlocked;
			}
			if (locked !== undefined) {
				localVarQueryParameter['locked'] = locked;
			}
			localVarHeaderParameter['Content-Type'] = 'plain/text';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  (request || "");
			
			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Import
*/
export interface ImportSettingsParams {
  timeoutSeconds?: number;
  namespace?: string;
  unlocked?: Api.ImportSettingsUnlockedEnum;
  locked?: Api.ImportSettingsLockedEnum;
  body: string;
}

export type ImportSettingsSuccess = Api.ImportSettings200Response[];
export type ImportSettingsError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * ImportSettingsApi - functional programming interface
 * <p>Import setting nodes from STY or STJ definitions.</p>
 * @export
 */
export const importSettingsFn = ({
  timeoutSeconds,
  namespace,
  unlocked,
  locked,
 body,
 }: ImportSettingsParams, options: any = {}, configuration?: Configuration): Promise<ImportSettingsSuccess> => {
  const localVarFetchArgs = ImportApiFetchParamCreator(configuration).importSettings(timeoutSeconds, namespace, unlocked, locked, body, options);
  return requestFetch<ImportSettingsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const importSettings = toResponsePromiseWithMeta<
  ImportSettingsError,
  ImportSettingsSuccess,
  ImportSettingsParams
>(importSettingsFn);

export const importSettingsObservable = toResponseObservableWithMeta<
  ImportSettingsError,
  ImportSettingsSuccess,
  ImportSettingsParams
>(importSettingsFn);

/**
 * KubernetesLogsApi - fetch parameter creator
 * @export
 */
export const KubernetesLogsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {number} aFrom Logs initial timestamp.
		 * @param {number} to Logs last timestamp.
		 * @param {number} [pageSize] Maximum number of the log lines in the result.
		 * @param {number} [page] The page for which the log lines of pageSize must be returned.
		 * @param {string} [query] Find only logs containing query text.
		 * @param {string} podUID Find only logs for the given pod UID.
		 * @param {string} cluster Cluster name which identifies the scope of the RBAC data
		 * @param {string[]} [containerNames] Find only logs for the given container names.
		 * @param {Api.LogsDirection} [direction] Fetch Oldest or Newest first.
		 * @param {Api.LogSeverity[]} [severity] Search a specific log severity WARN, ERROR, OTHER.
		 * @param {number} [topologyTime] A timestamp at which the pod existed. If not given the pod is queried at current time.
		 * @param {*} [options] Override http request option.
		 */
		getKubernetesLogs(aFrom: number, to: number, pageSize: number | undefined, page: number | undefined, query: string | undefined, podUID: string, cluster: string, containerNames: string[] | undefined, direction: Api.LogsDirection | undefined, severity: Api.LogSeverity[] | undefined, topologyTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/k8s/logs`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (aFrom !== undefined) {
				localVarQueryParameter['from'] = aFrom;
			}
			if (to !== undefined) {
				localVarQueryParameter['to'] = to;
			}
			if (pageSize !== undefined) {
				localVarQueryParameter['pageSize'] = pageSize;
			}
			if (page !== undefined) {
				localVarQueryParameter['page'] = page;
			}
			if (query !== undefined) {
				localVarQueryParameter['query'] = query;
			}
			if (podUID !== undefined) {
				localVarQueryParameter['podUID'] = podUID;
			}
			if (cluster !== undefined) {
				localVarQueryParameter['cluster'] = cluster;
			}
			if (containerNames !== undefined) {
				localVarQueryParameter['containerNames'] = containerNames;
			}
			if (direction !== undefined) {
				localVarQueryParameter['direction'] = direction;
			}
			if (severity !== undefined) {
				localVarQueryParameter['severity'] = severity;
			}
			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} aFrom Logs initial timestamp.
		 * @param {number} to Logs last timestamp.
		 * @param {string} podUID Find only logs for the given pod UID.
		 * @param {string} cluster Cluster name which identifies the scope of the RBAC data
		 * @param {number} [topologyTime] A timestamp at which the pod existed. If not given the pod is queried at current time.
		 * @param {*} [options] Override http request option.
		 */
		getKubernetesLogsAutocomplete(aFrom: number, to: number, podUID: string, cluster: string, topologyTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/k8s/logs/autocomplete`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (aFrom !== undefined) {
				localVarQueryParameter['from'] = aFrom;
			}
			if (to !== undefined) {
				localVarQueryParameter['to'] = to;
			}
			if (podUID !== undefined) {
				localVarQueryParameter['podUID'] = podUID;
			}
			if (cluster !== undefined) {
				localVarQueryParameter['cluster'] = cluster;
			}
			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} aFrom Logs initial timestamp.
		 * @param {number} to Logs last timestamp.
		 * @param {string} [query] Find only logs containing query text.
		 * @param {string} podUID Find only logs for the given pod UID.
		 * @param {string} cluster Cluster name which identifies the scope of the RBAC data
		 * @param {string[]} [containerNames] Find only logs for the given container names.
		 * @param {number} bucketsCount The number of histogram buckets.
		 * @param {Api.LogSeverity[]} [severity] Search a specific log severity WARN, ERROR, OTHER.
		 * @param {number} [topologyTime] A timestamp at which the pod existed. If not given the pod is queried at current time.
		 * @param {*} [options] Override http request option.
		 */
		getKubernetesLogsHistogram(aFrom: number, to: number, query: string | undefined, podUID: string, cluster: string, containerNames: string[] | undefined, bucketsCount: number, severity: Api.LogSeverity[] | undefined, topologyTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/k8s/logs/histogram`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (aFrom !== undefined) {
				localVarQueryParameter['from'] = aFrom;
			}
			if (to !== undefined) {
				localVarQueryParameter['to'] = to;
			}
			if (query !== undefined) {
				localVarQueryParameter['query'] = query;
			}
			if (podUID !== undefined) {
				localVarQueryParameter['podUID'] = podUID;
			}
			if (cluster !== undefined) {
				localVarQueryParameter['cluster'] = cluster;
			}
			if (containerNames !== undefined) {
				localVarQueryParameter['containerNames'] = containerNames;
			}
			if (bucketsCount !== undefined) {
				localVarQueryParameter['bucketsCount'] = bucketsCount;
			}
			if (severity !== undefined) {
				localVarQueryParameter['severity'] = severity;
			}
			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* KubernetesLogs
*/
export interface GetKubernetesLogsParams {
  aFrom: number;
  to: number;
  pageSize?: number;
  page?: number;
  query?: string;
  podUID: string;
  cluster: string;
  containerNames?: string[];
  direction?: Api.LogsDirection;
  severity?: Api.LogSeverity[];
  topologyTime?: number;
}

export type GetKubernetesLogsSuccess = Api.GetKubernetesLogsResult;
export type GetKubernetesLogsError = HTTPError | Api.GetKubernetesLogsBadRequest | Api.GenericErrorsResponse;

/**
 * GetKubernetesLogsApi - functional programming interface
 * @export
 */
export const getKubernetesLogsFn = ({
  aFrom,
  to,
  pageSize,
  page,
  query,
  podUID,
  cluster,
  containerNames,
  direction,
  severity,
  topologyTime,
 }: GetKubernetesLogsParams, options: any = {}, configuration?: Configuration): Promise<GetKubernetesLogsSuccess> => {
  const localVarFetchArgs = KubernetesLogsApiFetchParamCreator(configuration).getKubernetesLogs(aFrom, to, pageSize, page, query, podUID, cluster, containerNames, direction, severity, topologyTime, options);
  return requestFetch<GetKubernetesLogsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getKubernetesLogs = toResponsePromiseWithMeta<
  GetKubernetesLogsError,
  GetKubernetesLogsSuccess,
  GetKubernetesLogsParams
>(getKubernetesLogsFn);

export const getKubernetesLogsObservable = toResponseObservableWithMeta<
  GetKubernetesLogsError,
  GetKubernetesLogsSuccess,
  GetKubernetesLogsParams
>(getKubernetesLogsFn);

export interface GetKubernetesLogsAutocompleteParams {
  aFrom: number;
  to: number;
  podUID: string;
  cluster: string;
  topologyTime?: number;
}

export type GetKubernetesLogsAutocompleteSuccess = Api.GetKubernetesLogsAutocompleteResult;
export type GetKubernetesLogsAutocompleteError = HTTPError | Api.GetKubernetesLogsAutocompleteBadRequest | Api.GenericErrorsResponse;

/**
 * GetKubernetesLogsAutocompleteApi - functional programming interface
 * @export
 */
export const getKubernetesLogsAutocompleteFn = ({
  aFrom,
  to,
  podUID,
  cluster,
  topologyTime,
 }: GetKubernetesLogsAutocompleteParams, options: any = {}, configuration?: Configuration): Promise<GetKubernetesLogsAutocompleteSuccess> => {
  const localVarFetchArgs = KubernetesLogsApiFetchParamCreator(configuration).getKubernetesLogsAutocomplete(aFrom, to, podUID, cluster, topologyTime, options);
  return requestFetch<GetKubernetesLogsAutocompleteSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getKubernetesLogsAutocomplete = toResponsePromiseWithMeta<
  GetKubernetesLogsAutocompleteError,
  GetKubernetesLogsAutocompleteSuccess,
  GetKubernetesLogsAutocompleteParams
>(getKubernetesLogsAutocompleteFn);

export const getKubernetesLogsAutocompleteObservable = toResponseObservableWithMeta<
  GetKubernetesLogsAutocompleteError,
  GetKubernetesLogsAutocompleteSuccess,
  GetKubernetesLogsAutocompleteParams
>(getKubernetesLogsAutocompleteFn);

export interface GetKubernetesLogsHistogramParams {
  aFrom: number;
  to: number;
  query?: string;
  podUID: string;
  cluster: string;
  containerNames?: string[];
  bucketsCount: number;
  severity?: Api.LogSeverity[];
  topologyTime?: number;
}

export type GetKubernetesLogsHistogramSuccess = Api.GetKubernetesLogsHistogramResult;
export type GetKubernetesLogsHistogramError = HTTPError | Api.GetKubernetesLogsHistogramBadRequest | Api.GenericErrorsResponse;

/**
 * GetKubernetesLogsHistogramApi - functional programming interface
 * @export
 */
export const getKubernetesLogsHistogramFn = ({
  aFrom,
  to,
  query,
  podUID,
  cluster,
  containerNames,
  bucketsCount,
  severity,
  topologyTime,
 }: GetKubernetesLogsHistogramParams, options: any = {}, configuration?: Configuration): Promise<GetKubernetesLogsHistogramSuccess> => {
  const localVarFetchArgs = KubernetesLogsApiFetchParamCreator(configuration).getKubernetesLogsHistogram(aFrom, to, query, podUID, cluster, containerNames, bucketsCount, severity, topologyTime, options);
  return requestFetch<GetKubernetesLogsHistogramSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getKubernetesLogsHistogram = toResponsePromiseWithMeta<
  GetKubernetesLogsHistogramError,
  GetKubernetesLogsHistogramSuccess,
  GetKubernetesLogsHistogramParams
>(getKubernetesLogsHistogramFn);

export const getKubernetesLogsHistogramObservable = toResponseObservableWithMeta<
  GetKubernetesLogsHistogramError,
  GetKubernetesLogsHistogramSuccess,
  GetKubernetesLogsHistogramParams
>(getKubernetesLogsHistogramFn);

/**
 * MainMenuApi - fetch parameter creator
 * @export
 */
export const MainMenuApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		getMainMenu(options: any = {}): FetchArgs {
			const localVarPath = `/main-menu`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* MainMenu
*/
export interface GetMainMenuParams {
}

export type GetMainMenuSuccess = Api.MainMenuGroup[];
export type GetMainMenuError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetMainMenuApi - functional programming interface
 * <p>Get Main Menu</p>
 * @export
 */
export const getMainMenuFn = ({
 }: GetMainMenuParams, options: any = {}, configuration?: Configuration): Promise<GetMainMenuSuccess> => {
  const localVarFetchArgs = MainMenuApiFetchParamCreator(configuration).getMainMenu(options);
  return requestFetch<GetMainMenuSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMainMenu = toResponsePromiseWithMeta<
  GetMainMenuError,
  GetMainMenuSuccess,
  GetMainMenuParams
>(getMainMenuFn);

export const getMainMenuObservable = toResponseObservableWithMeta<
  GetMainMenuError,
  GetMainMenuSuccess,
  GetMainMenuParams
>(getMainMenuFn);

/**
 * MetricApi - fetch parameter creator
 * @export
 */
export const MetricApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} query Prometheus expression query string
		 * @param {string} [start] Start timestamp in rfc3339 format or unix format
		 * @param {string} [end] End timestamp in rfc3339 format or unix format
		 * @param {*} [options] Override http request option.
		 */
		getExemplarsQuery(query: string, start: string | undefined, end: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/query_exemplars`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (query !== undefined) {
				localVarQueryParameter['query'] = query;
			}
			if (start !== undefined) {
				localVarQueryParameter['start'] = start;
			}
			if (end !== undefined) {
				localVarQueryParameter['end'] = end;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} query Prometheus expression query string
		 * @param {string} [time] Evaluation timestamp in rfc3339 format or unix format
		 * @param {string} [timeout] Evaluation timeout
		 * @param {string} [step] Query resolution step width in duration format or float number of seconds.
		 * @param {string[]} [postFilter] Enforce additional label filters for queries
		 * @param {*} [options] Override http request option.
		 */
		getInstantQuery(query: string, time: string | undefined, timeout: string | undefined, step: string | undefined, postFilter: string[] | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/query`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (query !== undefined) {
				localVarQueryParameter['query'] = query;
			}
			if (time !== undefined) {
				localVarQueryParameter['time'] = time;
			}
			if (timeout !== undefined) {
				localVarQueryParameter['timeout'] = timeout;
			}
			if (step !== undefined) {
				localVarQueryParameter['step'] = step;
			}
			if (postFilter !== undefined) {
				localVarQueryParameter['post_filter'] = postFilter;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} [start] Start timestamp in rfc3339 format or unix format
		 * @param {string} [end] End timestamp in rfc3339 format or unix format
		 * @param {string[]} [match] Repeated series selector argument that selects the series from which to read the label names. Optional.
		 * @param {*} [options] Override http request option.
		 */
		getLabels(start: string | undefined, end: string | undefined, match: string[] | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/labels`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (start !== undefined) {
				localVarQueryParameter['start'] = start;
			}
			if (end !== undefined) {
				localVarQueryParameter['end'] = end;
			}
			if (match !== undefined) {
				localVarQueryParameter['match[]'] = match;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} label Prometheus query label
		 * @param {string} [start] Start timestamp in rfc3339 format or unix format
		 * @param {string} [end] End timestamp in rfc3339 format or unix format
		 * @param {string[]} [match] Repeated series selector argument that selects the series from which to read the label names. Optional.
		 * @param {*} [options] Override http request option.
		 */
		getLabelValues(label: string, start: string | undefined, end: string | undefined, match: string[] | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/label/{label}/values`
				.replace('{label}', encodeURIComponent(String(label)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (start !== undefined) {
				localVarQueryParameter['start'] = start;
			}
			if (end !== undefined) {
				localVarQueryParameter['end'] = end;
			}
			if (match !== undefined) {
				localVarQueryParameter['match[]'] = match;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} [limit] Maximum number of metrics to return.
		 * @param {string} [metric] A metric name to filter metadata for. All metric metadata is retrieved if left empty.
		 * @param {*} [options] Override http request option.
		 */
		getMetadata(limit: number | undefined, metric: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/metadata`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			if (metric !== undefined) {
				localVarQueryParameter['metric'] = metric;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} query Prometheus expression query string
		 * @param {string} start Start timestamp in rfc3339 format or unix format
		 * @param {string} end End timestamp in rfc3339 format or unix format
		 * @param {string} step Query resolution step width in duration format or float number of seconds.
		 * @param {string} [timeout] Evaluation timeout
		 * @param {boolean} [aligned] Align start and end times with step size
		 * @param {number} [maxNumberOfDataPoints] Maximum number of data points to return.
		 * @param {string[]} [postFilter] Enforce additional label filters for queries
		 * @param {*} [options] Override http request option.
		 */
		getRangeQuery(query: string, start: string, end: string, step: string, timeout: string | undefined, aligned: boolean | undefined, maxNumberOfDataPoints: number | undefined, postFilter: string[] | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/query_range`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (query !== undefined) {
				localVarQueryParameter['query'] = query;
			}
			if (start !== undefined) {
				localVarQueryParameter['start'] = start;
			}
			if (end !== undefined) {
				localVarQueryParameter['end'] = end;
			}
			if (step !== undefined) {
				localVarQueryParameter['step'] = step;
			}
			if (timeout !== undefined) {
				localVarQueryParameter['timeout'] = timeout;
			}
			if (aligned !== undefined) {
				localVarQueryParameter['aligned'] = aligned;
			}
			if (maxNumberOfDataPoints !== undefined) {
				localVarQueryParameter['maxNumberOfDataPoints'] = maxNumberOfDataPoints;
			}
			if (postFilter !== undefined) {
				localVarQueryParameter['post_filter'] = postFilter;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string[]} match Repeated series selector argument that selects the series to return. At least one match[] argument must be provided.
		 * @param {string} [start] Start timestamp in rfc3339 format or unix format
		 * @param {string} [end] End timestamp in rfc3339 format or unix format
		 * @param {*} [options] Override http request option.
		 */
		getSeries(match: string[], start: string | undefined, end: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/series`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (match !== undefined) {
				localVarQueryParameter['match[]'] = match;
			}
			if (start !== undefined) {
				localVarQueryParameter['start'] = start;
			}
			if (end !== undefined) {
				localVarQueryParameter['end'] = end;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.PromQueryExemplarRequest} [request]
		 * @param {*} [options] Override http request option.
		 */
		postExemplarsQuery(request: Api.PromQueryExemplarRequest | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/query_exemplars`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			const localVarFormParams = new URLSearchParams();
			for (const localVarName in request) {
				if (localVarName !== undefined) {
					localVarFormParams.set(localVarName, (request as any)[localVarName]);
				}
			}
			localVarRequestOptions.body = localVarFormParams.toString();

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.PromQueryRequest} [request]
		 * @param {*} [options] Override http request option.
		 */
		postInstantQuery(request: Api.PromQueryRequest | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/query`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			const localVarFormParams = new URLSearchParams();
			for (const localVarName in request) {
				if (localVarName !== undefined) {
					localVarFormParams.set(localVarName, (request as any)[localVarName]);
				}
			}
			localVarRequestOptions.body = localVarFormParams.toString();

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.PromLabelsRequest} [request]
		 * @param {*} [options] Override http request option.
		 */
		postLabels(request: Api.PromLabelsRequest | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/labels`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			const localVarFormParams = new URLSearchParams();
			for (const localVarName in request) {
				if (localVarName !== undefined) {
					localVarFormParams.set(localVarName, (request as any)[localVarName]);
				}
			}
			localVarRequestOptions.body = localVarFormParams.toString();

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} label Prometheus query label
		 * @param {Api.PromLabelValuesRequest} [request]
		 * @param {*} [options] Override http request option.
		 */
		postLabelValues(label: string, request: Api.PromLabelValuesRequest | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/label/{label}/values`
				.replace('{label}', encodeURIComponent(String(label)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			const localVarFormParams = new URLSearchParams();
			for (const localVarName in request) {
				if (localVarName !== undefined) {
					localVarFormParams.set(localVarName, (request as any)[localVarName]);
				}
			}
			localVarRequestOptions.body = localVarFormParams.toString();

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.PromMetadataRequest} [request]
		 * @param {*} [options] Override http request option.
		 */
		postMetadata(request: Api.PromMetadataRequest | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/metadata`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			const localVarFormParams = new URLSearchParams();
			for (const localVarName in request) {
				if (localVarName !== undefined) {
					localVarFormParams.set(localVarName, (request as any)[localVarName]);
				}
			}
			localVarRequestOptions.body = localVarFormParams.toString();

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.PromBatchQueryRequest} request
		 * @param {*} [options] Override http request option.
		 */
		postQueryBatch(request: Api.PromBatchQueryRequest, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/query_batch`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.PromQueryRangeRequest} [request]
		 * @param {*} [options] Override http request option.
		 */
		postRangeQuery(request: Api.PromQueryRangeRequest | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/query_range`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			const localVarFormParams = new URLSearchParams();
			for (const localVarName in request) {
				if (localVarName !== undefined) {
					localVarFormParams.set(localVarName, (request as any)[localVarName]);
				}
			}
			localVarRequestOptions.body = localVarFormParams.toString();

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.PromSeriesRequest} [request]
		 * @param {*} [options] Override http request option.
		 */
		postSeries(request: Api.PromSeriesRequest | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/metrics/series`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			const localVarFormParams = new URLSearchParams();
			for (const localVarName in request) {
				if (localVarName !== undefined) {
					localVarFormParams.set(localVarName, (request as any)[localVarName]);
				}
			}
			localVarRequestOptions.body = localVarFormParams.toString();

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Metric
*/
export interface GetExemplarsQueryParams {
  query: string;
  start?: string;
  end?: string;
}

export type GetExemplarsQuerySuccess = Api.PromExemplarEnvelope;
export type GetExemplarsQueryError = HTTPError | Api.PromExemplarEnvelope | Api.PromExemplarEnvelope | Api.GenericErrorsResponse | Api.PromExemplarEnvelope;

/**
 * GetExemplarsQueryApi - functional programming interface
 * <p>Experimental: The returns a list of exemplars for a valid PromQL query for a specific time range</p>
 * @export
 */
export const getExemplarsQueryFn = ({
  query,
  start,
  end,
 }: GetExemplarsQueryParams, options: any = {}, configuration?: Configuration): Promise<GetExemplarsQuerySuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).getExemplarsQuery(query, start, end, options);
  return requestFetch<GetExemplarsQuerySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getExemplarsQuery = toResponsePromiseWithMeta<
  GetExemplarsQueryError,
  GetExemplarsQuerySuccess,
  GetExemplarsQueryParams
>(getExemplarsQueryFn);

export const getExemplarsQueryObservable = toResponseObservableWithMeta<
  GetExemplarsQueryError,
  GetExemplarsQuerySuccess,
  GetExemplarsQueryParams
>(getExemplarsQueryFn);

export interface GetInstantQueryParams {
  query: string;
  time?: string;
  timeout?: string;
  step?: string;
  postFilter?: string[];
}

export type GetInstantQuerySuccess = Api.PromEnvelope;
export type GetInstantQueryError = HTTPError | Api.PromEnvelope | Api.PromEnvelope | Api.GenericErrorsResponse | Api.PromEnvelope;

/**
 * GetInstantQueryApi - functional programming interface
 * <p>The endpoint evaluates an instant query at a single point in time</p>
 * @export
 */
export const getInstantQueryFn = ({
  query,
  time,
  timeout,
  step,
  postFilter,
 }: GetInstantQueryParams, options: any = {}, configuration?: Configuration): Promise<GetInstantQuerySuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).getInstantQuery(query, time, timeout, step, postFilter, options);
  return requestFetch<GetInstantQuerySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getInstantQuery = toResponsePromiseWithMeta<
  GetInstantQueryError,
  GetInstantQuerySuccess,
  GetInstantQueryParams
>(getInstantQueryFn);

export const getInstantQueryObservable = toResponseObservableWithMeta<
  GetInstantQueryError,
  GetInstantQuerySuccess,
  GetInstantQueryParams
>(getInstantQueryFn);

export interface GetLabelsParams {
  start?: string;
  end?: string;
  match?: string[];
}

export type GetLabelsSuccess = Api.PromLabelsEnvelope;
export type GetLabelsError = HTTPError | Api.PromLabelsEnvelope | Api.PromLabelsEnvelope | Api.GenericErrorsResponse | Api.PromLabelsEnvelope;

/**
 * GetLabelsApi - functional programming interface
 * <p>The endpoint returns a list of label names</p>
 * @export
 */
export const getLabelsFn = ({
  start,
  end,
  match,
 }: GetLabelsParams, options: any = {}, configuration?: Configuration): Promise<GetLabelsSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).getLabels(start, end, match, options);
  return requestFetch<GetLabelsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getLabels = toResponsePromiseWithMeta<
  GetLabelsError,
  GetLabelsSuccess,
  GetLabelsParams
>(getLabelsFn);

export const getLabelsObservable = toResponseObservableWithMeta<
  GetLabelsError,
  GetLabelsSuccess,
  GetLabelsParams
>(getLabelsFn);

export interface GetLabelValuesParams {
  label: string;
  start?: string;
  end?: string;
  match?: string[];
}

export type GetLabelValuesSuccess = Api.PromLabelsEnvelope;
export type GetLabelValuesError = HTTPError | Api.PromLabelsEnvelope | Api.PromLabelsEnvelope | Api.GenericErrorsResponse | Api.PromLabelsEnvelope;

/**
 * GetLabelValuesApi - functional programming interface
 * <p>The endpoint returns a list of label values for a provided label name</p>
 * @export
 */
export const getLabelValuesFn = ({
  label,
  start,
  end,
  match,
 }: GetLabelValuesParams, options: any = {}, configuration?: Configuration): Promise<GetLabelValuesSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).getLabelValues(label, start, end, match, options);
  return requestFetch<GetLabelValuesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getLabelValues = toResponsePromiseWithMeta<
  GetLabelValuesError,
  GetLabelValuesSuccess,
  GetLabelValuesParams
>(getLabelValuesFn);

export const getLabelValuesObservable = toResponseObservableWithMeta<
  GetLabelValuesError,
  GetLabelValuesSuccess,
  GetLabelValuesParams
>(getLabelValuesFn);

export interface GetMetadataParams {
  limit?: number;
  metric?: string;
}

export type GetMetadataSuccess = Api.PromMetadataEnvelope;
export type GetMetadataError = HTTPError | Api.PromMetadataEnvelope | Api.PromMetadataEnvelope | Api.GenericErrorsResponse | Api.PromMetadataEnvelope;

/**
 * GetMetadataApi - functional programming interface
 * <p>The endpoint returns metadata about metrics currently scraped from targets. However, it does not provide any target information. This is considered experimental and might change in the future</p>
 * @export
 */
export const getMetadataFn = ({
  limit,
  metric,
 }: GetMetadataParams, options: any = {}, configuration?: Configuration): Promise<GetMetadataSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).getMetadata(limit, metric, options);
  return requestFetch<GetMetadataSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMetadata = toResponsePromiseWithMeta<
  GetMetadataError,
  GetMetadataSuccess,
  GetMetadataParams
>(getMetadataFn);

export const getMetadataObservable = toResponseObservableWithMeta<
  GetMetadataError,
  GetMetadataSuccess,
  GetMetadataParams
>(getMetadataFn);

export interface GetRangeQueryParams {
  query: string;
  start: string;
  end: string;
  step: string;
  timeout?: string;
  aligned?: boolean;
  maxNumberOfDataPoints?: number;
  postFilter?: string[];
}

export type GetRangeQuerySuccess = Api.PromEnvelope;
export type GetRangeQueryError = HTTPError | Api.PromEnvelope | Api.PromEnvelope | Api.GenericErrorsResponse | Api.PromEnvelope;

/**
 * GetRangeQueryApi - functional programming interface
 * <p>The endpoint evaluates an expression query over a range of time</p>
 * @export
 */
export const getRangeQueryFn = ({
  query,
  start,
  end,
  step,
  timeout,
  aligned,
  maxNumberOfDataPoints,
  postFilter,
 }: GetRangeQueryParams, options: any = {}, configuration?: Configuration): Promise<GetRangeQuerySuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).getRangeQuery(query, start, end, step, timeout, aligned, maxNumberOfDataPoints, postFilter, options);
  return requestFetch<GetRangeQuerySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getRangeQuery = toResponsePromiseWithMeta<
  GetRangeQueryError,
  GetRangeQuerySuccess,
  GetRangeQueryParams
>(getRangeQueryFn);

export const getRangeQueryObservable = toResponseObservableWithMeta<
  GetRangeQueryError,
  GetRangeQuerySuccess,
  GetRangeQueryParams
>(getRangeQueryFn);

export interface GetSeriesParams {
  match: string[];
  start?: string;
  end?: string;
}

export type GetSeriesSuccess = Api.PromSeriesEnvelope;
export type GetSeriesError = HTTPError | Api.PromSeriesEnvelope | Api.PromSeriesEnvelope | Api.GenericErrorsResponse | Api.PromSeriesEnvelope;

/**
 * GetSeriesApi - functional programming interface
 * <p>The endpoint returns the list of time series that match a certain label set</p>
 * @export
 */
export const getSeriesFn = ({
  match,
  start,
  end,
 }: GetSeriesParams, options: any = {}, configuration?: Configuration): Promise<GetSeriesSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).getSeries(match, start, end, options);
  return requestFetch<GetSeriesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getSeries = toResponsePromiseWithMeta<
  GetSeriesError,
  GetSeriesSuccess,
  GetSeriesParams
>(getSeriesFn);

export const getSeriesObservable = toResponseObservableWithMeta<
  GetSeriesError,
  GetSeriesSuccess,
  GetSeriesParams
>(getSeriesFn);

export interface PostExemplarsQueryParams {
  body: Api.PromQueryExemplarRequest;
}

export type PostExemplarsQuerySuccess = Api.PromExemplarEnvelope;
export type PostExemplarsQueryError = HTTPError | Api.PromExemplarEnvelope | Api.PromExemplarEnvelope | Api.GenericErrorsResponse | Api.PromExemplarEnvelope;

/**
 * PostExemplarsQueryApi - functional programming interface
 * <p>Experimental: The returns a list of exemplars for a valid PromQL query for a specific time range</p>
 * @export
 */
export const postExemplarsQueryFn = ({
 body,
 }: PostExemplarsQueryParams, options: any = {}, configuration?: Configuration): Promise<PostExemplarsQuerySuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postExemplarsQuery(body, options);
  return requestFetch<PostExemplarsQuerySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postExemplarsQuery = toResponsePromiseWithMeta<
  PostExemplarsQueryError,
  PostExemplarsQuerySuccess,
  PostExemplarsQueryParams
>(postExemplarsQueryFn);

export const postExemplarsQueryObservable = toResponseObservableWithMeta<
  PostExemplarsQueryError,
  PostExemplarsQuerySuccess,
  PostExemplarsQueryParams
>(postExemplarsQueryFn);

export interface PostInstantQueryParams {
  body: Api.PromQueryRequest;
}

export type PostInstantQuerySuccess = Api.PromEnvelope;
export type PostInstantQueryError = HTTPError | Api.PromEnvelope | Api.PromEnvelope | Api.GenericErrorsResponse | Api.PromEnvelope;

/**
 * PostInstantQueryApi - functional programming interface
 * <p>The endpoint evaluates an instant query at a single point in time</p>
 * @export
 */
export const postInstantQueryFn = ({
 body,
 }: PostInstantQueryParams, options: any = {}, configuration?: Configuration): Promise<PostInstantQuerySuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postInstantQuery(body, options);
  return requestFetch<PostInstantQuerySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postInstantQuery = toResponsePromiseWithMeta<
  PostInstantQueryError,
  PostInstantQuerySuccess,
  PostInstantQueryParams
>(postInstantQueryFn);

export const postInstantQueryObservable = toResponseObservableWithMeta<
  PostInstantQueryError,
  PostInstantQuerySuccess,
  PostInstantQueryParams
>(postInstantQueryFn);

export interface PostLabelsParams {
  body: Api.PromLabelsRequest;
}

export type PostLabelsSuccess = Api.PromLabelsEnvelope;
export type PostLabelsError = HTTPError | Api.PromLabelsEnvelope | Api.PromLabelsEnvelope | Api.GenericErrorsResponse | Api.PromLabelsEnvelope;

/**
 * PostLabelsApi - functional programming interface
 * <p>The endpoint returns a list of label names</p>
 * @export
 */
export const postLabelsFn = ({
 body,
 }: PostLabelsParams, options: any = {}, configuration?: Configuration): Promise<PostLabelsSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postLabels(body, options);
  return requestFetch<PostLabelsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postLabels = toResponsePromiseWithMeta<
  PostLabelsError,
  PostLabelsSuccess,
  PostLabelsParams
>(postLabelsFn);

export const postLabelsObservable = toResponseObservableWithMeta<
  PostLabelsError,
  PostLabelsSuccess,
  PostLabelsParams
>(postLabelsFn);

export interface PostLabelValuesParams {
  label: string;
  body: Api.PromLabelValuesRequest;
}

export type PostLabelValuesSuccess = Api.PromLabelsEnvelope;
export type PostLabelValuesError = HTTPError | Api.PromLabelsEnvelope | Api.PromLabelsEnvelope | Api.GenericErrorsResponse | Api.PromLabelsEnvelope;

/**
 * PostLabelValuesApi - functional programming interface
 * <p>The endpoint returns a list of label values for a provided label name</p>
 * @export
 */
export const postLabelValuesFn = ({
  label,
 body,
 }: PostLabelValuesParams, options: any = {}, configuration?: Configuration): Promise<PostLabelValuesSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postLabelValues(label, body, options);
  return requestFetch<PostLabelValuesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postLabelValues = toResponsePromiseWithMeta<
  PostLabelValuesError,
  PostLabelValuesSuccess,
  PostLabelValuesParams
>(postLabelValuesFn);

export const postLabelValuesObservable = toResponseObservableWithMeta<
  PostLabelValuesError,
  PostLabelValuesSuccess,
  PostLabelValuesParams
>(postLabelValuesFn);

export interface PostMetadataParams {
  body: Api.PromMetadataRequest;
}

export type PostMetadataSuccess = Api.PromMetadataEnvelope;
export type PostMetadataError = HTTPError | Api.PromMetadataEnvelope | Api.PromMetadataEnvelope | Api.GenericErrorsResponse | Api.PromMetadataEnvelope;

/**
 * PostMetadataApi - functional programming interface
 * <p>The endpoint returns metadata about metrics currently scraped from targets. However, it does not provide any target information. This is considered experimental and might change in the future</p>
 * @export
 */
export const postMetadataFn = ({
 body,
 }: PostMetadataParams, options: any = {}, configuration?: Configuration): Promise<PostMetadataSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postMetadata(body, options);
  return requestFetch<PostMetadataSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postMetadata = toResponsePromiseWithMeta<
  PostMetadataError,
  PostMetadataSuccess,
  PostMetadataParams
>(postMetadataFn);

export const postMetadataObservable = toResponseObservableWithMeta<
  PostMetadataError,
  PostMetadataSuccess,
  PostMetadataParams
>(postMetadataFn);

export interface PostQueryBatchParams {
  body: Api.PromBatchQueryRequest;
}

export type PostQueryBatchSuccess = Api.PromBatchEnvelope;
export type PostQueryBatchError = HTTPError | Api.PromEnvelope | Api.GenericErrorsResponse | Api.PromEnvelope;

/**
 * PostQueryBatchApi - functional programming interface
 * <p>Executes multiple PromQL queries in a single request to reduce HTTP overhead. Each query is executed independently and results are returned in a single response. Partial failures are supported: individual queries may fail while others succeed.</p>
 * @export
 */
export const postQueryBatchFn = ({
 body,
 }: PostQueryBatchParams, options: any = {}, configuration?: Configuration): Promise<PostQueryBatchSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postQueryBatch(body, options);
  return requestFetch<PostQueryBatchSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postQueryBatch = toResponsePromiseWithMeta<
  PostQueryBatchError,
  PostQueryBatchSuccess,
  PostQueryBatchParams
>(postQueryBatchFn);

export const postQueryBatchObservable = toResponseObservableWithMeta<
  PostQueryBatchError,
  PostQueryBatchSuccess,
  PostQueryBatchParams
>(postQueryBatchFn);

export interface PostRangeQueryParams {
  body: Api.PromQueryRangeRequest;
}

export type PostRangeQuerySuccess = Api.PromEnvelope;
export type PostRangeQueryError = HTTPError | Api.PromEnvelope | Api.PromEnvelope | Api.GenericErrorsResponse | Api.PromEnvelope;

/**
 * PostRangeQueryApi - functional programming interface
 * <p>The endpoint evaluates an expression query over a range of time</p>
 * @export
 */
export const postRangeQueryFn = ({
 body,
 }: PostRangeQueryParams, options: any = {}, configuration?: Configuration): Promise<PostRangeQuerySuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postRangeQuery(body, options);
  return requestFetch<PostRangeQuerySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postRangeQuery = toResponsePromiseWithMeta<
  PostRangeQueryError,
  PostRangeQuerySuccess,
  PostRangeQueryParams
>(postRangeQueryFn);

export const postRangeQueryObservable = toResponseObservableWithMeta<
  PostRangeQueryError,
  PostRangeQuerySuccess,
  PostRangeQueryParams
>(postRangeQueryFn);

export interface PostSeriesParams {
  body: Api.PromSeriesRequest;
}

export type PostSeriesSuccess = Api.PromSeriesEnvelope;
export type PostSeriesError = HTTPError | Api.PromSeriesEnvelope | Api.PromSeriesEnvelope | Api.GenericErrorsResponse | Api.PromSeriesEnvelope;

/**
 * PostSeriesApi - functional programming interface
 * <p>The endpoint returns the list of time series that match a certain label set</p>
 * @export
 */
export const postSeriesFn = ({
 body,
 }: PostSeriesParams, options: any = {}, configuration?: Configuration): Promise<PostSeriesSuccess> => {
  const localVarFetchArgs = MetricApiFetchParamCreator(configuration).postSeries(body, options);
  return requestFetch<PostSeriesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postSeries = toResponsePromiseWithMeta<
  PostSeriesError,
  PostSeriesSuccess,
  PostSeriesParams
>(postSeriesFn);

export const postSeriesObservable = toResponseObservableWithMeta<
  PostSeriesError,
  PostSeriesSuccess,
  PostSeriesParams
>(postSeriesFn);

/**
 * MonitorApi - fetch parameter creator
 * @export
 */
export const MonitorApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {*} [options] Override http request option.
		 */
		deleteMonitor(monitorIdOrUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getAllMonitors(options: any = {}): FetchArgs {
			const localVarPath = `/monitors`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {*} [options] Override http request option.
		 */
		getMonitor(monitorIdOrUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {Api.HealthStateValue} [healthState] Health state of check states
		 * @param {number} [limit]
		 * @param {number} [timestamp]
		 * @param {*} [options] Override http request option.
		 */
		getMonitorCheckStates(monitorIdOrUrn: string, healthState: Api.HealthStateValue | undefined, limit: number | undefined, timestamp: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}/checkStates`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (healthState !== undefined) {
				localVarQueryParameter['healthState'] = healthState;
			}
			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			if (timestamp !== undefined) {
				localVarQueryParameter['timestamp'] = timestamp;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getMonitorsOverview(options: any = {}): FetchArgs {
			const localVarPath = `/monitors/overview`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {number} [timestamp]
		 * @param {*} [options] Override http request option.
		 */
		getMonitorWithStatus(monitorIdOrUrn: string, timestamp: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}/status`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (timestamp !== undefined) {
				localVarQueryParameter['timestamp'] = timestamp;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.MonitorIdentifierLookup} request Component type and metric query for identifier lookup
		 * @param {*} [options] Override http request option.
		 */
		lookupIdentifier(request: Api.MonitorIdentifierLookup, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/identifierLookup`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {Api.MonitorPatch} request Monitor base properties
		 * @param {*} [options] Override http request option.
		 */
		patchMonitor(monitorIdOrUrn: string, request: Api.MonitorPatch, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {Api.MonitorPreview} request Monitor overrides in order to run a preview
		 * @param {*} [options] Override http request option.
		 */
		previewMonitor(monitorIdOrUrn: string, request: Api.MonitorPreview, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}/preview`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {Api.HealthStateValue} [healthState] Health state of check states
		 * @param {number} [limit]
		 * @param {Api.MonitorPreview} request Monitor overrides in order to run a preview
		 * @param {*} [options] Override http request option.
		 */
		previewMonitorCheckStates(monitorIdOrUrn: string, healthState: Api.HealthStateValue | undefined, limit: number | undefined, request: Api.MonitorPreview, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}/preview/checkStates`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (healthState !== undefined) {
				localVarQueryParameter['healthState'] = healthState;
			}
			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {Api.MonitorSnapshot} request Monitor snapshot of health states
		 * @param {*} [options] Override http request option.
		 */
		publishHealthStates(monitorIdOrUrn: string, request: Api.MonitorSnapshot, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}/publish`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorIdOrUrn The id or identifier (urn) of a monitor
		 * @param {boolean} [dryRun] If set, the topology state will not be modified
		 * @param {*} [options] Override http request option.
		 */
		runMonitor(monitorIdOrUrn: string, dryRun: boolean | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorIdOrUrn}/run`
				.replace('{monitorIdOrUrn}', encodeURIComponent(String(monitorIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (dryRun !== undefined) {
				localVarQueryParameter['dryRun'] = dryRun;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorFunctionIdOrUrn The id or identifier (urn) of a monitor function
		 * @param {Api.MonitorFunctionTest} request Monitor function arguments to test
		 * @param {*} [options] Override http request option.
		 */
		testMonitorFunction(monitorFunctionIdOrUrn: string, request: Api.MonitorFunctionTest, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorFunctionIdOrUrn}/test`
				.replace('{monitorFunctionIdOrUrn}', encodeURIComponent(String(monitorFunctionIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} monitorFunctionIdOrUrn The id or identifier (urn) of a monitor function
		 * @param {Api.HealthStateValue} [healthState] Health state of check states
		 * @param {number} [limit]
		 * @param {Api.MonitorFunctionTest} request Monitor function arguments to test
		 * @param {*} [options] Override http request option.
		 */
		testMonitorFunctionCheckStates(monitorFunctionIdOrUrn: string, healthState: Api.HealthStateValue | undefined, limit: number | undefined, request: Api.MonitorFunctionTest, options: any = {}): FetchArgs {
			const localVarPath = `/monitors/{monitorFunctionIdOrUrn}/test/checkStates`
				.replace('{monitorFunctionIdOrUrn}', encodeURIComponent(String(monitorFunctionIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (healthState !== undefined) {
				localVarQueryParameter['healthState'] = healthState;
			}
			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Monitor
*/
export interface DeleteMonitorParams {
  monitorIdOrUrn: string;
}

export type DeleteMonitorSuccess = void;
export type DeleteMonitorError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * DeleteMonitorApi - functional programming interface
 * <p>Deletes existing monitor</p>
 * @export
 */
export const deleteMonitorFn = ({
  monitorIdOrUrn,
 }: DeleteMonitorParams, options: any = {}, configuration?: Configuration): Promise<DeleteMonitorSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).deleteMonitor(monitorIdOrUrn, options);
  return requestFetch<DeleteMonitorSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteMonitor = toResponsePromiseWithMeta<
  DeleteMonitorError,
  DeleteMonitorSuccess,
  DeleteMonitorParams
>(deleteMonitorFn);

export const deleteMonitorObservable = toResponseObservableWithMeta<
  DeleteMonitorError,
  DeleteMonitorSuccess,
  DeleteMonitorParams
>(deleteMonitorFn);

export interface GetAllMonitorsParams {
}

export type GetAllMonitorsSuccess = Api.MonitorList;
export type GetAllMonitorsError = HTTPError | Api.MonitorApiError;

/**
 * GetAllMonitorsApi - functional programming interface
 * <p>List all available monitor in the system</p>
 * @export
 */
export const getAllMonitorsFn = ({
 }: GetAllMonitorsParams, options: any = {}, configuration?: Configuration): Promise<GetAllMonitorsSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).getAllMonitors(options);
  return requestFetch<GetAllMonitorsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getAllMonitors = toResponsePromiseWithMeta<
  GetAllMonitorsError,
  GetAllMonitorsSuccess,
  GetAllMonitorsParams
>(getAllMonitorsFn);

export const getAllMonitorsObservable = toResponseObservableWithMeta<
  GetAllMonitorsError,
  GetAllMonitorsSuccess,
  GetAllMonitorsParams
>(getAllMonitorsFn);

export interface GetMonitorParams {
  monitorIdOrUrn: string;
}

export type GetMonitorSuccess = Api.Monitor;
export type GetMonitorError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * GetMonitorApi - functional programming interface
 * <p>Returns a monitor full representation</p>
 * @export
 */
export const getMonitorFn = ({
  monitorIdOrUrn,
 }: GetMonitorParams, options: any = {}, configuration?: Configuration): Promise<GetMonitorSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).getMonitor(monitorIdOrUrn, options);
  return requestFetch<GetMonitorSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMonitor = toResponsePromiseWithMeta<
  GetMonitorError,
  GetMonitorSuccess,
  GetMonitorParams
>(getMonitorFn);

export const getMonitorObservable = toResponseObservableWithMeta<
  GetMonitorError,
  GetMonitorSuccess,
  GetMonitorParams
>(getMonitorFn);

export interface GetMonitorCheckStatesParams {
  monitorIdOrUrn: string;
  healthState?: Api.HealthStateValue;
  limit?: number;
  timestamp?: number;
}

export type GetMonitorCheckStatesSuccess = Api.MonitorCheckStates;
export type GetMonitorCheckStatesError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * GetMonitorCheckStatesApi - functional programming interface
 * <p>Returns the checkstates that a monitor generated</p>
 * @export
 */
export const getMonitorCheckStatesFn = ({
  monitorIdOrUrn,
  healthState,
  limit,
  timestamp,
 }: GetMonitorCheckStatesParams, options: any = {}, configuration?: Configuration): Promise<GetMonitorCheckStatesSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).getMonitorCheckStates(monitorIdOrUrn, healthState, limit, timestamp, options);
  return requestFetch<GetMonitorCheckStatesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMonitorCheckStates = toResponsePromiseWithMeta<
  GetMonitorCheckStatesError,
  GetMonitorCheckStatesSuccess,
  GetMonitorCheckStatesParams
>(getMonitorCheckStatesFn);

export const getMonitorCheckStatesObservable = toResponseObservableWithMeta<
  GetMonitorCheckStatesError,
  GetMonitorCheckStatesSuccess,
  GetMonitorCheckStatesParams
>(getMonitorCheckStatesFn);

export interface GetMonitorsOverviewParams {
}

export type GetMonitorsOverviewSuccess = Api.MonitorOverviewList;
export type GetMonitorsOverviewError = HTTPError | Api.MonitorApiError;

/**
 * GetMonitorsOverviewApi - functional programming interface
 * <p>List all available monitor in the system with their function and runtime data</p>
 * @export
 */
export const getMonitorsOverviewFn = ({
 }: GetMonitorsOverviewParams, options: any = {}, configuration?: Configuration): Promise<GetMonitorsOverviewSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).getMonitorsOverview(options);
  return requestFetch<GetMonitorsOverviewSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMonitorsOverview = toResponsePromiseWithMeta<
  GetMonitorsOverviewError,
  GetMonitorsOverviewSuccess,
  GetMonitorsOverviewParams
>(getMonitorsOverviewFn);

export const getMonitorsOverviewObservable = toResponseObservableWithMeta<
  GetMonitorsOverviewError,
  GetMonitorsOverviewSuccess,
  GetMonitorsOverviewParams
>(getMonitorsOverviewFn);

export interface GetMonitorWithStatusParams {
  monitorIdOrUrn: string;
  timestamp?: number;
}

export type GetMonitorWithStatusSuccess = Api.MonitorStatus;
export type GetMonitorWithStatusError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * GetMonitorWithStatusApi - functional programming interface
 * <p>Returns a monitor full representation with the stream status information</p>
 * @export
 */
export const getMonitorWithStatusFn = ({
  monitorIdOrUrn,
  timestamp,
 }: GetMonitorWithStatusParams, options: any = {}, configuration?: Configuration): Promise<GetMonitorWithStatusSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).getMonitorWithStatus(monitorIdOrUrn, timestamp, options);
  return requestFetch<GetMonitorWithStatusSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMonitorWithStatus = toResponsePromiseWithMeta<
  GetMonitorWithStatusError,
  GetMonitorWithStatusSuccess,
  GetMonitorWithStatusParams
>(getMonitorWithStatusFn);

export const getMonitorWithStatusObservable = toResponseObservableWithMeta<
  GetMonitorWithStatusError,
  GetMonitorWithStatusSuccess,
  GetMonitorWithStatusParams
>(getMonitorWithStatusFn);

export interface LookupIdentifierParams {
  body: Api.MonitorIdentifierLookup;
}

export type LookupIdentifierSuccess = Api.MonitorIdentifierSuggestions;
export type LookupIdentifierError = HTTPError | Api.MonitorApiError | Api.MonitorApiError;

/**
 * LookupIdentifierApi - functional programming interface
 * <p>Find identifier templates using a component type and a metrics query</p>
 * @export
 */
export const lookupIdentifierFn = ({
 body,
 }: LookupIdentifierParams, options: any = {}, configuration?: Configuration): Promise<LookupIdentifierSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).lookupIdentifier(body, options);
  return requestFetch<LookupIdentifierSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const lookupIdentifier = toResponsePromiseWithMeta<
  LookupIdentifierError,
  LookupIdentifierSuccess,
  LookupIdentifierParams
>(lookupIdentifierFn);

export const lookupIdentifierObservable = toResponseObservableWithMeta<
  LookupIdentifierError,
  LookupIdentifierSuccess,
  LookupIdentifierParams
>(lookupIdentifierFn);

export interface PatchMonitorParams {
  monitorIdOrUrn: string;
  body: Api.MonitorPatch;
}

export type PatchMonitorSuccess = Api.Monitor;
export type PatchMonitorError = HTTPError | Api.MonitorValidationError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * PatchMonitorApi - functional programming interface
 * <p>Performs a patch on the monitor base properties.</p>
 * @export
 */
export const patchMonitorFn = ({
  monitorIdOrUrn,
 body,
 }: PatchMonitorParams, options: any = {}, configuration?: Configuration): Promise<PatchMonitorSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).patchMonitor(monitorIdOrUrn, body, options);
  return requestFetch<PatchMonitorSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const patchMonitor = toResponsePromiseWithMeta<
  PatchMonitorError,
  PatchMonitorSuccess,
  PatchMonitorParams
>(patchMonitorFn);

export const patchMonitorObservable = toResponseObservableWithMeta<
  PatchMonitorError,
  PatchMonitorSuccess,
  PatchMonitorParams
>(patchMonitorFn);

export interface PreviewMonitorParams {
  monitorIdOrUrn: string;
  body: Api.MonitorPreview;
}

export type PreviewMonitorSuccess = Api.MonitorPreviewResult;
export type PreviewMonitorError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * PreviewMonitorApi - functional programming interface
 * <p>Performs a run of a monitor allowing to test it with new arguments and delivers a summary of the health states produced</p>
 * @export
 */
export const previewMonitorFn = ({
  monitorIdOrUrn,
 body,
 }: PreviewMonitorParams, options: any = {}, configuration?: Configuration): Promise<PreviewMonitorSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).previewMonitor(monitorIdOrUrn, body, options);
  return requestFetch<PreviewMonitorSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const previewMonitor = toResponsePromiseWithMeta<
  PreviewMonitorError,
  PreviewMonitorSuccess,
  PreviewMonitorParams
>(previewMonitorFn);

export const previewMonitorObservable = toResponseObservableWithMeta<
  PreviewMonitorError,
  PreviewMonitorSuccess,
  PreviewMonitorParams
>(previewMonitorFn);

export interface PreviewMonitorCheckStatesParams {
  monitorIdOrUrn: string;
  healthState?: Api.HealthStateValue;
  limit?: number;
  body: Api.MonitorPreview;
}

export type PreviewMonitorCheckStatesSuccess = Api.MonitorCheckStates;
export type PreviewMonitorCheckStatesError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * PreviewMonitorCheckStatesApi - functional programming interface
 * <p>Performs a run of a monitor allowing to test it with new arguments and returns the health states produced</p>
 * @export
 */
export const previewMonitorCheckStatesFn = ({
  monitorIdOrUrn,
  healthState,
  limit,
 body,
 }: PreviewMonitorCheckStatesParams, options: any = {}, configuration?: Configuration): Promise<PreviewMonitorCheckStatesSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).previewMonitorCheckStates(monitorIdOrUrn, healthState, limit, body, options);
  return requestFetch<PreviewMonitorCheckStatesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const previewMonitorCheckStates = toResponsePromiseWithMeta<
  PreviewMonitorCheckStatesError,
  PreviewMonitorCheckStatesSuccess,
  PreviewMonitorCheckStatesParams
>(previewMonitorCheckStatesFn);

export const previewMonitorCheckStatesObservable = toResponseObservableWithMeta<
  PreviewMonitorCheckStatesError,
  PreviewMonitorCheckStatesSuccess,
  PreviewMonitorCheckStatesParams
>(previewMonitorCheckStatesFn);

export interface PublishHealthStatesParams {
  monitorIdOrUrn: string;
  body: Api.MonitorSnapshot;
}

export type PublishHealthStatesSuccess = void;
export type PublishHealthStatesError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * PublishHealthStatesApi - functional programming interface
 * <p>Publish health states for monitor</p>
 * @export
 */
export const publishHealthStatesFn = ({
  monitorIdOrUrn,
 body,
 }: PublishHealthStatesParams, options: any = {}, configuration?: Configuration): Promise<PublishHealthStatesSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).publishHealthStates(monitorIdOrUrn, body, options);
  return requestFetch<PublishHealthStatesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const publishHealthStates = toResponsePromiseWithMeta<
  PublishHealthStatesError,
  PublishHealthStatesSuccess,
  PublishHealthStatesParams
>(publishHealthStatesFn);

export const publishHealthStatesObservable = toResponseObservableWithMeta<
  PublishHealthStatesError,
  PublishHealthStatesSuccess,
  PublishHealthStatesParams
>(publishHealthStatesFn);

export interface RunMonitorParams {
  monitorIdOrUrn: string;
  dryRun?: boolean;
}

export type RunMonitorSuccess = Api.MonitorRunResult;
export type RunMonitorError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorNotFoundError | Api.MonitorApiError;

/**
 * RunMonitorApi - functional programming interface
 * <p>Performs a run of a monitor. If &#39;dryRun&#39; is set, topology state will not be modified.</p>
 * @export
 */
export const runMonitorFn = ({
  monitorIdOrUrn,
  dryRun,
 }: RunMonitorParams, options: any = {}, configuration?: Configuration): Promise<RunMonitorSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).runMonitor(monitorIdOrUrn, dryRun, options);
  return requestFetch<RunMonitorSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const runMonitor = toResponsePromiseWithMeta<
  RunMonitorError,
  RunMonitorSuccess,
  RunMonitorParams
>(runMonitorFn);

export const runMonitorObservable = toResponseObservableWithMeta<
  RunMonitorError,
  RunMonitorSuccess,
  RunMonitorParams
>(runMonitorFn);

export interface TestMonitorFunctionParams {
  monitorFunctionIdOrUrn: string;
  body: Api.MonitorFunctionTest;
}

export type TestMonitorFunctionSuccess = Api.MonitorPreviewResult;
export type TestMonitorFunctionError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorFunctionNotFoundError | Api.MonitorApiError;

/**
 * TestMonitorFunctionApi - functional programming interface
 * <p>Performs a run of a monitor function to test arguments and delivers a summary of the health states produced</p>
 * @export
 */
export const testMonitorFunctionFn = ({
  monitorFunctionIdOrUrn,
 body,
 }: TestMonitorFunctionParams, options: any = {}, configuration?: Configuration): Promise<TestMonitorFunctionSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).testMonitorFunction(monitorFunctionIdOrUrn, body, options);
  return requestFetch<TestMonitorFunctionSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const testMonitorFunction = toResponsePromiseWithMeta<
  TestMonitorFunctionError,
  TestMonitorFunctionSuccess,
  TestMonitorFunctionParams
>(testMonitorFunctionFn);

export const testMonitorFunctionObservable = toResponseObservableWithMeta<
  TestMonitorFunctionError,
  TestMonitorFunctionSuccess,
  TestMonitorFunctionParams
>(testMonitorFunctionFn);

export interface TestMonitorFunctionCheckStatesParams {
  monitorFunctionIdOrUrn: string;
  healthState?: Api.HealthStateValue;
  limit?: number;
  body: Api.MonitorFunctionTest;
}

export type TestMonitorFunctionCheckStatesSuccess = Api.MonitorCheckStates;
export type TestMonitorFunctionCheckStatesError = HTTPError | Api.InvalidMonitorIdentifierError | Api.MonitorFunctionNotFoundError | Api.MonitorApiError;

/**
 * TestMonitorFunctionCheckStatesApi - functional programming interface
 * <p>Performs a run of a monitor function to test arguments and returns the health states produced</p>
 * @export
 */
export const testMonitorFunctionCheckStatesFn = ({
  monitorFunctionIdOrUrn,
  healthState,
  limit,
 body,
 }: TestMonitorFunctionCheckStatesParams, options: any = {}, configuration?: Configuration): Promise<TestMonitorFunctionCheckStatesSuccess> => {
  const localVarFetchArgs = MonitorApiFetchParamCreator(configuration).testMonitorFunctionCheckStates(monitorFunctionIdOrUrn, healthState, limit, body, options);
  return requestFetch<TestMonitorFunctionCheckStatesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const testMonitorFunctionCheckStates = toResponsePromiseWithMeta<
  TestMonitorFunctionCheckStatesError,
  TestMonitorFunctionCheckStatesSuccess,
  TestMonitorFunctionCheckStatesParams
>(testMonitorFunctionCheckStatesFn);

export const testMonitorFunctionCheckStatesObservable = toResponseObservableWithMeta<
  TestMonitorFunctionCheckStatesError,
  TestMonitorFunctionCheckStatesSuccess,
  TestMonitorFunctionCheckStatesParams
>(testMonitorFunctionCheckStatesFn);

/**
 * MonitorCheckStatusApi - fetch parameter creator
 * @export
 */
export const MonitorCheckStatusApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} identifier The id of a monitor check status
		 * @param {number} [topologyTime] A timestamp at which resources will be queried. If not given the resources are queried at current time.
		 * @param {*} [options] Override http request option.
		 */
		getMonitorCheckStatus(identifier: string, topologyTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/monitor/checkStatus/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier The id of a monitor check status
		 * @param {number} startTime The start time of a time range to query resources.
		 * @param {number} [endTime] The end time of a time range to query resources. If not given the endTime is set to current time.
		 * @param {*} [options] Override http request option.
		 */
		getMonitorCheckStatusHealthHistory(identifier: string, startTime: number, endTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/monitor/checkStatus/{identifier}/healthHistory`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (startTime !== undefined) {
				localVarQueryParameter['startTime'] = startTime;
			}
			if (endTime !== undefined) {
				localVarQueryParameter['endTime'] = endTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier The id of a monitor check status
		 * @param {number} [topologyTime] A timestamp at which resources will be queried. If not given the resources are queried at current time.
		 * @param {*} [options] Override http request option.
		 */
		getMonitorCheckStatusRelatedFailures(identifier: string, topologyTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/monitor/checkStatus/{identifier}/relatedFailures`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* MonitorCheckStatus
*/
export interface GetMonitorCheckStatusParams {
  identifier: string;
  topologyTime?: number;
}

export type GetMonitorCheckStatusSuccess = Api.MonitorCheckStatus;
export type GetMonitorCheckStatusError = HTTPError | Api.MonitorCheckStatusApiError | Api.MonitorCheckStatusNotFoundError | Api.MonitorCheckStatusApiError;

/**
 * GetMonitorCheckStatusApi - functional programming interface
 * <p>Get a monitor check status by check state id</p>
 * @export
 */
export const getMonitorCheckStatusFn = ({
  identifier,
  topologyTime,
 }: GetMonitorCheckStatusParams, options: any = {}, configuration?: Configuration): Promise<GetMonitorCheckStatusSuccess> => {
  const localVarFetchArgs = MonitorCheckStatusApiFetchParamCreator(configuration).getMonitorCheckStatus(identifier, topologyTime, options);
  return requestFetch<GetMonitorCheckStatusSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMonitorCheckStatus = toResponsePromiseWithMeta<
  GetMonitorCheckStatusError,
  GetMonitorCheckStatusSuccess,
  GetMonitorCheckStatusParams
>(getMonitorCheckStatusFn);

export const getMonitorCheckStatusObservable = toResponseObservableWithMeta<
  GetMonitorCheckStatusError,
  GetMonitorCheckStatusSuccess,
  GetMonitorCheckStatusParams
>(getMonitorCheckStatusFn);

export interface GetMonitorCheckStatusHealthHistoryParams {
  identifier: string;
  startTime: number;
  endTime?: number;
}

export type GetMonitorCheckStatusHealthHistorySuccess = Api.MonitorCheckStatusHealthHistory;
export type GetMonitorCheckStatusHealthHistoryError = HTTPError | Api.MonitorCheckStatusApiError | Api.MonitorCheckStatusApiError;

/**
 * GetMonitorCheckStatusHealthHistoryApi - functional programming interface
 * <p>Get a monitor check status health history for a defined period of time by the check state id</p>
 * @export
 */
export const getMonitorCheckStatusHealthHistoryFn = ({
  identifier,
  startTime,
  endTime,
 }: GetMonitorCheckStatusHealthHistoryParams, options: any = {}, configuration?: Configuration): Promise<GetMonitorCheckStatusHealthHistorySuccess> => {
  const localVarFetchArgs = MonitorCheckStatusApiFetchParamCreator(configuration).getMonitorCheckStatusHealthHistory(identifier, startTime, endTime, options);
  return requestFetch<GetMonitorCheckStatusHealthHistorySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMonitorCheckStatusHealthHistory = toResponsePromiseWithMeta<
  GetMonitorCheckStatusHealthHistoryError,
  GetMonitorCheckStatusHealthHistorySuccess,
  GetMonitorCheckStatusHealthHistoryParams
>(getMonitorCheckStatusHealthHistoryFn);

export const getMonitorCheckStatusHealthHistoryObservable = toResponseObservableWithMeta<
  GetMonitorCheckStatusHealthHistoryError,
  GetMonitorCheckStatusHealthHistorySuccess,
  GetMonitorCheckStatusHealthHistoryParams
>(getMonitorCheckStatusHealthHistoryFn);

export interface GetMonitorCheckStatusRelatedFailuresParams {
  identifier: string;
  topologyTime?: number;
}

export type GetMonitorCheckStatusRelatedFailuresSuccess = Api.MonitorCheckStatusRelatedFailures;
export type GetMonitorCheckStatusRelatedFailuresError = HTTPError | Api.MonitorCheckStatusApiError | Api.MonitorCheckStatusNotFoundError | Api.MonitorCheckStatusApiError;

/**
 * GetMonitorCheckStatusRelatedFailuresApi - functional programming interface
 * <p>Get a monitor check status related failures by the check state id</p>
 * @export
 */
export const getMonitorCheckStatusRelatedFailuresFn = ({
  identifier,
  topologyTime,
 }: GetMonitorCheckStatusRelatedFailuresParams, options: any = {}, configuration?: Configuration): Promise<GetMonitorCheckStatusRelatedFailuresSuccess> => {
  const localVarFetchArgs = MonitorCheckStatusApiFetchParamCreator(configuration).getMonitorCheckStatusRelatedFailures(identifier, topologyTime, options);
  return requestFetch<GetMonitorCheckStatusRelatedFailuresSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getMonitorCheckStatusRelatedFailures = toResponsePromiseWithMeta<
  GetMonitorCheckStatusRelatedFailuresError,
  GetMonitorCheckStatusRelatedFailuresSuccess,
  GetMonitorCheckStatusRelatedFailuresParams
>(getMonitorCheckStatusRelatedFailuresFn);

export const getMonitorCheckStatusRelatedFailuresObservable = toResponseObservableWithMeta<
  GetMonitorCheckStatusRelatedFailuresError,
  GetMonitorCheckStatusRelatedFailuresSuccess,
  GetMonitorCheckStatusRelatedFailuresParams
>(getMonitorCheckStatusRelatedFailuresFn);

/**
 * NodeApi - fetch parameter creator
 * @export
 */
export const NodeApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} nodeType
		 * @param {number} nodeId
		 * @param {number} [timeoutSeconds]
		 * @param {*} [options] Override http request option.
		 */
		aDelete(nodeType: string, nodeId: number, timeoutSeconds: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/node/{nodeType}/{nodeId}`
				.replace('{nodeType}', encodeURIComponent(String(nodeType)))
				.replace('{nodeId}', encodeURIComponent(String(nodeId)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (timeoutSeconds !== undefined) {
				localVarQueryParameter['timeoutSeconds'] = timeoutSeconds;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} nodeType
		 * @param {string} nodeIdOrUrn
		 * @param {Api.NodeName} request New name for the node
		 * @param {*} [options] Override http request option.
		 */
		clone(nodeType: string, nodeIdOrUrn: string, request: Api.NodeName, options: any = {}): FetchArgs {
			const localVarPath = `/node/{nodeType}/{nodeIdOrUrn}/clone`
				.replace('{nodeType}', encodeURIComponent(String(nodeType)))
				.replace('{nodeIdOrUrn}', encodeURIComponent(String(nodeIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} nodeType
		 * @param {number} nodeId
		 * @param {*} [options] Override http request option.
		 */
		lock(nodeType: string, nodeId: number, options: any = {}): FetchArgs {
			const localVarPath = `/node/{nodeType}/{nodeId}/islocked`
				.replace('{nodeType}', encodeURIComponent(String(nodeType)))
				.replace('{nodeId}', encodeURIComponent(String(nodeId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		nodeListTypes(options: any = {}): FetchArgs {
			const localVarPath = `/node`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} nodeType
		 * @param {string} [namespace]
		 * @param {string} [ownedBy]
		 * @param {*} [options] Override http request option.
		 */
		typeList(nodeType: string, namespace: string | undefined, ownedBy: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/node/{nodeType}`
				.replace('{nodeType}', encodeURIComponent(String(nodeType)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (namespace !== undefined) {
				localVarQueryParameter['namespace'] = namespace;
			}
			if (ownedBy !== undefined) {
				localVarQueryParameter['ownedBy'] = ownedBy;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} nodeType
		 * @param {number} nodeId
		 * @param {*} [options] Override http request option.
		 */
		unlock(nodeType: string, nodeId: number, options: any = {}): FetchArgs {
			const localVarPath = `/node/{nodeType}/{nodeId}/unlock`
				.replace('{nodeType}', encodeURIComponent(String(nodeType)))
				.replace('{nodeId}', encodeURIComponent(String(nodeId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Node
*/
export interface ADeleteParams {
  nodeType: string;
  nodeId: number;
  timeoutSeconds?: number;
}

export type ADeleteSuccess = void;
export type ADeleteError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * ADeleteApi - functional programming interface
 * <p>Delete a locked node</p>
 * @export
 */
export const aDeleteFn = ({
  nodeType,
  nodeId,
  timeoutSeconds,
 }: ADeleteParams, options: any = {}, configuration?: Configuration): Promise<ADeleteSuccess> => {
  const localVarFetchArgs = NodeApiFetchParamCreator(configuration).aDelete(nodeType, nodeId, timeoutSeconds, options);
  return requestFetch<ADeleteSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const aDelete = toResponsePromiseWithMeta<
  ADeleteError,
  ADeleteSuccess,
  ADeleteParams
>(aDeleteFn);

export const aDeleteObservable = toResponseObservableWithMeta<
  ADeleteError,
  ADeleteSuccess,
  ADeleteParams
>(aDeleteFn);

export interface CloneParams {
  nodeType: string;
  nodeIdOrUrn: string;
  body: Api.NodeName;
}

export type CloneSuccess = Api.Node;
export type CloneError = HTTPError | Api.GenericErrorsResponse;

/**
 * CloneApi - functional programming interface
 * <p>Clone a node with a new name</p>
 * @export
 */
export const cloneFn = ({
  nodeType,
  nodeIdOrUrn,
 body,
 }: CloneParams, options: any = {}, configuration?: Configuration): Promise<CloneSuccess> => {
  const localVarFetchArgs = NodeApiFetchParamCreator(configuration).clone(nodeType, nodeIdOrUrn, body, options);
  return requestFetch<CloneSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const clone = toResponsePromiseWithMeta<
  CloneError,
  CloneSuccess,
  CloneParams
>(cloneFn);

export const cloneObservable = toResponseObservableWithMeta<
  CloneError,
  CloneSuccess,
  CloneParams
>(cloneFn);

export interface LockParams {
  nodeType: string;
  nodeId: number;
}

export type LockSuccess = Api.LockedResponse;
export type LockError = HTTPError | Api.GenericErrorsResponse;

/**
 * LockApi - functional programming interface
 * <p>Retrieve if a node is locked</p>
 * @export
 */
export const lockFn = ({
  nodeType,
  nodeId,
 }: LockParams, options: any = {}, configuration?: Configuration): Promise<LockSuccess> => {
  const localVarFetchArgs = NodeApiFetchParamCreator(configuration).lock(nodeType, nodeId, options);
  return requestFetch<LockSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const lock = toResponsePromiseWithMeta<
  LockError,
  LockSuccess,
  LockParams
>(lockFn);

export const lockObservable = toResponseObservableWithMeta<
  LockError,
  LockSuccess,
  LockParams
>(lockFn);

export interface NodeListTypesParams {
}

export type NodeListTypesSuccess = Api.NodeTypes;
export type NodeListTypesError = HTTPError | Api.GenericErrorsResponse;

/**
 * NodeListTypesApi - functional programming interface
 * <p>list all node types</p>
 * @export
 */
export const nodeListTypesFn = ({
 }: NodeListTypesParams, options: any = {}, configuration?: Configuration): Promise<NodeListTypesSuccess> => {
  const localVarFetchArgs = NodeApiFetchParamCreator(configuration).nodeListTypes(options);
  return requestFetch<NodeListTypesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const nodeListTypes = toResponsePromiseWithMeta<
  NodeListTypesError,
  NodeListTypesSuccess,
  NodeListTypesParams
>(nodeListTypesFn);

export const nodeListTypesObservable = toResponseObservableWithMeta<
  NodeListTypesError,
  NodeListTypesSuccess,
  NodeListTypesParams
>(nodeListTypesFn);

export interface TypeListParams {
  nodeType: string;
  namespace?: string;
  ownedBy?: string;
}

export type TypeListSuccess = Api.Node[];
export type TypeListError = HTTPError | Api.GenericErrorsResponse;

/**
 * TypeListApi - functional programming interface
 * <p>list all nodes of that type</p>
 * @export
 */
export const typeListFn = ({
  nodeType,
  namespace,
  ownedBy,
 }: TypeListParams, options: any = {}, configuration?: Configuration): Promise<TypeListSuccess> => {
  const localVarFetchArgs = NodeApiFetchParamCreator(configuration).typeList(nodeType, namespace, ownedBy, options);
  return requestFetch<TypeListSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const typeList = toResponsePromiseWithMeta<
  TypeListError,
  TypeListSuccess,
  TypeListParams
>(typeListFn);

export const typeListObservable = toResponseObservableWithMeta<
  TypeListError,
  TypeListSuccess,
  TypeListParams
>(typeListFn);

export interface UnlockParams {
  nodeType: string;
  nodeId: number;
}

export type UnlockSuccess = Api.Node;
export type UnlockError = HTTPError | Api.GenericErrorsResponse;

/**
 * UnlockApi - functional programming interface
 * <p>Unlock a locked node</p>
 * @export
 */
export const unlockFn = ({
  nodeType,
  nodeId,
 }: UnlockParams, options: any = {}, configuration?: Configuration): Promise<UnlockSuccess> => {
  const localVarFetchArgs = NodeApiFetchParamCreator(configuration).unlock(nodeType, nodeId, options);
  return requestFetch<UnlockSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const unlock = toResponsePromiseWithMeta<
  UnlockError,
  UnlockSuccess,
  UnlockParams
>(unlockFn);

export const unlockObservable = toResponseObservableWithMeta<
  UnlockError,
  UnlockSuccess,
  UnlockParams
>(unlockFn);

/**
 * NotificationChannelsApi - fetch parameter creator
 * @export
 */
export const NotificationChannelsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {Api.EmailChannelWriteSchema} request Create or update a email channel
		 * @param {*} [options] Override http request option.
		 */
		createEmailNotificationChannel(request: Api.EmailChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/email`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.OpsgenieChannelWriteSchema} request Create or update a opsgenie channel
		 * @param {*} [options] Override http request option.
		 */
		createOpsgenieNotificationChannel(request: Api.OpsgenieChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/opsgenie`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.TeamsChannelWriteSchema} request Create or update a teams channel
		 * @param {*} [options] Override http request option.
		 */
		createTeamsNotificationChannel(request: Api.TeamsChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/teams`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.WebhookChannelWriteSchema} request Create or update a webhook channel
		 * @param {*} [options] Override http request option.
		 */
		createWebhookNotificationChannel(request: Api.WebhookChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/webhook`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteEmailNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/email/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteOpsgenieNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/opsgenie/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteSlackNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteTeamsNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/teams/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteWebhookNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/webhook/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		getEmailNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/email/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getEmailNotificationStatus(options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/email/status`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		getOpsgenieNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/opsgenie/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		getSlackNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		getTeamsNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/teams/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		getWebhookNotificationChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/webhook/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {Api.SlackChannelId} request Provide a Slack channel id to join the specified Slack channel
		 * @param {*} [options] Override http request option.
		 */
		joinSlackChannel(channelId: number, request: Api.SlackChannelId, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/{channelId}/joinSlackChannel`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} genieKey OpsGenie API key
		 * @param {Api.OpsgenieRegion} region OpsGenie region
		 * @param {*} [options] Override http request option.
		 */
		listOpsgenieResponders(genieKey: string, region: Api.OpsgenieRegion, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/opsgenie/responders`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (genieKey !== undefined) {
				localVarQueryParameter['genieKey'] = genieKey;
			}
			if (region !== undefined) {
				localVarQueryParameter['region'] = region;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {string} [cursor] Slack list cursor
		 * @param {*} [options] Override http request option.
		 */
		listSlackChannels(channelId: number, cursor: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/{channelId}/listSlackChannels`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (cursor !== undefined) {
				localVarQueryParameter['cursor'] = cursor;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {string} slackChannelId Slack Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		slackChannelDetails(channelId: number, slackChannelId: string, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/{channelId}/slackChannelDetails/{slackChannelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)))
				.replace('{slackChannelId}', encodeURIComponent(String(slackChannelId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} [code] OAuth code from Slack. Either the code is present for the success case or the error parameter is present for the error case.
		 * @param {string} state State parameter that was passed to Slack, should have the same value as the one passed to Slack.
		 * @param {string} [error] Error parameter. Either the code is present for the success case or the error parameter is present for the error case.
		 * @param {*} [options] Override http request option.
		 */
		slackOAuthCallback(code: string | undefined, state: string, error: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/oauth-callback`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (code !== undefined) {
				localVarQueryParameter['code'] = code;
			}
			if (state !== undefined) {
				localVarQueryParameter['state'] = state;
			}
			if (error !== undefined) {
				localVarQueryParameter['error'] = error;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} redirectPath After completing the oauth flow the user will be redirected back to this path, in the UI, on StackState, to continue further setup of the Slack notification channel.
		 * @param {*} [options] Override http request option.
		 */
		slackOauthRedirect(redirectPath: string, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/oauth-redirect`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (redirectPath !== undefined) {
				localVarQueryParameter['redirectPath'] = redirectPath;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		testEmailChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/email/{channelId}/test`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		testOpsgenieChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/opsgenie/{channelId}/test`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		testSlackChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/slack/{channelId}/test`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		testTeamsChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/teams/{channelId}/test`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {*} [options] Override http request option.
		 */
		testWebhookChannel(channelId: number, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/webhook/{channelId}/test`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {Api.EmailChannelWriteSchema} request Create or update a email channel
		 * @param {*} [options] Override http request option.
		 */
		updateEmailNotificationChannel(channelId: number, request: Api.EmailChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/email/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {Api.OpsgenieChannelWriteSchema} request Create or update a opsgenie channel
		 * @param {*} [options] Override http request option.
		 */
		updateOpsgenieNotificationChannel(channelId: number, request: Api.OpsgenieChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/opsgenie/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {Api.TeamsChannelWriteSchema} request Create or update a teams channel
		 * @param {*} [options] Override http request option.
		 */
		updateTeamsNotificationChannel(channelId: number, request: Api.TeamsChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/teams/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} channelId Channel identifier
		 * @param {Api.WebhookChannelWriteSchema} request Create or update a webhook channel
		 * @param {*} [options] Override http request option.
		 */
		updateWebhookNotificationChannel(channelId: number, request: Api.WebhookChannelWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/channels/webhook/{channelId}`
				.replace('{channelId}', encodeURIComponent(String(channelId)));
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* NotificationChannels
*/
export interface CreateEmailNotificationChannelParams {
  body: Api.EmailChannelWriteSchema;
}

export type CreateEmailNotificationChannelSuccess = Api.EmailNotificationChannel;
export type CreateEmailNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelError;

/**
 * CreateEmailNotificationChannelApi - functional programming interface
 * <p>Create Email Notification channel</p>
 * @export
 */
export const createEmailNotificationChannelFn = ({
 body,
 }: CreateEmailNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<CreateEmailNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).createEmailNotificationChannel(body, options);
  return requestFetch<CreateEmailNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createEmailNotificationChannel = toResponsePromiseWithMeta<
  CreateEmailNotificationChannelError,
  CreateEmailNotificationChannelSuccess,
  CreateEmailNotificationChannelParams
>(createEmailNotificationChannelFn);

export const createEmailNotificationChannelObservable = toResponseObservableWithMeta<
  CreateEmailNotificationChannelError,
  CreateEmailNotificationChannelSuccess,
  CreateEmailNotificationChannelParams
>(createEmailNotificationChannelFn);

export interface CreateOpsgenieNotificationChannelParams {
  body: Api.OpsgenieChannelWriteSchema;
}

export type CreateOpsgenieNotificationChannelSuccess = Api.OpsgenieNotificationChannel;
export type CreateOpsgenieNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelError;

/**
 * CreateOpsgenieNotificationChannelApi - functional programming interface
 * <p>Create a Opsgenie Notification channel</p>
 * @export
 */
export const createOpsgenieNotificationChannelFn = ({
 body,
 }: CreateOpsgenieNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<CreateOpsgenieNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).createOpsgenieNotificationChannel(body, options);
  return requestFetch<CreateOpsgenieNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createOpsgenieNotificationChannel = toResponsePromiseWithMeta<
  CreateOpsgenieNotificationChannelError,
  CreateOpsgenieNotificationChannelSuccess,
  CreateOpsgenieNotificationChannelParams
>(createOpsgenieNotificationChannelFn);

export const createOpsgenieNotificationChannelObservable = toResponseObservableWithMeta<
  CreateOpsgenieNotificationChannelError,
  CreateOpsgenieNotificationChannelSuccess,
  CreateOpsgenieNotificationChannelParams
>(createOpsgenieNotificationChannelFn);

export interface CreateTeamsNotificationChannelParams {
  body: Api.TeamsChannelWriteSchema;
}

export type CreateTeamsNotificationChannelSuccess = Api.TeamsNotificationChannel;
export type CreateTeamsNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelError;

/**
 * CreateTeamsNotificationChannelApi - functional programming interface
 * <p>Create a Teams Notification channel</p>
 * @export
 */
export const createTeamsNotificationChannelFn = ({
 body,
 }: CreateTeamsNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<CreateTeamsNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).createTeamsNotificationChannel(body, options);
  return requestFetch<CreateTeamsNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createTeamsNotificationChannel = toResponsePromiseWithMeta<
  CreateTeamsNotificationChannelError,
  CreateTeamsNotificationChannelSuccess,
  CreateTeamsNotificationChannelParams
>(createTeamsNotificationChannelFn);

export const createTeamsNotificationChannelObservable = toResponseObservableWithMeta<
  CreateTeamsNotificationChannelError,
  CreateTeamsNotificationChannelSuccess,
  CreateTeamsNotificationChannelParams
>(createTeamsNotificationChannelFn);

export interface CreateWebhookNotificationChannelParams {
  body: Api.WebhookChannelWriteSchema;
}

export type CreateWebhookNotificationChannelSuccess = Api.WebhookNotificationChannel;
export type CreateWebhookNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelError;

/**
 * CreateWebhookNotificationChannelApi - functional programming interface
 * <p>Create a Webhook Notification channel</p>
 * @export
 */
export const createWebhookNotificationChannelFn = ({
 body,
 }: CreateWebhookNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<CreateWebhookNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).createWebhookNotificationChannel(body, options);
  return requestFetch<CreateWebhookNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createWebhookNotificationChannel = toResponsePromiseWithMeta<
  CreateWebhookNotificationChannelError,
  CreateWebhookNotificationChannelSuccess,
  CreateWebhookNotificationChannelParams
>(createWebhookNotificationChannelFn);

export const createWebhookNotificationChannelObservable = toResponseObservableWithMeta<
  CreateWebhookNotificationChannelError,
  CreateWebhookNotificationChannelSuccess,
  CreateWebhookNotificationChannelParams
>(createWebhookNotificationChannelFn);

export interface DeleteEmailNotificationChannelParams {
  channelId: number;
}

export type DeleteEmailNotificationChannelSuccess = void;
export type DeleteEmailNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * DeleteEmailNotificationChannelApi - functional programming interface
 * <p>Delete the email notification channel by id</p>
 * @export
 */
export const deleteEmailNotificationChannelFn = ({
  channelId,
 }: DeleteEmailNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<DeleteEmailNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).deleteEmailNotificationChannel(channelId, options);
  return requestFetch<DeleteEmailNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteEmailNotificationChannel = toResponsePromiseWithMeta<
  DeleteEmailNotificationChannelError,
  DeleteEmailNotificationChannelSuccess,
  DeleteEmailNotificationChannelParams
>(deleteEmailNotificationChannelFn);

export const deleteEmailNotificationChannelObservable = toResponseObservableWithMeta<
  DeleteEmailNotificationChannelError,
  DeleteEmailNotificationChannelSuccess,
  DeleteEmailNotificationChannelParams
>(deleteEmailNotificationChannelFn);

export interface DeleteOpsgenieNotificationChannelParams {
  channelId: number;
}

export type DeleteOpsgenieNotificationChannelSuccess = void;
export type DeleteOpsgenieNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * DeleteOpsgenieNotificationChannelApi - functional programming interface
 * <p>Delete the opsgenie notification channel by id</p>
 * @export
 */
export const deleteOpsgenieNotificationChannelFn = ({
  channelId,
 }: DeleteOpsgenieNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<DeleteOpsgenieNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).deleteOpsgenieNotificationChannel(channelId, options);
  return requestFetch<DeleteOpsgenieNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteOpsgenieNotificationChannel = toResponsePromiseWithMeta<
  DeleteOpsgenieNotificationChannelError,
  DeleteOpsgenieNotificationChannelSuccess,
  DeleteOpsgenieNotificationChannelParams
>(deleteOpsgenieNotificationChannelFn);

export const deleteOpsgenieNotificationChannelObservable = toResponseObservableWithMeta<
  DeleteOpsgenieNotificationChannelError,
  DeleteOpsgenieNotificationChannelSuccess,
  DeleteOpsgenieNotificationChannelParams
>(deleteOpsgenieNotificationChannelFn);

export interface DeleteSlackNotificationChannelParams {
  channelId: number;
}

export type DeleteSlackNotificationChannelSuccess = void;
export type DeleteSlackNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * DeleteSlackNotificationChannelApi - functional programming interface
 * <p>Delete the slack notification channel by id</p>
 * @export
 */
export const deleteSlackNotificationChannelFn = ({
  channelId,
 }: DeleteSlackNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<DeleteSlackNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).deleteSlackNotificationChannel(channelId, options);
  return requestFetch<DeleteSlackNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteSlackNotificationChannel = toResponsePromiseWithMeta<
  DeleteSlackNotificationChannelError,
  DeleteSlackNotificationChannelSuccess,
  DeleteSlackNotificationChannelParams
>(deleteSlackNotificationChannelFn);

export const deleteSlackNotificationChannelObservable = toResponseObservableWithMeta<
  DeleteSlackNotificationChannelError,
  DeleteSlackNotificationChannelSuccess,
  DeleteSlackNotificationChannelParams
>(deleteSlackNotificationChannelFn);

export interface DeleteTeamsNotificationChannelParams {
  channelId: number;
}

export type DeleteTeamsNotificationChannelSuccess = void;
export type DeleteTeamsNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * DeleteTeamsNotificationChannelApi - functional programming interface
 * <p>Delete the teams notification channel by id</p>
 * @export
 */
export const deleteTeamsNotificationChannelFn = ({
  channelId,
 }: DeleteTeamsNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<DeleteTeamsNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).deleteTeamsNotificationChannel(channelId, options);
  return requestFetch<DeleteTeamsNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteTeamsNotificationChannel = toResponsePromiseWithMeta<
  DeleteTeamsNotificationChannelError,
  DeleteTeamsNotificationChannelSuccess,
  DeleteTeamsNotificationChannelParams
>(deleteTeamsNotificationChannelFn);

export const deleteTeamsNotificationChannelObservable = toResponseObservableWithMeta<
  DeleteTeamsNotificationChannelError,
  DeleteTeamsNotificationChannelSuccess,
  DeleteTeamsNotificationChannelParams
>(deleteTeamsNotificationChannelFn);

export interface DeleteWebhookNotificationChannelParams {
  channelId: number;
}

export type DeleteWebhookNotificationChannelSuccess = void;
export type DeleteWebhookNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * DeleteWebhookNotificationChannelApi - functional programming interface
 * <p>Delete the webhook notification channel by id</p>
 * @export
 */
export const deleteWebhookNotificationChannelFn = ({
  channelId,
 }: DeleteWebhookNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<DeleteWebhookNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).deleteWebhookNotificationChannel(channelId, options);
  return requestFetch<DeleteWebhookNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteWebhookNotificationChannel = toResponsePromiseWithMeta<
  DeleteWebhookNotificationChannelError,
  DeleteWebhookNotificationChannelSuccess,
  DeleteWebhookNotificationChannelParams
>(deleteWebhookNotificationChannelFn);

export const deleteWebhookNotificationChannelObservable = toResponseObservableWithMeta<
  DeleteWebhookNotificationChannelError,
  DeleteWebhookNotificationChannelSuccess,
  DeleteWebhookNotificationChannelParams
>(deleteWebhookNotificationChannelFn);

export interface GetEmailNotificationChannelParams {
  channelId: number;
}

export type GetEmailNotificationChannelSuccess = Api.EmailNotificationChannel;
export type GetEmailNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * GetEmailNotificationChannelApi - functional programming interface
 * <p>Get the email notification channel by id</p>
 * @export
 */
export const getEmailNotificationChannelFn = ({
  channelId,
 }: GetEmailNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<GetEmailNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).getEmailNotificationChannel(channelId, options);
  return requestFetch<GetEmailNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEmailNotificationChannel = toResponsePromiseWithMeta<
  GetEmailNotificationChannelError,
  GetEmailNotificationChannelSuccess,
  GetEmailNotificationChannelParams
>(getEmailNotificationChannelFn);

export const getEmailNotificationChannelObservable = toResponseObservableWithMeta<
  GetEmailNotificationChannelError,
  GetEmailNotificationChannelSuccess,
  GetEmailNotificationChannelParams
>(getEmailNotificationChannelFn);

export interface GetEmailNotificationStatusParams {
}

export type GetEmailNotificationStatusSuccess = Api.EmailNotificationStatus;
export type GetEmailNotificationStatusError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelError;

/**
 * GetEmailNotificationStatusApi - functional programming interface
 * <p>Email Notification channel status, test whether it can be used</p>
 * @export
 */
export const getEmailNotificationStatusFn = ({
 }: GetEmailNotificationStatusParams, options: any = {}, configuration?: Configuration): Promise<GetEmailNotificationStatusSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).getEmailNotificationStatus(options);
  return requestFetch<GetEmailNotificationStatusSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getEmailNotificationStatus = toResponsePromiseWithMeta<
  GetEmailNotificationStatusError,
  GetEmailNotificationStatusSuccess,
  GetEmailNotificationStatusParams
>(getEmailNotificationStatusFn);

export const getEmailNotificationStatusObservable = toResponseObservableWithMeta<
  GetEmailNotificationStatusError,
  GetEmailNotificationStatusSuccess,
  GetEmailNotificationStatusParams
>(getEmailNotificationStatusFn);

export interface GetOpsgenieNotificationChannelParams {
  channelId: number;
}

export type GetOpsgenieNotificationChannelSuccess = Api.OpsgenieNotificationChannel;
export type GetOpsgenieNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * GetOpsgenieNotificationChannelApi - functional programming interface
 * <p>Get the opsgenie notification channel by id</p>
 * @export
 */
export const getOpsgenieNotificationChannelFn = ({
  channelId,
 }: GetOpsgenieNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<GetOpsgenieNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).getOpsgenieNotificationChannel(channelId, options);
  return requestFetch<GetOpsgenieNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOpsgenieNotificationChannel = toResponsePromiseWithMeta<
  GetOpsgenieNotificationChannelError,
  GetOpsgenieNotificationChannelSuccess,
  GetOpsgenieNotificationChannelParams
>(getOpsgenieNotificationChannelFn);

export const getOpsgenieNotificationChannelObservable = toResponseObservableWithMeta<
  GetOpsgenieNotificationChannelError,
  GetOpsgenieNotificationChannelSuccess,
  GetOpsgenieNotificationChannelParams
>(getOpsgenieNotificationChannelFn);

export interface GetSlackNotificationChannelParams {
  channelId: number;
}

export type GetSlackNotificationChannelSuccess = Api.SlackNotificationChannel;
export type GetSlackNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * GetSlackNotificationChannelApi - functional programming interface
 * <p>Get the slack notification channel by id</p>
 * @export
 */
export const getSlackNotificationChannelFn = ({
  channelId,
 }: GetSlackNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<GetSlackNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).getSlackNotificationChannel(channelId, options);
  return requestFetch<GetSlackNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getSlackNotificationChannel = toResponsePromiseWithMeta<
  GetSlackNotificationChannelError,
  GetSlackNotificationChannelSuccess,
  GetSlackNotificationChannelParams
>(getSlackNotificationChannelFn);

export const getSlackNotificationChannelObservable = toResponseObservableWithMeta<
  GetSlackNotificationChannelError,
  GetSlackNotificationChannelSuccess,
  GetSlackNotificationChannelParams
>(getSlackNotificationChannelFn);

export interface GetTeamsNotificationChannelParams {
  channelId: number;
}

export type GetTeamsNotificationChannelSuccess = Api.TeamsNotificationChannel;
export type GetTeamsNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * GetTeamsNotificationChannelApi - functional programming interface
 * <p>Get the teams notification channel by id</p>
 * @export
 */
export const getTeamsNotificationChannelFn = ({
  channelId,
 }: GetTeamsNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<GetTeamsNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).getTeamsNotificationChannel(channelId, options);
  return requestFetch<GetTeamsNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getTeamsNotificationChannel = toResponsePromiseWithMeta<
  GetTeamsNotificationChannelError,
  GetTeamsNotificationChannelSuccess,
  GetTeamsNotificationChannelParams
>(getTeamsNotificationChannelFn);

export const getTeamsNotificationChannelObservable = toResponseObservableWithMeta<
  GetTeamsNotificationChannelError,
  GetTeamsNotificationChannelSuccess,
  GetTeamsNotificationChannelParams
>(getTeamsNotificationChannelFn);

export interface GetWebhookNotificationChannelParams {
  channelId: number;
}

export type GetWebhookNotificationChannelSuccess = Api.WebhookNotificationChannel;
export type GetWebhookNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * GetWebhookNotificationChannelApi - functional programming interface
 * <p>Get the webhook notification channel by id</p>
 * @export
 */
export const getWebhookNotificationChannelFn = ({
  channelId,
 }: GetWebhookNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<GetWebhookNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).getWebhookNotificationChannel(channelId, options);
  return requestFetch<GetWebhookNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getWebhookNotificationChannel = toResponsePromiseWithMeta<
  GetWebhookNotificationChannelError,
  GetWebhookNotificationChannelSuccess,
  GetWebhookNotificationChannelParams
>(getWebhookNotificationChannelFn);

export const getWebhookNotificationChannelObservable = toResponseObservableWithMeta<
  GetWebhookNotificationChannelError,
  GetWebhookNotificationChannelSuccess,
  GetWebhookNotificationChannelParams
>(getWebhookNotificationChannelFn);

export interface JoinSlackChannelParams {
  channelId: number;
  body: Api.SlackChannelId;
}

export type JoinSlackChannelSuccess = Api.SlackNotificationChannel;
export type JoinSlackChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * JoinSlackChannelApi - functional programming interface
 * <p>Join the specified Slack channel and configure this notifiation channel to post notifications to the specified slack channel.</p>
 * @export
 */
export const joinSlackChannelFn = ({
  channelId,
 body,
 }: JoinSlackChannelParams, options: any = {}, configuration?: Configuration): Promise<JoinSlackChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).joinSlackChannel(channelId, body, options);
  return requestFetch<JoinSlackChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const joinSlackChannel = toResponsePromiseWithMeta<
  JoinSlackChannelError,
  JoinSlackChannelSuccess,
  JoinSlackChannelParams
>(joinSlackChannelFn);

export const joinSlackChannelObservable = toResponseObservableWithMeta<
  JoinSlackChannelError,
  JoinSlackChannelSuccess,
  JoinSlackChannelParams
>(joinSlackChannelFn);

export interface ListOpsgenieRespondersParams {
  genieKey: string;
  region: Api.OpsgenieRegion;
}

export type ListOpsgenieRespondersSuccess = Api.OpsgenieResponder[];
export type ListOpsgenieRespondersError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelError;

/**
 * ListOpsgenieRespondersApi - functional programming interface
 * <p>List Opsgenie responders</p>
 * @export
 */
export const listOpsgenieRespondersFn = ({
  genieKey,
  region,
 }: ListOpsgenieRespondersParams, options: any = {}, configuration?: Configuration): Promise<ListOpsgenieRespondersSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).listOpsgenieResponders(genieKey, region, options);
  return requestFetch<ListOpsgenieRespondersSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const listOpsgenieResponders = toResponsePromiseWithMeta<
  ListOpsgenieRespondersError,
  ListOpsgenieRespondersSuccess,
  ListOpsgenieRespondersParams
>(listOpsgenieRespondersFn);

export const listOpsgenieRespondersObservable = toResponseObservableWithMeta<
  ListOpsgenieRespondersError,
  ListOpsgenieRespondersSuccess,
  ListOpsgenieRespondersParams
>(listOpsgenieRespondersFn);

export interface ListSlackChannelsParams {
  channelId: number;
  cursor?: string;
}

export type ListSlackChannelsSuccess = Api.SlackChannelsChunk;
export type ListSlackChannelsError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * ListSlackChannelsApi - functional programming interface
 * <p>List all public Slack channels, used for selecting a channel for the notifications</p>
 * @export
 */
export const listSlackChannelsFn = ({
  channelId,
  cursor,
 }: ListSlackChannelsParams, options: any = {}, configuration?: Configuration): Promise<ListSlackChannelsSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).listSlackChannels(channelId, cursor, options);
  return requestFetch<ListSlackChannelsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const listSlackChannels = toResponsePromiseWithMeta<
  ListSlackChannelsError,
  ListSlackChannelsSuccess,
  ListSlackChannelsParams
>(listSlackChannelsFn);

export const listSlackChannelsObservable = toResponseObservableWithMeta<
  ListSlackChannelsError,
  ListSlackChannelsSuccess,
  ListSlackChannelsParams
>(listSlackChannelsFn);

export interface SlackChannelDetailsParams {
  channelId: number;
  slackChannelId: string;
}

export type SlackChannelDetailsSuccess = Api.SlackChannel;
export type SlackChannelDetailsError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * SlackChannelDetailsApi - functional programming interface
 * <p>Get Slack channel details, used for validating a channel for the notifications</p>
 * @export
 */
export const slackChannelDetailsFn = ({
  channelId,
  slackChannelId,
 }: SlackChannelDetailsParams, options: any = {}, configuration?: Configuration): Promise<SlackChannelDetailsSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).slackChannelDetails(channelId, slackChannelId, options);
  return requestFetch<SlackChannelDetailsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const slackChannelDetails = toResponsePromiseWithMeta<
  SlackChannelDetailsError,
  SlackChannelDetailsSuccess,
  SlackChannelDetailsParams
>(slackChannelDetailsFn);

export const slackChannelDetailsObservable = toResponseObservableWithMeta<
  SlackChannelDetailsError,
  SlackChannelDetailsSuccess,
  SlackChannelDetailsParams
>(slackChannelDetailsFn);

export interface SlackOAuthCallbackParams {
  code?: string;
  state: string;
  error?: string;
}

export type SlackOAuthCallbackSuccess = void;
export type SlackOAuthCallbackError = HTTPError | "Redirects back to the Slack channel configuration, in case of an error it includes an &#x60;error&#x60; query parameter. If known also a &#x60;channelId&#x60; parameter will be included.";

/**
 * SlackOAuthCallbackApi - functional programming interface
 * <p>The OAuth callback for Slack, which is used to obtain the access token for the Slack channel.</p>
 * @export
 */
export const slackOAuthCallbackFn = ({
  code,
  state,
  error,
 }: SlackOAuthCallbackParams, options: any = {}, configuration?: Configuration): Promise<SlackOAuthCallbackSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).slackOAuthCallback(code, state, error, options);
  return requestFetch<SlackOAuthCallbackSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const slackOAuthCallback = toResponsePromiseWithMeta<
  SlackOAuthCallbackError,
  SlackOAuthCallbackSuccess,
  SlackOAuthCallbackParams
>(slackOAuthCallbackFn);

export const slackOAuthCallbackObservable = toResponseObservableWithMeta<
  SlackOAuthCallbackError,
  SlackOAuthCallbackSuccess,
  SlackOAuthCallbackParams
>(slackOAuthCallbackFn);

export interface SlackOauthRedirectParams {
  redirectPath: string;
}

export type SlackOauthRedirectSuccess = void;
export type SlackOauthRedirectError = HTTPError | "Redirects to Slack to start an OAuth2 flow that will return to the slack channel configuration afterwards. In case of an error redirects back to the Slack channel configuration with an &#x60;error&#x60; and a &#x60;channelId&#x60; parameter.";

/**
 * SlackOauthRedirectApi - functional programming interface
 * <p>Redirects to Slack to start an OAuth2 flow.</p>
 * @export
 */
export const slackOauthRedirectFn = ({
  redirectPath,
 }: SlackOauthRedirectParams, options: any = {}, configuration?: Configuration): Promise<SlackOauthRedirectSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).slackOauthRedirect(redirectPath, options);
  return requestFetch<SlackOauthRedirectSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const slackOauthRedirect = toResponsePromiseWithMeta<
  SlackOauthRedirectError,
  SlackOauthRedirectSuccess,
  SlackOauthRedirectParams
>(slackOauthRedirectFn);

export const slackOauthRedirectObservable = toResponseObservableWithMeta<
  SlackOauthRedirectError,
  SlackOauthRedirectSuccess,
  SlackOauthRedirectParams
>(slackOauthRedirectFn);

export interface TestEmailChannelParams {
  channelId: number;
}

export type TestEmailChannelSuccess = void;
export type TestEmailChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * TestEmailChannelApi - functional programming interface
 * <p>Test the email notification channel by sending a test message to the notification channel.</p>
 * @export
 */
export const testEmailChannelFn = ({
  channelId,
 }: TestEmailChannelParams, options: any = {}, configuration?: Configuration): Promise<TestEmailChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).testEmailChannel(channelId, options);
  return requestFetch<TestEmailChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const testEmailChannel = toResponsePromiseWithMeta<
  TestEmailChannelError,
  TestEmailChannelSuccess,
  TestEmailChannelParams
>(testEmailChannelFn);

export const testEmailChannelObservable = toResponseObservableWithMeta<
  TestEmailChannelError,
  TestEmailChannelSuccess,
  TestEmailChannelParams
>(testEmailChannelFn);

export interface TestOpsgenieChannelParams {
  channelId: number;
}

export type TestOpsgenieChannelSuccess = void;
export type TestOpsgenieChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * TestOpsgenieChannelApi - functional programming interface
 * <p>Test the opsgenie notification channel by sending a test message to the notification channel.</p>
 * @export
 */
export const testOpsgenieChannelFn = ({
  channelId,
 }: TestOpsgenieChannelParams, options: any = {}, configuration?: Configuration): Promise<TestOpsgenieChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).testOpsgenieChannel(channelId, options);
  return requestFetch<TestOpsgenieChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const testOpsgenieChannel = toResponsePromiseWithMeta<
  TestOpsgenieChannelError,
  TestOpsgenieChannelSuccess,
  TestOpsgenieChannelParams
>(testOpsgenieChannelFn);

export const testOpsgenieChannelObservable = toResponseObservableWithMeta<
  TestOpsgenieChannelError,
  TestOpsgenieChannelSuccess,
  TestOpsgenieChannelParams
>(testOpsgenieChannelFn);

export interface TestSlackChannelParams {
  channelId: number;
}

export type TestSlackChannelSuccess = void;
export type TestSlackChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * TestSlackChannelApi - functional programming interface
 * <p>Test the Notification channel by sending a test message to the notification channel.</p>
 * @export
 */
export const testSlackChannelFn = ({
  channelId,
 }: TestSlackChannelParams, options: any = {}, configuration?: Configuration): Promise<TestSlackChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).testSlackChannel(channelId, options);
  return requestFetch<TestSlackChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const testSlackChannel = toResponsePromiseWithMeta<
  TestSlackChannelError,
  TestSlackChannelSuccess,
  TestSlackChannelParams
>(testSlackChannelFn);

export const testSlackChannelObservable = toResponseObservableWithMeta<
  TestSlackChannelError,
  TestSlackChannelSuccess,
  TestSlackChannelParams
>(testSlackChannelFn);

export interface TestTeamsChannelParams {
  channelId: number;
}

export type TestTeamsChannelSuccess = void;
export type TestTeamsChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * TestTeamsChannelApi - functional programming interface
 * <p>Test the teams notification channel by sending a test message to the notification channel.</p>
 * @export
 */
export const testTeamsChannelFn = ({
  channelId,
 }: TestTeamsChannelParams, options: any = {}, configuration?: Configuration): Promise<TestTeamsChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).testTeamsChannel(channelId, options);
  return requestFetch<TestTeamsChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const testTeamsChannel = toResponsePromiseWithMeta<
  TestTeamsChannelError,
  TestTeamsChannelSuccess,
  TestTeamsChannelParams
>(testTeamsChannelFn);

export const testTeamsChannelObservable = toResponseObservableWithMeta<
  TestTeamsChannelError,
  TestTeamsChannelSuccess,
  TestTeamsChannelParams
>(testTeamsChannelFn);

export interface TestWebhookChannelParams {
  channelId: number;
}

export type TestWebhookChannelSuccess = void;
export type TestWebhookChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * TestWebhookChannelApi - functional programming interface
 * <p>Test the webhook notification channel by sending a test message to the notification channel.</p>
 * @export
 */
export const testWebhookChannelFn = ({
  channelId,
 }: TestWebhookChannelParams, options: any = {}, configuration?: Configuration): Promise<TestWebhookChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).testWebhookChannel(channelId, options);
  return requestFetch<TestWebhookChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const testWebhookChannel = toResponsePromiseWithMeta<
  TestWebhookChannelError,
  TestWebhookChannelSuccess,
  TestWebhookChannelParams
>(testWebhookChannelFn);

export const testWebhookChannelObservable = toResponseObservableWithMeta<
  TestWebhookChannelError,
  TestWebhookChannelSuccess,
  TestWebhookChannelParams
>(testWebhookChannelFn);

export interface UpdateEmailNotificationChannelParams {
  channelId: number;
  body: Api.EmailChannelWriteSchema;
}

export type UpdateEmailNotificationChannelSuccess = Api.EmailNotificationChannel;
export type UpdateEmailNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * UpdateEmailNotificationChannelApi - functional programming interface
 * <p>Update the email notification channel by id</p>
 * @export
 */
export const updateEmailNotificationChannelFn = ({
  channelId,
 body,
 }: UpdateEmailNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<UpdateEmailNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).updateEmailNotificationChannel(channelId, body, options);
  return requestFetch<UpdateEmailNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const updateEmailNotificationChannel = toResponsePromiseWithMeta<
  UpdateEmailNotificationChannelError,
  UpdateEmailNotificationChannelSuccess,
  UpdateEmailNotificationChannelParams
>(updateEmailNotificationChannelFn);

export const updateEmailNotificationChannelObservable = toResponseObservableWithMeta<
  UpdateEmailNotificationChannelError,
  UpdateEmailNotificationChannelSuccess,
  UpdateEmailNotificationChannelParams
>(updateEmailNotificationChannelFn);

export interface UpdateOpsgenieNotificationChannelParams {
  channelId: number;
  body: Api.OpsgenieChannelWriteSchema;
}

export type UpdateOpsgenieNotificationChannelSuccess = Api.OpsgenieNotificationChannel;
export type UpdateOpsgenieNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * UpdateOpsgenieNotificationChannelApi - functional programming interface
 * <p>Update the opsgenie notification channel by id</p>
 * @export
 */
export const updateOpsgenieNotificationChannelFn = ({
  channelId,
 body,
 }: UpdateOpsgenieNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<UpdateOpsgenieNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).updateOpsgenieNotificationChannel(channelId, body, options);
  return requestFetch<UpdateOpsgenieNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const updateOpsgenieNotificationChannel = toResponsePromiseWithMeta<
  UpdateOpsgenieNotificationChannelError,
  UpdateOpsgenieNotificationChannelSuccess,
  UpdateOpsgenieNotificationChannelParams
>(updateOpsgenieNotificationChannelFn);

export const updateOpsgenieNotificationChannelObservable = toResponseObservableWithMeta<
  UpdateOpsgenieNotificationChannelError,
  UpdateOpsgenieNotificationChannelSuccess,
  UpdateOpsgenieNotificationChannelParams
>(updateOpsgenieNotificationChannelFn);

export interface UpdateTeamsNotificationChannelParams {
  channelId: number;
  body: Api.TeamsChannelWriteSchema;
}

export type UpdateTeamsNotificationChannelSuccess = Api.TeamsNotificationChannel;
export type UpdateTeamsNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * UpdateTeamsNotificationChannelApi - functional programming interface
 * <p>Update the teams notification channel by id</p>
 * @export
 */
export const updateTeamsNotificationChannelFn = ({
  channelId,
 body,
 }: UpdateTeamsNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<UpdateTeamsNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).updateTeamsNotificationChannel(channelId, body, options);
  return requestFetch<UpdateTeamsNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const updateTeamsNotificationChannel = toResponsePromiseWithMeta<
  UpdateTeamsNotificationChannelError,
  UpdateTeamsNotificationChannelSuccess,
  UpdateTeamsNotificationChannelParams
>(updateTeamsNotificationChannelFn);

export const updateTeamsNotificationChannelObservable = toResponseObservableWithMeta<
  UpdateTeamsNotificationChannelError,
  UpdateTeamsNotificationChannelSuccess,
  UpdateTeamsNotificationChannelParams
>(updateTeamsNotificationChannelFn);

export interface UpdateWebhookNotificationChannelParams {
  channelId: number;
  body: Api.WebhookChannelWriteSchema;
}

export type UpdateWebhookNotificationChannelSuccess = Api.WebhookNotificationChannel;
export type UpdateWebhookNotificationChannelError = HTTPError | Api.NotificationChannelError | Api.NotificationChannelNotFound | Api.NotificationChannelError;

/**
 * UpdateWebhookNotificationChannelApi - functional programming interface
 * <p>Update the webhook notification channel by id</p>
 * @export
 */
export const updateWebhookNotificationChannelFn = ({
  channelId,
 body,
 }: UpdateWebhookNotificationChannelParams, options: any = {}, configuration?: Configuration): Promise<UpdateWebhookNotificationChannelSuccess> => {
  const localVarFetchArgs = NotificationChannelsApiFetchParamCreator(configuration).updateWebhookNotificationChannel(channelId, body, options);
  return requestFetch<UpdateWebhookNotificationChannelSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const updateWebhookNotificationChannel = toResponsePromiseWithMeta<
  UpdateWebhookNotificationChannelError,
  UpdateWebhookNotificationChannelSuccess,
  UpdateWebhookNotificationChannelParams
>(updateWebhookNotificationChannelFn);

export const updateWebhookNotificationChannelObservable = toResponseObservableWithMeta<
  UpdateWebhookNotificationChannelError,
  UpdateWebhookNotificationChannelSuccess,
  UpdateWebhookNotificationChannelParams
>(updateWebhookNotificationChannelFn);

/**
 * NotificationConfigurationsApi - fetch parameter creator
 * @export
 */
export const NotificationConfigurationsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {Api.NotificationConfigurationWriteSchema} request Create or update a notification configuration
		 * @param {*} [options] Override http request option.
		 */
		createNotificationConfiguration(request: Api.NotificationConfigurationWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/configurations`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} notificationConfigurationIdOrUrn Notification identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteNotificationConfiguration(notificationConfigurationIdOrUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/configurations/{notificationConfigurationIdOrUrn}`
				.replace('{notificationConfigurationIdOrUrn}', encodeURIComponent(String(notificationConfigurationIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} notificationConfigurationIdOrUrn Notification identifier
		 * @param {*} [options] Override http request option.
		 */
		getNotificationConfiguration(notificationConfigurationIdOrUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/configurations/{notificationConfigurationIdOrUrn}`
				.replace('{notificationConfigurationIdOrUrn}', encodeURIComponent(String(notificationConfigurationIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} notificationConfigurationIdOrUrn Notification identifier
		 * @param {*} [options] Override http request option.
		 */
		getNotificationConfigurationChannels(notificationConfigurationIdOrUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/configurations/{notificationConfigurationIdOrUrn}/channels`
				.replace('{notificationConfigurationIdOrUrn}', encodeURIComponent(String(notificationConfigurationIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getNotificationConfigurations(options: any = {}): FetchArgs {
			const localVarPath = `/notifications/configurations`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} notificationConfigurationIdOrUrn Notification identifier
		 * @param {Api.NotificationConfigurationWriteSchema} request Create or update a notification configuration
		 * @param {*} [options] Override http request option.
		 */
		updateNotificationConfiguration(notificationConfigurationIdOrUrn: string, request: Api.NotificationConfigurationWriteSchema, options: any = {}): FetchArgs {
			const localVarPath = `/notifications/configurations/{notificationConfigurationIdOrUrn}`
				.replace('{notificationConfigurationIdOrUrn}', encodeURIComponent(String(notificationConfigurationIdOrUrn)));
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* NotificationConfigurations
*/
export interface CreateNotificationConfigurationParams {
  body: Api.NotificationConfigurationWriteSchema;
}

export type CreateNotificationConfigurationSuccess = Api.NotificationConfigurationReadSchema;
export type CreateNotificationConfigurationError = HTTPError | Api.NotificationConfigurationError | Api.NotificationConfigurationError;

/**
 * CreateNotificationConfigurationApi - functional programming interface
 * <p>Create a new notification configuration</p>
 * @export
 */
export const createNotificationConfigurationFn = ({
 body,
 }: CreateNotificationConfigurationParams, options: any = {}, configuration?: Configuration): Promise<CreateNotificationConfigurationSuccess> => {
  const localVarFetchArgs = NotificationConfigurationsApiFetchParamCreator(configuration).createNotificationConfiguration(body, options);
  return requestFetch<CreateNotificationConfigurationSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createNotificationConfiguration = toResponsePromiseWithMeta<
  CreateNotificationConfigurationError,
  CreateNotificationConfigurationSuccess,
  CreateNotificationConfigurationParams
>(createNotificationConfigurationFn);

export const createNotificationConfigurationObservable = toResponseObservableWithMeta<
  CreateNotificationConfigurationError,
  CreateNotificationConfigurationSuccess,
  CreateNotificationConfigurationParams
>(createNotificationConfigurationFn);

export interface DeleteNotificationConfigurationParams {
  notificationConfigurationIdOrUrn: string;
}

export type DeleteNotificationConfigurationSuccess = void;
export type DeleteNotificationConfigurationError = HTTPError | Api.NotificationConfigurationByIdErrors | Api.NotificationConfigurationNotFound | Api.NotificationConfigurationError;

/**
 * DeleteNotificationConfigurationApi - functional programming interface
 * <p>Delete the notification configuration</p>
 * @export
 */
export const deleteNotificationConfigurationFn = ({
  notificationConfigurationIdOrUrn,
 }: DeleteNotificationConfigurationParams, options: any = {}, configuration?: Configuration): Promise<DeleteNotificationConfigurationSuccess> => {
  const localVarFetchArgs = NotificationConfigurationsApiFetchParamCreator(configuration).deleteNotificationConfiguration(notificationConfigurationIdOrUrn, options);
  return requestFetch<DeleteNotificationConfigurationSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteNotificationConfiguration = toResponsePromiseWithMeta<
  DeleteNotificationConfigurationError,
  DeleteNotificationConfigurationSuccess,
  DeleteNotificationConfigurationParams
>(deleteNotificationConfigurationFn);

export const deleteNotificationConfigurationObservable = toResponseObservableWithMeta<
  DeleteNotificationConfigurationError,
  DeleteNotificationConfigurationSuccess,
  DeleteNotificationConfigurationParams
>(deleteNotificationConfigurationFn);

export interface GetNotificationConfigurationParams {
  notificationConfigurationIdOrUrn: string;
}

export type GetNotificationConfigurationSuccess = Api.NotificationConfigurationReadSchema;
export type GetNotificationConfigurationError = HTTPError | Api.NotificationConfigurationByIdErrors | Api.NotificationConfigurationNotFound | Api.NotificationConfigurationError;

/**
 * GetNotificationConfigurationApi - functional programming interface
 * <p>Get the notification configuration</p>
 * @export
 */
export const getNotificationConfigurationFn = ({
  notificationConfigurationIdOrUrn,
 }: GetNotificationConfigurationParams, options: any = {}, configuration?: Configuration): Promise<GetNotificationConfigurationSuccess> => {
  const localVarFetchArgs = NotificationConfigurationsApiFetchParamCreator(configuration).getNotificationConfiguration(notificationConfigurationIdOrUrn, options);
  return requestFetch<GetNotificationConfigurationSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getNotificationConfiguration = toResponsePromiseWithMeta<
  GetNotificationConfigurationError,
  GetNotificationConfigurationSuccess,
  GetNotificationConfigurationParams
>(getNotificationConfigurationFn);

export const getNotificationConfigurationObservable = toResponseObservableWithMeta<
  GetNotificationConfigurationError,
  GetNotificationConfigurationSuccess,
  GetNotificationConfigurationParams
>(getNotificationConfigurationFn);

export interface GetNotificationConfigurationChannelsParams {
  notificationConfigurationIdOrUrn: string;
}

export type GetNotificationConfigurationChannelsSuccess = Api.NotificationChannel[];
export type GetNotificationConfigurationChannelsError = HTTPError | Api.NotificationConfigurationByIdErrors | Api.NotificationConfigurationNotFound | Api.NotificationConfigurationError;

/**
 * GetNotificationConfigurationChannelsApi - functional programming interface
 * <p>Get the channels for the notification configuration</p>
 * @export
 */
export const getNotificationConfigurationChannelsFn = ({
  notificationConfigurationIdOrUrn,
 }: GetNotificationConfigurationChannelsParams, options: any = {}, configuration?: Configuration): Promise<GetNotificationConfigurationChannelsSuccess> => {
  const localVarFetchArgs = NotificationConfigurationsApiFetchParamCreator(configuration).getNotificationConfigurationChannels(notificationConfigurationIdOrUrn, options);
  return requestFetch<GetNotificationConfigurationChannelsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getNotificationConfigurationChannels = toResponsePromiseWithMeta<
  GetNotificationConfigurationChannelsError,
  GetNotificationConfigurationChannelsSuccess,
  GetNotificationConfigurationChannelsParams
>(getNotificationConfigurationChannelsFn);

export const getNotificationConfigurationChannelsObservable = toResponseObservableWithMeta<
  GetNotificationConfigurationChannelsError,
  GetNotificationConfigurationChannelsSuccess,
  GetNotificationConfigurationChannelsParams
>(getNotificationConfigurationChannelsFn);

export interface GetNotificationConfigurationsParams {
}

export type GetNotificationConfigurationsSuccess = Api.NotificationConfigurationReadSchema[];
export type GetNotificationConfigurationsError = HTTPError | Api.NotificationConfigurationError | Api.NotificationConfigurationError;

/**
 * GetNotificationConfigurationsApi - functional programming interface
 * <p>Get all notification configurations</p>
 * @export
 */
export const getNotificationConfigurationsFn = ({
 }: GetNotificationConfigurationsParams, options: any = {}, configuration?: Configuration): Promise<GetNotificationConfigurationsSuccess> => {
  const localVarFetchArgs = NotificationConfigurationsApiFetchParamCreator(configuration).getNotificationConfigurations(options);
  return requestFetch<GetNotificationConfigurationsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getNotificationConfigurations = toResponsePromiseWithMeta<
  GetNotificationConfigurationsError,
  GetNotificationConfigurationsSuccess,
  GetNotificationConfigurationsParams
>(getNotificationConfigurationsFn);

export const getNotificationConfigurationsObservable = toResponseObservableWithMeta<
  GetNotificationConfigurationsError,
  GetNotificationConfigurationsSuccess,
  GetNotificationConfigurationsParams
>(getNotificationConfigurationsFn);

export interface UpdateNotificationConfigurationParams {
  notificationConfigurationIdOrUrn: string;
  body: Api.NotificationConfigurationWriteSchema;
}

export type UpdateNotificationConfigurationSuccess = Api.NotificationConfigurationReadSchema;
export type UpdateNotificationConfigurationError = HTTPError | Api.NotificationConfigurationByIdErrors | Api.NotificationConfigurationNotFound | Api.NotificationConfigurationError;

/**
 * UpdateNotificationConfigurationApi - functional programming interface
 * <p>Update the notification configuration</p>
 * @export
 */
export const updateNotificationConfigurationFn = ({
  notificationConfigurationIdOrUrn,
 body,
 }: UpdateNotificationConfigurationParams, options: any = {}, configuration?: Configuration): Promise<UpdateNotificationConfigurationSuccess> => {
  const localVarFetchArgs = NotificationConfigurationsApiFetchParamCreator(configuration).updateNotificationConfiguration(notificationConfigurationIdOrUrn, body, options);
  return requestFetch<UpdateNotificationConfigurationSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const updateNotificationConfiguration = toResponsePromiseWithMeta<
  UpdateNotificationConfigurationError,
  UpdateNotificationConfigurationSuccess,
  UpdateNotificationConfigurationParams
>(updateNotificationConfigurationFn);

export const updateNotificationConfigurationObservable = toResponseObservableWithMeta<
  UpdateNotificationConfigurationError,
  UpdateNotificationConfigurationSuccess,
  UpdateNotificationConfigurationParams
>(updateNotificationConfigurationFn);

/**
 * OtelMappingApi - fetch parameter creator
 * @export
 */
export const OtelMappingApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteOtelComponentMapping(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/otel-component-mappings/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		deleteOtelRelationMapping(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/otel-relation-mappings/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		getOtelComponentMapping(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/otel-component-mappings/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getOtelComponentMappings(options: any = {}): FetchArgs {
			const localVarPath = `/otel-component-mappings`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		getOtelComponentMappingStatus(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/otel-component-mappings/{identifier}/status`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		getOtelRelationMapping(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/otel-relation-mappings/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getOtelRelationMappings(options: any = {}): FetchArgs {
			const localVarPath = `/otel-relation-mappings`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier
		 * @param {*} [options] Override http request option.
		 */
		getOtelRelationMappingStatus(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/otel-relation-mappings/{identifier}/status`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.OtelComponentMappingUpsertRequest} request Otel Component Mapping to create/update
		 * @param {*} [options] Override http request option.
		 */
		upsertOtelComponentMappings(request: Api.OtelComponentMappingUpsertRequest, options: any = {}): FetchArgs {
			const localVarPath = `/otel-component-mappings`;
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.OtelRelationmappingUpsertRequest} request Otel Relation Mapping to create/update
		 * @param {*} [options] Override http request option.
		 */
		upsertOtelRelationMappings(request: Api.OtelRelationmappingUpsertRequest, options: any = {}): FetchArgs {
			const localVarPath = `/otel-relation-mappings`;
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* OtelMapping
*/
export interface DeleteOtelComponentMappingParams {
  identifier: string;
}

export type DeleteOtelComponentMappingSuccess = void;
export type DeleteOtelComponentMappingError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError | Api.OtelMappingApiError;

/**
 * DeleteOtelComponentMappingApi - functional programming interface
 * @export
 */
export const deleteOtelComponentMappingFn = ({
  identifier,
 }: DeleteOtelComponentMappingParams, options: any = {}, configuration?: Configuration): Promise<DeleteOtelComponentMappingSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).deleteOtelComponentMapping(identifier, options);
  return requestFetch<DeleteOtelComponentMappingSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteOtelComponentMapping = toResponsePromiseWithMeta<
  DeleteOtelComponentMappingError,
  DeleteOtelComponentMappingSuccess,
  DeleteOtelComponentMappingParams
>(deleteOtelComponentMappingFn);

export const deleteOtelComponentMappingObservable = toResponseObservableWithMeta<
  DeleteOtelComponentMappingError,
  DeleteOtelComponentMappingSuccess,
  DeleteOtelComponentMappingParams
>(deleteOtelComponentMappingFn);

export interface DeleteOtelRelationMappingParams {
  identifier: string;
}

export type DeleteOtelRelationMappingSuccess = void;
export type DeleteOtelRelationMappingError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError | Api.OtelMappingApiError;

/**
 * DeleteOtelRelationMappingApi - functional programming interface
 * @export
 */
export const deleteOtelRelationMappingFn = ({
  identifier,
 }: DeleteOtelRelationMappingParams, options: any = {}, configuration?: Configuration): Promise<DeleteOtelRelationMappingSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).deleteOtelRelationMapping(identifier, options);
  return requestFetch<DeleteOtelRelationMappingSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteOtelRelationMapping = toResponsePromiseWithMeta<
  DeleteOtelRelationMappingError,
  DeleteOtelRelationMappingSuccess,
  DeleteOtelRelationMappingParams
>(deleteOtelRelationMappingFn);

export const deleteOtelRelationMappingObservable = toResponseObservableWithMeta<
  DeleteOtelRelationMappingError,
  DeleteOtelRelationMappingSuccess,
  DeleteOtelRelationMappingParams
>(deleteOtelRelationMappingFn);

export interface GetOtelComponentMappingParams {
  identifier: string;
}

export type GetOtelComponentMappingSuccess = Api.OtelComponentMapping;
export type GetOtelComponentMappingError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError | Api.OtelMappingApiError;

/**
 * GetOtelComponentMappingApi - functional programming interface
 * @export
 */
export const getOtelComponentMappingFn = ({
  identifier,
 }: GetOtelComponentMappingParams, options: any = {}, configuration?: Configuration): Promise<GetOtelComponentMappingSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).getOtelComponentMapping(identifier, options);
  return requestFetch<GetOtelComponentMappingSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOtelComponentMapping = toResponsePromiseWithMeta<
  GetOtelComponentMappingError,
  GetOtelComponentMappingSuccess,
  GetOtelComponentMappingParams
>(getOtelComponentMappingFn);

export const getOtelComponentMappingObservable = toResponseObservableWithMeta<
  GetOtelComponentMappingError,
  GetOtelComponentMappingSuccess,
  GetOtelComponentMappingParams
>(getOtelComponentMappingFn);

export interface GetOtelComponentMappingsParams {
}

export type GetOtelComponentMappingsSuccess = Api.OtelMappingItem[];
export type GetOtelComponentMappingsError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError;

/**
 * GetOtelComponentMappingsApi - functional programming interface
 * @export
 */
export const getOtelComponentMappingsFn = ({
 }: GetOtelComponentMappingsParams, options: any = {}, configuration?: Configuration): Promise<GetOtelComponentMappingsSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).getOtelComponentMappings(options);
  return requestFetch<GetOtelComponentMappingsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOtelComponentMappings = toResponsePromiseWithMeta<
  GetOtelComponentMappingsError,
  GetOtelComponentMappingsSuccess,
  GetOtelComponentMappingsParams
>(getOtelComponentMappingsFn);

export const getOtelComponentMappingsObservable = toResponseObservableWithMeta<
  GetOtelComponentMappingsError,
  GetOtelComponentMappingsSuccess,
  GetOtelComponentMappingsParams
>(getOtelComponentMappingsFn);

export interface GetOtelComponentMappingStatusParams {
  identifier: string;
}

export type GetOtelComponentMappingStatusSuccess = Api.OtelMappingStatus;
export type GetOtelComponentMappingStatusError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError | Api.OtelMappingApiError;

/**
 * GetOtelComponentMappingStatusApi - functional programming interface
 * @export
 */
export const getOtelComponentMappingStatusFn = ({
  identifier,
 }: GetOtelComponentMappingStatusParams, options: any = {}, configuration?: Configuration): Promise<GetOtelComponentMappingStatusSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).getOtelComponentMappingStatus(identifier, options);
  return requestFetch<GetOtelComponentMappingStatusSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOtelComponentMappingStatus = toResponsePromiseWithMeta<
  GetOtelComponentMappingStatusError,
  GetOtelComponentMappingStatusSuccess,
  GetOtelComponentMappingStatusParams
>(getOtelComponentMappingStatusFn);

export const getOtelComponentMappingStatusObservable = toResponseObservableWithMeta<
  GetOtelComponentMappingStatusError,
  GetOtelComponentMappingStatusSuccess,
  GetOtelComponentMappingStatusParams
>(getOtelComponentMappingStatusFn);

export interface GetOtelRelationMappingParams {
  identifier: string;
}

export type GetOtelRelationMappingSuccess = Api.OtelRelationMapping;
export type GetOtelRelationMappingError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError | Api.OtelMappingApiError;

/**
 * GetOtelRelationMappingApi - functional programming interface
 * @export
 */
export const getOtelRelationMappingFn = ({
  identifier,
 }: GetOtelRelationMappingParams, options: any = {}, configuration?: Configuration): Promise<GetOtelRelationMappingSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).getOtelRelationMapping(identifier, options);
  return requestFetch<GetOtelRelationMappingSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOtelRelationMapping = toResponsePromiseWithMeta<
  GetOtelRelationMappingError,
  GetOtelRelationMappingSuccess,
  GetOtelRelationMappingParams
>(getOtelRelationMappingFn);

export const getOtelRelationMappingObservable = toResponseObservableWithMeta<
  GetOtelRelationMappingError,
  GetOtelRelationMappingSuccess,
  GetOtelRelationMappingParams
>(getOtelRelationMappingFn);

export interface GetOtelRelationMappingsParams {
}

export type GetOtelRelationMappingsSuccess = Api.OtelMappingItem[];
export type GetOtelRelationMappingsError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError;

/**
 * GetOtelRelationMappingsApi - functional programming interface
 * @export
 */
export const getOtelRelationMappingsFn = ({
 }: GetOtelRelationMappingsParams, options: any = {}, configuration?: Configuration): Promise<GetOtelRelationMappingsSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).getOtelRelationMappings(options);
  return requestFetch<GetOtelRelationMappingsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOtelRelationMappings = toResponsePromiseWithMeta<
  GetOtelRelationMappingsError,
  GetOtelRelationMappingsSuccess,
  GetOtelRelationMappingsParams
>(getOtelRelationMappingsFn);

export const getOtelRelationMappingsObservable = toResponseObservableWithMeta<
  GetOtelRelationMappingsError,
  GetOtelRelationMappingsSuccess,
  GetOtelRelationMappingsParams
>(getOtelRelationMappingsFn);

export interface GetOtelRelationMappingStatusParams {
  identifier: string;
}

export type GetOtelRelationMappingStatusSuccess = Api.OtelMappingStatus;
export type GetOtelRelationMappingStatusError = HTTPError | "Unauthorized" | "Forbidden" | Api.OtelMappingApiError | Api.OtelMappingApiError;

/**
 * GetOtelRelationMappingStatusApi - functional programming interface
 * @export
 */
export const getOtelRelationMappingStatusFn = ({
  identifier,
 }: GetOtelRelationMappingStatusParams, options: any = {}, configuration?: Configuration): Promise<GetOtelRelationMappingStatusSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).getOtelRelationMappingStatus(identifier, options);
  return requestFetch<GetOtelRelationMappingStatusSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOtelRelationMappingStatus = toResponsePromiseWithMeta<
  GetOtelRelationMappingStatusError,
  GetOtelRelationMappingStatusSuccess,
  GetOtelRelationMappingStatusParams
>(getOtelRelationMappingStatusFn);

export const getOtelRelationMappingStatusObservable = toResponseObservableWithMeta<
  GetOtelRelationMappingStatusError,
  GetOtelRelationMappingStatusSuccess,
  GetOtelRelationMappingStatusParams
>(getOtelRelationMappingStatusFn);

export interface UpsertOtelComponentMappingsParams {
  body: Api.OtelComponentMappingUpsertRequest;
}

export type UpsertOtelComponentMappingsSuccess = Api.OtelMappingItem;
export type UpsertOtelComponentMappingsError = HTTPError | Api.OtelMappingApiError | "Unauthorized" | "Forbidden" | Api.GenericErrorsResponse;

/**
 * UpsertOtelComponentMappingsApi - functional programming interface
 * @export
 */
export const upsertOtelComponentMappingsFn = ({
 body,
 }: UpsertOtelComponentMappingsParams, options: any = {}, configuration?: Configuration): Promise<UpsertOtelComponentMappingsSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).upsertOtelComponentMappings(body, options);
  return requestFetch<UpsertOtelComponentMappingsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const upsertOtelComponentMappings = toResponsePromiseWithMeta<
  UpsertOtelComponentMappingsError,
  UpsertOtelComponentMappingsSuccess,
  UpsertOtelComponentMappingsParams
>(upsertOtelComponentMappingsFn);

export const upsertOtelComponentMappingsObservable = toResponseObservableWithMeta<
  UpsertOtelComponentMappingsError,
  UpsertOtelComponentMappingsSuccess,
  UpsertOtelComponentMappingsParams
>(upsertOtelComponentMappingsFn);

export interface UpsertOtelRelationMappingsParams {
  body: Api.OtelRelationmappingUpsertRequest;
}

export type UpsertOtelRelationMappingsSuccess = Api.OtelMappingItem;
export type UpsertOtelRelationMappingsError = HTTPError | Api.OtelMappingApiError | "Unauthorized" | "Forbidden" | Api.GenericErrorsResponse;

/**
 * UpsertOtelRelationMappingsApi - functional programming interface
 * @export
 */
export const upsertOtelRelationMappingsFn = ({
 body,
 }: UpsertOtelRelationMappingsParams, options: any = {}, configuration?: Configuration): Promise<UpsertOtelRelationMappingsSuccess> => {
  const localVarFetchArgs = OtelMappingApiFetchParamCreator(configuration).upsertOtelRelationMappings(body, options);
  return requestFetch<UpsertOtelRelationMappingsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const upsertOtelRelationMappings = toResponsePromiseWithMeta<
  UpsertOtelRelationMappingsError,
  UpsertOtelRelationMappingsSuccess,
  UpsertOtelRelationMappingsParams
>(upsertOtelRelationMappingsFn);

export const upsertOtelRelationMappingsObservable = toResponseObservableWithMeta<
  UpsertOtelRelationMappingsError,
  UpsertOtelRelationMappingsSuccess,
  UpsertOtelRelationMappingsParams
>(upsertOtelRelationMappingsFn);

/**
 * OverviewApi - fetch parameter creator
 * @export
 */
export const OverviewApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} presentationOrViewUrn A Component Presentation Identifier, legacy View (QueryView, ViewType) URNs are be supported for backward compatibility
		 * @param {Api.OverviewRequest} request
		 * @param {*} [options] Override http request option.
		 */
		getOverview(presentationOrViewUrn: string, request: Api.OverviewRequest, options: any = {}): FetchArgs {
			const localVarPath = `/overview/{presentationOrViewUrn}`
				.replace('{presentationOrViewUrn}', encodeURIComponent(String(presentationOrViewUrn)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Overview
*/
export interface GetOverviewParams {
  presentationOrViewUrn: string;
  body: Api.OverviewRequest;
}

export type GetOverviewSuccess = Api.OverviewPageResponse;
export type GetOverviewError = HTTPError | Api.OverviewErrorResponse | Api.OverviewErrorResponse;

/**
 * GetOverviewApi - functional programming interface
 * @export
 */
export const getOverviewFn = ({
  presentationOrViewUrn,
 body,
 }: GetOverviewParams, options: any = {}, configuration?: Configuration): Promise<GetOverviewSuccess> => {
  const localVarFetchArgs = OverviewApiFetchParamCreator(configuration).getOverview(presentationOrViewUrn, body, options);
  return requestFetch<GetOverviewSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getOverview = toResponsePromiseWithMeta<
  GetOverviewError,
  GetOverviewSuccess,
  GetOverviewParams
>(getOverviewFn);

export const getOverviewObservable = toResponseObservableWithMeta<
  GetOverviewError,
  GetOverviewSuccess,
  GetOverviewParams
>(getOverviewFn);

/**
 * PermissionsApi - fetch parameter creator
 * @export
 */
export const PermissionsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} subject
		 * @param {string} [resource]
		 * @param {string} [permission]
		 * @param {Api.SubjectSource} [source]
		 * @param {*} [options] Override http request option.
		 */
		describePermissions(subject: string, resource: string | undefined, permission: string | undefined, source: Api.SubjectSource | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/security/permissions/{subject}`
				.replace('{subject}', encodeURIComponent(String(subject)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (resource !== undefined) {
				localVarQueryParameter['resource'] = resource;
			}
			if (permission !== undefined) {
				localVarQueryParameter['permission'] = permission;
			}
			if (source !== undefined) {
				localVarQueryParameter['source'] = source;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getPermissions(options: any = {}): FetchArgs {
			const localVarPath = `/security/permissions/list`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} subject
		 * @param {Api.GrantPermission} request
		 * @param {*} [options] Override http request option.
		 */
		grantPermissions(subject: string, request: Api.GrantPermission, options: any = {}): FetchArgs {
			const localVarPath = `/security/permissions/{subject}`
				.replace('{subject}', encodeURIComponent(String(subject)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} subject
		 * @param {string} [resource]
		 * @param {string} [permission]
		 * @param {*} [options] Override http request option.
		 */
		revokePermissions(subject: string, resource: string | undefined, permission: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/security/permissions/{subject}`
				.replace('{subject}', encodeURIComponent(String(subject)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (resource !== undefined) {
				localVarQueryParameter['resource'] = resource;
			}
			if (permission !== undefined) {
				localVarQueryParameter['permission'] = permission;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Permissions
*/
export interface DescribePermissionsParams {
  subject: string;
  resource?: string;
  permission?: string;
  source?: Api.SubjectSource;
}

export type DescribePermissionsSuccess = Api.PermissionDescription;
export type DescribePermissionsError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * DescribePermissionsApi - functional programming interface
 * <p>Describe permissions granted to a subject</p>
 * @export
 */
export const describePermissionsFn = ({
  subject,
  resource,
  permission,
  source,
 }: DescribePermissionsParams, options: any = {}, configuration?: Configuration): Promise<DescribePermissionsSuccess> => {
  const localVarFetchArgs = PermissionsApiFetchParamCreator(configuration).describePermissions(subject, resource, permission, source, options);
  return requestFetch<DescribePermissionsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const describePermissions = toResponsePromiseWithMeta<
  DescribePermissionsError,
  DescribePermissionsSuccess,
  DescribePermissionsParams
>(describePermissionsFn);

export const describePermissionsObservable = toResponseObservableWithMeta<
  DescribePermissionsError,
  DescribePermissionsSuccess,
  DescribePermissionsParams
>(describePermissionsFn);

export interface GetPermissionsParams {
}

export type GetPermissionsSuccess = Api.Permissions;
export type GetPermissionsError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetPermissionsApi - functional programming interface
 * <p>Get a list of available permissions</p>
 * @export
 */
export const getPermissionsFn = ({
 }: GetPermissionsParams, options: any = {}, configuration?: Configuration): Promise<GetPermissionsSuccess> => {
  const localVarFetchArgs = PermissionsApiFetchParamCreator(configuration).getPermissions(options);
  return requestFetch<GetPermissionsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getPermissions = toResponsePromiseWithMeta<
  GetPermissionsError,
  GetPermissionsSuccess,
  GetPermissionsParams
>(getPermissionsFn);

export const getPermissionsObservable = toResponseObservableWithMeta<
  GetPermissionsError,
  GetPermissionsSuccess,
  GetPermissionsParams
>(getPermissionsFn);

export interface GrantPermissionsParams {
  subject: string;
  body: Api.GrantPermission;
}

export type GrantPermissionsSuccess = void;
export type GrantPermissionsError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * GrantPermissionsApi - functional programming interface
 * <p>Grant permissions to a subject</p>
 * @export
 */
export const grantPermissionsFn = ({
  subject,
 body,
 }: GrantPermissionsParams, options: any = {}, configuration?: Configuration): Promise<GrantPermissionsSuccess> => {
  const localVarFetchArgs = PermissionsApiFetchParamCreator(configuration).grantPermissions(subject, body, options);
  return requestFetch<GrantPermissionsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const grantPermissions = toResponsePromiseWithMeta<
  GrantPermissionsError,
  GrantPermissionsSuccess,
  GrantPermissionsParams
>(grantPermissionsFn);

export const grantPermissionsObservable = toResponseObservableWithMeta<
  GrantPermissionsError,
  GrantPermissionsSuccess,
  GrantPermissionsParams
>(grantPermissionsFn);

export interface RevokePermissionsParams {
  subject: string;
  resource?: string;
  permission?: string;
}

export type RevokePermissionsSuccess = void;
export type RevokePermissionsError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * RevokePermissionsApi - functional programming interface
 * <p>Revoke permissions of a subject</p>
 * @export
 */
export const revokePermissionsFn = ({
  subject,
  resource,
  permission,
 }: RevokePermissionsParams, options: any = {}, configuration?: Configuration): Promise<RevokePermissionsSuccess> => {
  const localVarFetchArgs = PermissionsApiFetchParamCreator(configuration).revokePermissions(subject, resource, permission, options);
  return requestFetch<RevokePermissionsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const revokePermissions = toResponsePromiseWithMeta<
  RevokePermissionsError,
  RevokePermissionsSuccess,
  RevokePermissionsParams
>(revokePermissionsFn);

export const revokePermissionsObservable = toResponseObservableWithMeta<
  RevokePermissionsError,
  RevokePermissionsSuccess,
  RevokePermissionsParams
>(revokePermissionsFn);

/**
 * PerspectivesApi - fetch parameter creator
 * @export
 */
export const PerspectivesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} presentationOrViewUrn A Component Presentation Identifier, legacy View (QueryView, ViewType) URNs are supported for backward compatibility
		 * @param {*} [options] Override http request option.
		 */
		getPerspectives(presentationOrViewUrn: string, options: any = {}): FetchArgs {
			const localVarPath = `/perspectives/{presentationOrViewUrn}`
				.replace('{presentationOrViewUrn}', encodeURIComponent(String(presentationOrViewUrn)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Perspectives
*/
export interface GetPerspectivesParams {
  presentationOrViewUrn: string;
}

export type GetPerspectivesSuccess = Api.Perspectives;
export type GetPerspectivesError = HTTPError | "Unauthorized" | "Forbidden" | Api.PerspectivesApiError | Api.PerspectivesApiError;

/**
 * GetPerspectivesApi - functional programming interface
 * <p>Returns the perspectives, and the per-perspective configs that are available.</p>
<p>Acts as the canonical view-open permission check: returns 403 when the
caller lacks access and 404 when the URN does not resolve.</p>
 * @export
 */
export const getPerspectivesFn = ({
  presentationOrViewUrn,
 }: GetPerspectivesParams, options: any = {}, configuration?: Configuration): Promise<GetPerspectivesSuccess> => {
  const localVarFetchArgs = PerspectivesApiFetchParamCreator(configuration).getPerspectives(presentationOrViewUrn, options);
  return requestFetch<GetPerspectivesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getPerspectives = toResponsePromiseWithMeta<
  GetPerspectivesError,
  GetPerspectivesSuccess,
  GetPerspectivesParams
>(getPerspectivesFn);

export const getPerspectivesObservable = toResponseObservableWithMeta<
  GetPerspectivesError,
  GetPerspectivesSuccess,
  GetPerspectivesParams
>(getPerspectivesFn);

/**
 * ProblemApi - fetch parameter creator
 * @export
 */
export const ProblemApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {number} problemId The problem id number.
		 * @param {number} [topologyTime] A timestamp at which resources will be queried. If not given the resources are queried for current time.
		 * @param {number} [limit] Maximum number of resources to be returned in result.
		 * @param {*} [options] Override http request option.
		 */
		getProblemCausingEvents(problemId: number, topologyTime: number | undefined, limit: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/problems/{problemId}/causing-events`
				.replace('{problemId}', encodeURIComponent(String(problemId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Problem
*/
export interface GetProblemCausingEventsParams {
  problemId: number;
  topologyTime?: number;
  limit?: number;
}

export type GetProblemCausingEventsSuccess = Api.GetCausingEventsResult;
export type GetProblemCausingEventsError = HTTPError | Api.GetCausingEventsBadRequest | Api.GetCausingEventsNotFound | Api.GenericErrorsResponse | Api.GetCausingEventsServiceUnaivailable;

/**
 * GetProblemCausingEventsApi - functional programming interface
 * <p>Resulting events are ordered by likeness to be an actual problem cause</p>
 * @export
 */
export const getProblemCausingEventsFn = ({
  problemId,
  topologyTime,
  limit,
 }: GetProblemCausingEventsParams, options: any = {}, configuration?: Configuration): Promise<GetProblemCausingEventsSuccess> => {
  const localVarFetchArgs = ProblemApiFetchParamCreator(configuration).getProblemCausingEvents(problemId, topologyTime, limit, options);
  return requestFetch<GetProblemCausingEventsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getProblemCausingEvents = toResponsePromiseWithMeta<
  GetProblemCausingEventsError,
  GetProblemCausingEventsSuccess,
  GetProblemCausingEventsParams
>(getProblemCausingEventsFn);

export const getProblemCausingEventsObservable = toResponseObservableWithMeta<
  GetProblemCausingEventsError,
  GetProblemCausingEventsSuccess,
  GetProblemCausingEventsParams
>(getProblemCausingEventsFn);

/**
 * RelationApi - fetch parameter creator
 * @export
 */
export const RelationApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {number} relationId The id of a relation
		 * @param {number} [topologyTime] A timestamp at which resources will be queried. If not given the resources are queried at current time.
		 * @param {*} [options] Override http request option.
		 */
		getFullRelation(relationId: number, topologyTime: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/relations/{relationId}`
				.replace('{relationId}', encodeURIComponent(String(relationId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (topologyTime !== undefined) {
				localVarQueryParameter['topologyTime'] = topologyTime;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Relation
*/
export interface GetFullRelationParams {
  relationId: number;
  topologyTime?: number;
}

export type GetFullRelationSuccess = Api.FullRelation;
export type GetFullRelationError = HTTPError | Api.StackElementNotFound | Api.GenericErrorsResponse;

/**
 * GetFullRelationApi - functional programming interface
 * <p>Get full relation details</p>
 * @export
 */
export const getFullRelationFn = ({
  relationId,
  topologyTime,
 }: GetFullRelationParams, options: any = {}, configuration?: Configuration): Promise<GetFullRelationSuccess> => {
  const localVarFetchArgs = RelationApiFetchParamCreator(configuration).getFullRelation(relationId, topologyTime, options);
  return requestFetch<GetFullRelationSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getFullRelation = toResponsePromiseWithMeta<
  GetFullRelationError,
  GetFullRelationSuccess,
  GetFullRelationParams
>(getFullRelationFn);

export const getFullRelationObservable = toResponseObservableWithMeta<
  GetFullRelationError,
  GetFullRelationSuccess,
  GetFullRelationParams
>(getFullRelationFn);

/**
 * ScriptingApi - fetch parameter creator
 * @export
 */
export const ScriptingApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {Api.ExecuteScriptRequest} request
		 * @param {*} [options] Override http request option.
		 */
		scriptExecute(request: Api.ExecuteScriptRequest, options: any = {}): FetchArgs {
			const localVarPath = `/script/execute`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Scripting
*/
export interface ScriptExecuteParams {
  body: Api.ExecuteScriptRequest;
}

export type ScriptExecuteSuccess = Api.ExecuteScriptResponse;
export type ScriptExecuteError = HTTPError | Api.ExecuteScriptError | Api.ExecuteScriptTimeoutError | Api.GenericErrorsResponse;

/**
 * ScriptExecuteApi - functional programming interface
 * <p>Execute a StackState Scripting Language or Template Language script with arbitrary arguments.</p>
 * @export
 */
export const scriptExecuteFn = ({
 body,
 }: ScriptExecuteParams, options: any = {}, configuration?: Configuration): Promise<ScriptExecuteSuccess> => {
  const localVarFetchArgs = ScriptingApiFetchParamCreator(configuration).scriptExecute(body, options);
  return requestFetch<ScriptExecuteSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const scriptExecute = toResponsePromiseWithMeta<
  ScriptExecuteError,
  ScriptExecuteSuccess,
  ScriptExecuteParams
>(scriptExecuteFn);

export const scriptExecuteObservable = toResponseObservableWithMeta<
  ScriptExecuteError,
  ScriptExecuteSuccess,
  ScriptExecuteParams
>(scriptExecuteFn);

/**
 * ServerApi - fetch parameter creator
 * @export
 */
export const ServerApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		serverInfo(options: any = {}): FetchArgs {
			const localVarPath = `/server/info`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Server
*/
export interface ServerInfoParams {
}

export type ServerInfoSuccess = Api.ServerInfo;
export type ServerInfoError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * ServerInfoApi - functional programming interface
 * <p>Get information of the StackState information, such as version, deployment mode, etc.</p>
 * @export
 */
export const serverInfoFn = ({
 }: ServerInfoParams, options: any = {}, configuration?: Configuration): Promise<ServerInfoSuccess> => {
  const localVarFetchArgs = ServerApiFetchParamCreator(configuration).serverInfo(options);
  return requestFetch<ServerInfoSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const serverInfo = toResponsePromiseWithMeta<
  ServerInfoError,
  ServerInfoSuccess,
  ServerInfoParams
>(serverInfoFn);

export const serverInfoObservable = toResponseObservableWithMeta<
  ServerInfoError,
  ServerInfoSuccess,
  ServerInfoParams
>(serverInfoFn);

/**
 * ServiceTokenApi - fetch parameter creator
 * @export
 */
export const ServiceTokenApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {Api.NewServiceTokenRequest} request
		 * @param {*} [options] Override http request option.
		 */
		createNewServiceToken(request: Api.NewServiceTokenRequest, options: any = {}): FetchArgs {
			const localVarPath = `/security/tokens`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} serviceTokenId The identifier of a service token
		 * @param {*} [options] Override http request option.
		 */
		deleteServiceToken(serviceTokenId: number, options: any = {}): FetchArgs {
			const localVarPath = `/security/tokens/{serviceTokenId}`
				.replace('{serviceTokenId}', encodeURIComponent(String(serviceTokenId)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getServiceTokens(options: any = {}): FetchArgs {
			const localVarPath = `/security/tokens`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* ServiceToken
*/
export interface CreateNewServiceTokenParams {
  body: Api.NewServiceTokenRequest;
}

export type CreateNewServiceTokenSuccess = Api.ServiceTokenCreatedResponse;
export type CreateNewServiceTokenError = HTTPError | Api.ServiceTokenCreateError | Api.GenericErrorsResponse;

/**
 * CreateNewServiceTokenApi - functional programming interface
 * <p>Create new service token.</p>
 * @export
 */
export const createNewServiceTokenFn = ({
 body,
 }: CreateNewServiceTokenParams, options: any = {}, configuration?: Configuration): Promise<CreateNewServiceTokenSuccess> => {
  const localVarFetchArgs = ServiceTokenApiFetchParamCreator(configuration).createNewServiceToken(body, options);
  return requestFetch<CreateNewServiceTokenSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createNewServiceToken = toResponsePromiseWithMeta<
  CreateNewServiceTokenError,
  CreateNewServiceTokenSuccess,
  CreateNewServiceTokenParams
>(createNewServiceTokenFn);

export const createNewServiceTokenObservable = toResponseObservableWithMeta<
  CreateNewServiceTokenError,
  CreateNewServiceTokenSuccess,
  CreateNewServiceTokenParams
>(createNewServiceTokenFn);

export interface DeleteServiceTokenParams {
  serviceTokenId: number;
}

export type DeleteServiceTokenSuccess = void;
export type DeleteServiceTokenError = HTTPError | Api.GenericErrorsResponse;

/**
 * DeleteServiceTokenApi - functional programming interface
 * <p>Delete service token.</p>
 * @export
 */
export const deleteServiceTokenFn = ({
  serviceTokenId,
 }: DeleteServiceTokenParams, options: any = {}, configuration?: Configuration): Promise<DeleteServiceTokenSuccess> => {
  const localVarFetchArgs = ServiceTokenApiFetchParamCreator(configuration).deleteServiceToken(serviceTokenId, options);
  return requestFetch<DeleteServiceTokenSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteServiceToken = toResponsePromiseWithMeta<
  DeleteServiceTokenError,
  DeleteServiceTokenSuccess,
  DeleteServiceTokenParams
>(deleteServiceTokenFn);

export const deleteServiceTokenObservable = toResponseObservableWithMeta<
  DeleteServiceTokenError,
  DeleteServiceTokenSuccess,
  DeleteServiceTokenParams
>(deleteServiceTokenFn);

export interface GetServiceTokensParams {
}

export type GetServiceTokensSuccess = Api.ServiceToken[];
export type GetServiceTokensError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetServiceTokensApi - functional programming interface
 * <p>Get service tokens.</p>
 * @export
 */
export const getServiceTokensFn = ({
 }: GetServiceTokensParams, options: any = {}, configuration?: Configuration): Promise<GetServiceTokensSuccess> => {
  const localVarFetchArgs = ServiceTokenApiFetchParamCreator(configuration).getServiceTokens(options);
  return requestFetch<GetServiceTokensSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getServiceTokens = toResponsePromiseWithMeta<
  GetServiceTokensError,
  GetServiceTokensSuccess,
  GetServiceTokensParams
>(getServiceTokensFn);

export const getServiceTokensObservable = toResponseObservableWithMeta<
  GetServiceTokensError,
  GetServiceTokensSuccess,
  GetServiceTokensParams
>(getServiceTokensFn);

/**
 * SilencingRuleApi - fetch parameter creator
 * @export
 */
export const SilencingRuleApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {Api.CreateSilencingRule} request
		 * @param {*} [options] Override http request option.
		 */
		createSilencingRule(request: Api.CreateSilencingRule, options: any = {}): FetchArgs {
			const localVarPath = `/silencing-rules`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier The unique identifier (URN) of the silencing rule
		 * @param {*} [options] Override http request option.
		 */
		deleteSilencingRule(identifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/silencing-rules/{identifier}`
				.replace('{identifier}', encodeURIComponent(String(identifier)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getAllSilencingRules(options: any = {}): FetchArgs {
			const localVarPath = `/silencing-rules`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* SilencingRule
*/
export interface CreateSilencingRuleParams {
  body: Api.CreateSilencingRule;
}

export type CreateSilencingRuleSuccess = Api.SilencingRule;
export type CreateSilencingRuleError = HTTPError | Api.SilencingRuleApiError | Api.SilencingRuleConflictError | Api.SilencingRuleApiError;

/**
 * CreateSilencingRuleApi - functional programming interface
 * <p>Create a new silencing rule. Only one silencing rule may be active per monitor check state.</p>
 * @export
 */
export const createSilencingRuleFn = ({
 body,
 }: CreateSilencingRuleParams, options: any = {}, configuration?: Configuration): Promise<CreateSilencingRuleSuccess> => {
  const localVarFetchArgs = SilencingRuleApiFetchParamCreator(configuration).createSilencingRule(body, options);
  return requestFetch<CreateSilencingRuleSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createSilencingRule = toResponsePromiseWithMeta<
  CreateSilencingRuleError,
  CreateSilencingRuleSuccess,
  CreateSilencingRuleParams
>(createSilencingRuleFn);

export const createSilencingRuleObservable = toResponseObservableWithMeta<
  CreateSilencingRuleError,
  CreateSilencingRuleSuccess,
  CreateSilencingRuleParams
>(createSilencingRuleFn);

export interface DeleteSilencingRuleParams {
  identifier: string;
}

export type DeleteSilencingRuleSuccess = void;
export type DeleteSilencingRuleError = HTTPError | Api.SilencingRuleApiError | Api.SilencingRuleNotFoundError | Api.SilencingRuleApiError;

/**
 * DeleteSilencingRuleApi - functional programming interface
 * <p>Remove a silencing rule by its identifier.</p>
 * @export
 */
export const deleteSilencingRuleFn = ({
  identifier,
 }: DeleteSilencingRuleParams, options: any = {}, configuration?: Configuration): Promise<DeleteSilencingRuleSuccess> => {
  const localVarFetchArgs = SilencingRuleApiFetchParamCreator(configuration).deleteSilencingRule(identifier, options);
  return requestFetch<DeleteSilencingRuleSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteSilencingRule = toResponsePromiseWithMeta<
  DeleteSilencingRuleError,
  DeleteSilencingRuleSuccess,
  DeleteSilencingRuleParams
>(deleteSilencingRuleFn);

export const deleteSilencingRuleObservable = toResponseObservableWithMeta<
  DeleteSilencingRuleError,
  DeleteSilencingRuleSuccess,
  DeleteSilencingRuleParams
>(deleteSilencingRuleFn);

export interface GetAllSilencingRulesParams {
}

export type GetAllSilencingRulesSuccess = Api.SilencingRuleList;
export type GetAllSilencingRulesError = HTTPError | Api.SilencingRuleApiError;

/**
 * GetAllSilencingRulesApi - functional programming interface
 * <p>List all active silencing rules</p>
 * @export
 */
export const getAllSilencingRulesFn = ({
 }: GetAllSilencingRulesParams, options: any = {}, configuration?: Configuration): Promise<GetAllSilencingRulesSuccess> => {
  const localVarFetchArgs = SilencingRuleApiFetchParamCreator(configuration).getAllSilencingRules(options);
  return requestFetch<GetAllSilencingRulesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getAllSilencingRules = toResponsePromiseWithMeta<
  GetAllSilencingRulesError,
  GetAllSilencingRulesSuccess,
  GetAllSilencingRulesParams
>(getAllSilencingRulesFn);

export const getAllSilencingRulesObservable = toResponseObservableWithMeta<
  GetAllSilencingRulesError,
  GetAllSilencingRulesSuccess,
  GetAllSilencingRulesParams
>(getAllSilencingRulesFn);

/**
 * SnapshotApi - fetch parameter creator
 * @export
 */
export const SnapshotApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {number} [timeoutMs] Query timeout in milliseconds
		 * @param {Api.ViewSnapshotRequest} request Request body for querying a topology snapshot
		 * @param {*} [options] Override http request option.
		 */
		querySnapshot(timeoutMs: number | undefined, request: Api.ViewSnapshotRequest, options: any = {}): FetchArgs {
			const localVarPath = `/snapshot`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (timeoutMs !== undefined) {
				localVarQueryParameter['timeout-ms'] = timeoutMs;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Snapshot
*/
export interface QuerySnapshotParams {
  timeoutMs?: number;
  body: Api.ViewSnapshotRequest;
}

export type QuerySnapshotSuccess = Api.QuerySnapshotResult;
export type QuerySnapshotError = HTTPError | Api.QueryParsingFailure | "User is not authorized" | "User is forbidden for the provided permission" | Api.GenericErrorsResponse;

/**
 * QuerySnapshotApi - functional programming interface
 * @export
 */
export const querySnapshotFn = ({
  timeoutMs,
 body,
 }: QuerySnapshotParams, options: any = {}, configuration?: Configuration): Promise<QuerySnapshotSuccess> => {
  const localVarFetchArgs = SnapshotApiFetchParamCreator(configuration).querySnapshot(timeoutMs, body, options);
  return requestFetch<QuerySnapshotSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const querySnapshot = toResponsePromiseWithMeta<
  QuerySnapshotError,
  QuerySnapshotSuccess,
  QuerySnapshotParams
>(querySnapshotFn);

export const querySnapshotObservable = toResponseObservableWithMeta<
  QuerySnapshotError,
  QuerySnapshotSuccess,
  QuerySnapshotParams
>(querySnapshotFn);

/**
 * StackpackApi - fetch parameter creator
 * @export
 */
export const StackpackApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} stackPackName
		 * @param {number} stackPackInstanceId
		 * @param {*} [options] Override http request option.
		 */
		confirmManualSteps(stackPackName: string, stackPackInstanceId: number, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/confirm-manual-steps/{stackPackInstanceId}`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)))
				.replace('{stackPackInstanceId}', encodeURIComponent(String(stackPackInstanceId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} stackPackName
		 * @param {string} version Version string (e.g. &#x27;1.2.3&#x27;) to downgrade to. Must be lower than the currently installed version.
		 * @param {*} [options] Override http request option.
		 */
		downgradeStackPack(stackPackName: string, version: string, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/downgrade`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (version !== undefined) {
				localVarQueryParameter['version'] = version;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} stackPackName
		 * @param {string} unlocked
		 * @param {string} [version] Optional version string (e.g. &#x27;1.2.3&#x27;). If not provided, the latest version is used. When provisioning, the StackPack cannot already be installed at a different version.
		 * @param {{ [name: string]: string }} [request]
		 * @param {*} [options] Override http request option.
		 */
		provisionDetails(stackPackName: string, unlocked: string, version: string | undefined, request: { [name: string]: string } | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/provision`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (unlocked !== undefined) {
				localVarQueryParameter['unlocked'] = unlocked;
			}
			if (version !== undefined) {
				localVarQueryParameter['version'] = version;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} stackPackName
		 * @param {number} stackPackInstanceId
		 * @param {*} [options] Override http request option.
		 */
		provisionUninstall(stackPackName: string, stackPackInstanceId: number, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/deprovision/{stackPackInstanceId}`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)))
				.replace('{stackPackInstanceId}', encodeURIComponent(String(stackPackInstanceId)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} stackPackName
		 * @param {string} version Version string (e.g. &#x27;1.2.3&#x27;)
		 * @param {*} [options] Override http request option.
		 */
		stackPackDeleteVersion(stackPackName: string, version: string, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/versions/{version}`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)))
				.replace('{version}', encodeURIComponent(String(version)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} stackPackName
		 * @param {string} [aFrom] Inclusive lower bound. Deletes versions &gt;&#x3D; this version. Can be used alone or combined with &#x27;to&#x27; for a range.
		 * @param {string} [to] Inclusive upper bound. Deletes versions &lt;&#x3D; this version. Can be used alone or combined with &#x27;from&#x27; for a range.
		 * @param {boolean} [all] Delete all versions. Cannot be combined with &#x27;from&#x27; or &#x27;to&#x27;.
		 * @param {boolean} [dev] Filter to development versions only (versions with metadata, e.g. SNAPSHOT). Can be combined with any scope selector.
		 * @param {*} [options] Override http request option.
		 */
		stackPackDeleteVersions(stackPackName: string, aFrom: string | undefined, to: string | undefined, all: boolean | undefined, dev: boolean | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/versions`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (aFrom !== undefined) {
				localVarQueryParameter['from'] = aFrom;
			}
			if (to !== undefined) {
				localVarQueryParameter['to'] = to;
			}
			if (all !== undefined) {
				localVarQueryParameter['all'] = all;
			}
			if (dev !== undefined) {
				localVarQueryParameter['dev'] = dev;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		stackPackList(options: any = {}): FetchArgs {
			const localVarPath = `/stackpack`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} stackPackName
		 * @param {*} [options] Override http request option.
		 */
		stackPackListVersions(stackPackName: string, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/versions`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.StackPackUpload.MultipartFormData} [request]
		 * @param {*} [options] Override http request option.
		 */
		stackPackUpload(request: Api.StackPackUpload.MultipartFormData | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  (request || "");
			
			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.StackPackUpload.MultipartFormData2} [request]
		 * @param {*} [options] Override http request option.
		 */
		stackPackValidate(request: Api.StackPackUpload.MultipartFormData2 | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/validate`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  (request || "");
			
			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} stackPackName
		 * @param {string} unlocked
		 * @param {*} [options] Override http request option.
		 */
		upgradeStackPack(stackPackName: string, unlocked: string, options: any = {}): FetchArgs {
			const localVarPath = `/stackpack/{stackPackName}/upgrade`
				.replace('{stackPackName}', encodeURIComponent(String(stackPackName)));
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (unlocked !== undefined) {
				localVarQueryParameter['unlocked'] = unlocked;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Stackpack
*/
export interface ConfirmManualStepsParams {
  stackPackName: string;
  stackPackInstanceId: number;
}

export type ConfirmManualStepsSuccess = string;
export type ConfirmManualStepsError = HTTPError | Api.GenericErrorsResponse;

/**
 * ConfirmManualStepsApi - functional programming interface
 * <p>Confirm manual steps of the stackpack</p>
 * @export
 */
export const confirmManualStepsFn = ({
  stackPackName,
  stackPackInstanceId,
 }: ConfirmManualStepsParams, options: any = {}, configuration?: Configuration): Promise<ConfirmManualStepsSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).confirmManualSteps(stackPackName, stackPackInstanceId, options);
  return requestFetch<ConfirmManualStepsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const confirmManualSteps = toResponsePromiseWithMeta<
  ConfirmManualStepsError,
  ConfirmManualStepsSuccess,
  ConfirmManualStepsParams
>(confirmManualStepsFn);

export const confirmManualStepsObservable = toResponseObservableWithMeta<
  ConfirmManualStepsError,
  ConfirmManualStepsSuccess,
  ConfirmManualStepsParams
>(confirmManualStepsFn);

export interface DowngradeStackPackParams {
  stackPackName: string;
  version: string;
}

export type DowngradeStackPackSuccess = string;
export type DowngradeStackPackError = HTTPError | Api.GenericErrorsResponse;

/**
 * DowngradeStackPackApi - functional programming interface
 * <p>Downgrade a StackPack to an older version. Only supported for StackPacks 2.0; the target version must be lower than the currently installed version.</p>
 * @export
 */
export const downgradeStackPackFn = ({
  stackPackName,
  version,
 }: DowngradeStackPackParams, options: any = {}, configuration?: Configuration): Promise<DowngradeStackPackSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).downgradeStackPack(stackPackName, version, options);
  return requestFetch<DowngradeStackPackSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const downgradeStackPack = toResponsePromiseWithMeta<
  DowngradeStackPackError,
  DowngradeStackPackSuccess,
  DowngradeStackPackParams
>(downgradeStackPackFn);

export const downgradeStackPackObservable = toResponseObservableWithMeta<
  DowngradeStackPackError,
  DowngradeStackPackSuccess,
  DowngradeStackPackParams
>(downgradeStackPackFn);

export interface ProvisionDetailsParams {
  stackPackName: string;
  unlocked: string;
  version?: string;
  body: { [name: string]: string };
}

export type ProvisionDetailsSuccess = Api.ProvisionResponse;
export type ProvisionDetailsError = HTTPError | Api.GenericErrorsResponse;

/**
 * ProvisionDetailsApi - functional programming interface
 * <p>Provision details</p>
 * @export
 */
export const provisionDetailsFn = ({
  stackPackName,
  unlocked,
  version,
 body,
 }: ProvisionDetailsParams, options: any = {}, configuration?: Configuration): Promise<ProvisionDetailsSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).provisionDetails(stackPackName, unlocked, version, body, options);
  return requestFetch<ProvisionDetailsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const provisionDetails = toResponsePromiseWithMeta<
  ProvisionDetailsError,
  ProvisionDetailsSuccess,
  ProvisionDetailsParams
>(provisionDetailsFn);

export const provisionDetailsObservable = toResponseObservableWithMeta<
  ProvisionDetailsError,
  ProvisionDetailsSuccess,
  ProvisionDetailsParams
>(provisionDetailsFn);

export interface ProvisionUninstallParams {
  stackPackName: string;
  stackPackInstanceId: number;
}

export type ProvisionUninstallSuccess = string;
export type ProvisionUninstallError = HTTPError | string[] | Api.GenericErrorsResponse;

/**
 * ProvisionUninstallApi - functional programming interface
 * <p>Provision details</p>
 * @export
 */
export const provisionUninstallFn = ({
  stackPackName,
  stackPackInstanceId,
 }: ProvisionUninstallParams, options: any = {}, configuration?: Configuration): Promise<ProvisionUninstallSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).provisionUninstall(stackPackName, stackPackInstanceId, options);
  return requestFetch<ProvisionUninstallSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const provisionUninstall = toResponsePromiseWithMeta<
  ProvisionUninstallError,
  ProvisionUninstallSuccess,
  ProvisionUninstallParams
>(provisionUninstallFn);

export const provisionUninstallObservable = toResponseObservableWithMeta<
  ProvisionUninstallError,
  ProvisionUninstallSuccess,
  ProvisionUninstallParams
>(provisionUninstallFn);

export interface StackPackDeleteVersionParams {
  stackPackName: string;
  version: string;
}

export type StackPackDeleteVersionSuccess = void;
export type StackPackDeleteVersionError = HTTPError | string[] | string[] | Api.GenericErrorsResponse;

/**
 * StackPackDeleteVersionApi - functional programming interface
 * <p>Delete a specific version of a StackPack. Fails if the version is currently in use.</p>
 * @export
 */
export const stackPackDeleteVersionFn = ({
  stackPackName,
  version,
 }: StackPackDeleteVersionParams, options: any = {}, configuration?: Configuration): Promise<StackPackDeleteVersionSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).stackPackDeleteVersion(stackPackName, version, options);
  return requestFetch<StackPackDeleteVersionSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const stackPackDeleteVersion = toResponsePromiseWithMeta<
  StackPackDeleteVersionError,
  StackPackDeleteVersionSuccess,
  StackPackDeleteVersionParams
>(stackPackDeleteVersionFn);

export const stackPackDeleteVersionObservable = toResponseObservableWithMeta<
  StackPackDeleteVersionError,
  StackPackDeleteVersionSuccess,
  StackPackDeleteVersionParams
>(stackPackDeleteVersionFn);

export interface StackPackDeleteVersionsParams {
  stackPackName: string;
  aFrom?: string;
  to?: string;
  all?: boolean;
  dev?: boolean;
}

export type StackPackDeleteVersionsSuccess = Api.DeleteVersionsResult;
export type StackPackDeleteVersionsError = HTTPError | string[] | string[] | Api.DeleteVersionsResult | Api.GenericErrorsResponse;

/**
 * StackPackDeleteVersionsApi - functional programming interface
 * <p>Delete versions of a StackPack. Versions currently in use are skipped.</p>
<p>Supported parameter combinations:</p>
<ul>
<li><code>?to=X</code> — delete all versions up to and including X</li>
<li><code>?from=X</code> — delete all versions from X onwards</li>
<li><code>?from=X&amp;to=Y</code> — delete versions in the inclusive range [X, Y]</li>
<li><code>?all=true</code> — delete all versions</li>
<li>Any of the above combined with <code>&amp;dev=true</code> to restrict to development versions only</li>
</ul>
 * @export
 */
export const stackPackDeleteVersionsFn = ({
  stackPackName,
  aFrom,
  to,
  all,
  dev,
 }: StackPackDeleteVersionsParams, options: any = {}, configuration?: Configuration): Promise<StackPackDeleteVersionsSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).stackPackDeleteVersions(stackPackName, aFrom, to, all, dev, options);
  return requestFetch<StackPackDeleteVersionsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const stackPackDeleteVersions = toResponsePromiseWithMeta<
  StackPackDeleteVersionsError,
  StackPackDeleteVersionsSuccess,
  StackPackDeleteVersionsParams
>(stackPackDeleteVersionsFn);

export const stackPackDeleteVersionsObservable = toResponseObservableWithMeta<
  StackPackDeleteVersionsError,
  StackPackDeleteVersionsSuccess,
  StackPackDeleteVersionsParams
>(stackPackDeleteVersionsFn);

export interface StackPackListParams {
}

export type StackPackListSuccess = Api.FullStackPack[];
export type StackPackListError = HTTPError | string[] | Api.GenericErrorsResponse;

/**
 * StackPackListApi - functional programming interface
 * <p>list of stackpack</p>
 * @export
 */
export const stackPackListFn = ({
 }: StackPackListParams, options: any = {}, configuration?: Configuration): Promise<StackPackListSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).stackPackList(options);
  return requestFetch<StackPackListSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const stackPackList = toResponsePromiseWithMeta<
  StackPackListError,
  StackPackListSuccess,
  StackPackListParams
>(stackPackListFn);

export const stackPackListObservable = toResponseObservableWithMeta<
  StackPackListError,
  StackPackListSuccess,
  StackPackListParams
>(stackPackListFn);

export interface StackPackListVersionsParams {
  stackPackName: string;
}

export type StackPackListVersionsSuccess = Api.StackPackVersionInfo[];
export type StackPackListVersionsError = HTTPError | string[] | Api.GenericErrorsResponse;

/**
 * StackPackListVersionsApi - functional programming interface
 * <p>List all available versions of a StackPack</p>
 * @export
 */
export const stackPackListVersionsFn = ({
  stackPackName,
 }: StackPackListVersionsParams, options: any = {}, configuration?: Configuration): Promise<StackPackListVersionsSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).stackPackListVersions(stackPackName, options);
  return requestFetch<StackPackListVersionsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const stackPackListVersions = toResponsePromiseWithMeta<
  StackPackListVersionsError,
  StackPackListVersionsSuccess,
  StackPackListVersionsParams
>(stackPackListVersionsFn);

export const stackPackListVersionsObservable = toResponseObservableWithMeta<
  StackPackListVersionsError,
  StackPackListVersionsSuccess,
  StackPackListVersionsParams
>(stackPackListVersionsFn);

export interface StackPackUploadParams {
  body: Api.StackPackUpload.MultipartFormData;
}

export type StackPackUploadSuccess = Api.StackPack;
export type StackPackUploadError = HTTPError | string[] | Api.GenericErrorsResponse;

/**
 * StackPackUploadApi - functional programming interface
 * <p>upload a StackPack</p>
 * @export
 */
export const stackPackUploadFn = ({
 body,
 }: StackPackUploadParams, options: any = {}, configuration?: Configuration): Promise<StackPackUploadSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).stackPackUpload(body, options);
  return requestFetch<StackPackUploadSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const stackPackUpload = toResponsePromiseWithMeta<
  StackPackUploadError,
  StackPackUploadSuccess,
  StackPackUploadParams
>(stackPackUploadFn);

export const stackPackUploadObservable = toResponseObservableWithMeta<
  StackPackUploadError,
  StackPackUploadSuccess,
  StackPackUploadParams
>(stackPackUploadFn);

export interface StackPackValidateParams {
  body: Api.StackPackUpload.MultipartFormData2;
}

export type StackPackValidateSuccess = string;
export type StackPackValidateError = HTTPError | string[] | Api.GenericErrorsResponse;

/**
 * StackPackValidateApi - functional programming interface
 * <p>Validate a stackpack&#39;s setting declarations</p>
 * @export
 */
export const stackPackValidateFn = ({
 body,
 }: StackPackValidateParams, options: any = {}, configuration?: Configuration): Promise<StackPackValidateSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).stackPackValidate(body, options);
  return requestFetch<StackPackValidateSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const stackPackValidate = toResponsePromiseWithMeta<
  StackPackValidateError,
  StackPackValidateSuccess,
  StackPackValidateParams
>(stackPackValidateFn);

export const stackPackValidateObservable = toResponseObservableWithMeta<
  StackPackValidateError,
  StackPackValidateSuccess,
  StackPackValidateParams
>(stackPackValidateFn);

export interface UpgradeStackPackParams {
  stackPackName: string;
  unlocked: string;
}

export type UpgradeStackPackSuccess = string;
export type UpgradeStackPackError = HTTPError | Api.GenericErrorsResponse;

/**
 * UpgradeStackPackApi - functional programming interface
 * <p>Upgrade stackpack</p>
 * @export
 */
export const upgradeStackPackFn = ({
  stackPackName,
  unlocked,
 }: UpgradeStackPackParams, options: any = {}, configuration?: Configuration): Promise<UpgradeStackPackSuccess> => {
  const localVarFetchArgs = StackpackApiFetchParamCreator(configuration).upgradeStackPack(stackPackName, unlocked, options);
  return requestFetch<UpgradeStackPackSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const upgradeStackPack = toResponsePromiseWithMeta<
  UpgradeStackPackError,
  UpgradeStackPackSuccess,
  UpgradeStackPackParams
>(upgradeStackPackFn);

export const upgradeStackPackObservable = toResponseObservableWithMeta<
  UpgradeStackPackError,
  UpgradeStackPackSuccess,
  UpgradeStackPackParams
>(upgradeStackPackFn);

/**
 * SubjectApi - fetch parameter creator
 * @export
 */
export const SubjectApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} subject
		 * @param {boolean} [createOnly]
		 * @param {Api.CreateSubject} request
		 * @param {*} [options] Override http request option.
		 */
		createSubject(subject: string, createOnly: boolean | undefined, request: Api.CreateSubject, options: any = {}): FetchArgs {
			const localVarPath = `/security/subjects/{subject}`
				.replace('{subject}', encodeURIComponent(String(subject)));
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (createOnly !== undefined) {
				localVarQueryParameter['createOnly'] = createOnly;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} subject
		 * @param {*} [options] Override http request option.
		 */
		deleteSubject(subject: string, options: any = {}): FetchArgs {
			const localVarPath = `/security/subjects/{subject}`
				.replace('{subject}', encodeURIComponent(String(subject)));
			const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} subject
		 * @param {*} [options] Override http request option.
		 */
		getSubject(subject: string, options: any = {}): FetchArgs {
			const localVarPath = `/security/subjects/{subject}`
				.replace('{subject}', encodeURIComponent(String(subject)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		listSubjects(options: any = {}): FetchArgs {
			const localVarPath = `/security/subjects`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Subject
*/
export interface CreateSubjectParams {
  subject: string;
  createOnly?: boolean;
  body: Api.CreateSubject;
}

export type CreateSubjectSuccess = void;
export type CreateSubjectError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * CreateSubjectApi - functional programming interface
 * <p>Create a new security subject</p>
 * @export
 */
export const createSubjectFn = ({
  subject,
  createOnly,
 body,
 }: CreateSubjectParams, options: any = {}, configuration?: Configuration): Promise<CreateSubjectSuccess> => {
  const localVarFetchArgs = SubjectApiFetchParamCreator(configuration).createSubject(subject, createOnly, body, options);
  return requestFetch<CreateSubjectSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const createSubject = toResponsePromiseWithMeta<
  CreateSubjectError,
  CreateSubjectSuccess,
  CreateSubjectParams
>(createSubjectFn);

export const createSubjectObservable = toResponseObservableWithMeta<
  CreateSubjectError,
  CreateSubjectSuccess,
  CreateSubjectParams
>(createSubjectFn);

export interface DeleteSubjectParams {
  subject: string;
}

export type DeleteSubjectSuccess = void;
export type DeleteSubjectError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * DeleteSubjectApi - functional programming interface
 * <p>Remove a security subject</p>
 * @export
 */
export const deleteSubjectFn = ({
  subject,
 }: DeleteSubjectParams, options: any = {}, configuration?: Configuration): Promise<DeleteSubjectSuccess> => {
  const localVarFetchArgs = SubjectApiFetchParamCreator(configuration).deleteSubject(subject, options);
  return requestFetch<DeleteSubjectSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const deleteSubject = toResponsePromiseWithMeta<
  DeleteSubjectError,
  DeleteSubjectSuccess,
  DeleteSubjectParams
>(deleteSubjectFn);

export const deleteSubjectObservable = toResponseObservableWithMeta<
  DeleteSubjectError,
  DeleteSubjectSuccess,
  DeleteSubjectParams
>(deleteSubjectFn);

export interface GetSubjectParams {
  subject: string;
}

export type GetSubjectSuccess = Api.SubjectConfig;
export type GetSubjectError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * GetSubjectApi - functional programming interface
 * <p>Describe a subject</p>
 * @export
 */
export const getSubjectFn = ({
  subject,
 }: GetSubjectParams, options: any = {}, configuration?: Configuration): Promise<GetSubjectSuccess> => {
  const localVarFetchArgs = SubjectApiFetchParamCreator(configuration).getSubject(subject, options);
  return requestFetch<GetSubjectSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getSubject = toResponsePromiseWithMeta<
  GetSubjectError,
  GetSubjectSuccess,
  GetSubjectParams
>(getSubjectFn);

export const getSubjectObservable = toResponseObservableWithMeta<
  GetSubjectError,
  GetSubjectSuccess,
  GetSubjectParams
>(getSubjectFn);

export interface ListSubjectsParams {
}

export type ListSubjectsSuccess = Api.SubjectConfig[];
export type ListSubjectsError = HTTPError | Api.GenericErrorsResponse;

/**
 * ListSubjectsApi - functional programming interface
 * <p>List all subjects and their scopes</p>
 * @export
 */
export const listSubjectsFn = ({
 }: ListSubjectsParams, options: any = {}, configuration?: Configuration): Promise<ListSubjectsSuccess> => {
  const localVarFetchArgs = SubjectApiFetchParamCreator(configuration).listSubjects(options);
  return requestFetch<ListSubjectsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const listSubjects = toResponsePromiseWithMeta<
  ListSubjectsError,
  ListSubjectsSuccess,
  ListSubjectsParams
>(listSubjectsFn);

export const listSubjectsObservable = toResponseObservableWithMeta<
  ListSubjectsError,
  ListSubjectsSuccess,
  ListSubjectsParams
>(listSubjectsFn);

/**
 * SubscriptionApi - fetch parameter creator
 * @export
 */
export const SubscriptionApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		getSubscription(options: any = {}): FetchArgs {
			const localVarPath = `/subscription`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.NewLicense} request The new license
		 * @param {*} [options] Override http request option.
		 */
		postSubscription(request: Api.NewLicense, options: any = {}): FetchArgs {
			const localVarPath = `/subscription`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Subscription
*/
export interface GetSubscriptionParams {
}

export type GetSubscriptionSuccess = Api.SubscriptionState;
export type GetSubscriptionError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetSubscriptionApi - functional programming interface
 * <p>Get the state of the StackState license</p>
 * @export
 */
export const getSubscriptionFn = ({
 }: GetSubscriptionParams, options: any = {}, configuration?: Configuration): Promise<GetSubscriptionSuccess> => {
  const localVarFetchArgs = SubscriptionApiFetchParamCreator(configuration).getSubscription(options);
  return requestFetch<GetSubscriptionSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getSubscription = toResponsePromiseWithMeta<
  GetSubscriptionError,
  GetSubscriptionSuccess,
  GetSubscriptionParams
>(getSubscriptionFn);

export const getSubscriptionObservable = toResponseObservableWithMeta<
  GetSubscriptionError,
  GetSubscriptionSuccess,
  GetSubscriptionParams
>(getSubscriptionFn);

export interface PostSubscriptionParams {
  body: Api.NewLicense;
}

export type PostSubscriptionSuccess = Api.SubscriptionState;
export type PostSubscriptionError = HTTPError | Api.GenericErrorsResponse;

/**
 * PostSubscriptionApi - functional programming interface
 * <p>Update the StackState license</p>
 * @export
 */
export const postSubscriptionFn = ({
 body,
 }: PostSubscriptionParams, options: any = {}, configuration?: Configuration): Promise<PostSubscriptionSuccess> => {
  const localVarFetchArgs = SubscriptionApiFetchParamCreator(configuration).postSubscription(body, options);
  return requestFetch<PostSubscriptionSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postSubscription = toResponsePromiseWithMeta<
  PostSubscriptionError,
  PostSubscriptionSuccess,
  PostSubscriptionParams
>(postSubscriptionFn);

export const postSubscriptionObservable = toResponseObservableWithMeta<
  PostSubscriptionError,
  PostSubscriptionSuccess,
  PostSubscriptionParams
>(postSubscriptionFn);

/**
 * SystemNotificationsApi - fetch parameter creator
 * @export
 */
export const SystemNotificationsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		allSystemNotifications(options: any = {}): FetchArgs {
			const localVarPath = `/system/notifications`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* SystemNotifications
*/
export interface AllSystemNotificationsParams {
}

export type AllSystemNotificationsSuccess = Api.SystemNotifications;
export type AllSystemNotificationsError = HTTPError | "Forbidden" | Api.GenericErrorsResponse;

/**
 * AllSystemNotificationsApi - functional programming interface
 * <p>All active system notifications</p>
 * @export
 */
export const allSystemNotificationsFn = ({
 }: AllSystemNotificationsParams, options: any = {}, configuration?: Configuration): Promise<AllSystemNotificationsSuccess> => {
  const localVarFetchArgs = SystemNotificationsApiFetchParamCreator(configuration).allSystemNotifications(options);
  return requestFetch<AllSystemNotificationsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const allSystemNotifications = toResponsePromiseWithMeta<
  AllSystemNotificationsError,
  AllSystemNotificationsSuccess,
  AllSystemNotificationsParams
>(allSystemNotificationsFn);

export const allSystemNotificationsObservable = toResponseObservableWithMeta<
  AllSystemNotificationsError,
  AllSystemNotificationsSuccess,
  AllSystemNotificationsParams
>(allSystemNotificationsFn);

/**
 * TimelineApi - fetch parameter creator
 * @export
 */
export const TimelineApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {Api.TimelineSummaryRequest} request Request for event summary and aggregated health over time
		 * @param {*} [options] Override http request option.
		 */
		getTimelineSummary(request: Api.TimelineSummaryRequest, options: any = {}): FetchArgs {
			const localVarPath = `/timeline/summary`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Timeline
*/
export interface GetTimelineSummaryParams {
  body: Api.TimelineSummaryRequest;
}

export type GetTimelineSummarySuccess = Api.TimelineSummary;
export type GetTimelineSummaryError = HTTPError | Api.TimelineSummaryOverflow | Api.TimelineSummaryError;

/**
 * GetTimelineSummaryApi - functional programming interface
 * <p>Event summary and aggregated health changes for a topology over a range of time</p>
 * @export
 */
export const getTimelineSummaryFn = ({
 body,
 }: GetTimelineSummaryParams, options: any = {}, configuration?: Configuration): Promise<GetTimelineSummarySuccess> => {
  const localVarFetchArgs = TimelineApiFetchParamCreator(configuration).getTimelineSummary(body, options);
  return requestFetch<GetTimelineSummarySuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getTimelineSummary = toResponsePromiseWithMeta<
  GetTimelineSummaryError,
  GetTimelineSummarySuccess,
  GetTimelineSummaryParams
>(getTimelineSummaryFn);

export const getTimelineSummaryObservable = toResponseObservableWithMeta<
  GetTimelineSummaryError,
  GetTimelineSummarySuccess,
  GetTimelineSummaryParams
>(getTimelineSummaryFn);

/**
 * TopicApi - fetch parameter creator
 * @export
 */
export const TopicApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} topic
		 * @param {number} [limit]
		 * @param {number} [offset]
		 * @param {number} [partition]
		 * @param {*} [options] Override http request option.
		 */
		describe(topic: string, limit: number | undefined, offset: number | undefined, partition: number | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/topic/{topic}`
				.replace('{topic}', encodeURIComponent(String(topic)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (limit !== undefined) {
				localVarQueryParameter['limit'] = limit;
			}
			if (offset !== undefined) {
				localVarQueryParameter['offset'] = offset;
			}
			if (partition !== undefined) {
				localVarQueryParameter['partition'] = partition;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		list(options: any = {}): FetchArgs {
			const localVarPath = `/topic`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Topic
*/
export interface DescribeParams {
  topic: string;
  limit?: number;
  offset?: number;
  partition?: number;
}

export type DescribeSuccess = Api.Messages;
export type DescribeError = HTTPError | Api.GenericErrorsResponse | Api.GenericErrorsResponse | Api.GenericErrorsResponse;

/**
 * DescribeApi - functional programming interface
 * <p>List Kafka messages on the topic of choice</p>
 * @export
 */
export const describeFn = ({
  topic,
  limit,
  offset,
  partition,
 }: DescribeParams, options: any = {}, configuration?: Configuration): Promise<DescribeSuccess> => {
  const localVarFetchArgs = TopicApiFetchParamCreator(configuration).describe(topic, limit, offset, partition, options);
  return requestFetch<DescribeSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const describe = toResponsePromiseWithMeta<
  DescribeError,
  DescribeSuccess,
  DescribeParams
>(describeFn);

export const describeObservable = toResponseObservableWithMeta<
  DescribeError,
  DescribeSuccess,
  DescribeParams
>(describeFn);

export interface ListParams {
}

export type ListSuccess = Api.Topic[];
export type ListError = HTTPError | Api.GenericErrorsResponse;

/**
 * ListApi - functional programming interface
 * <p>List all Kafka topics available in StackState</p>
 * @export
 */
export const listFn = ({
 }: ListParams, options: any = {}, configuration?: Configuration): Promise<ListSuccess> => {
  const localVarFetchArgs = TopicApiFetchParamCreator(configuration).list(options);
  return requestFetch<ListSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const list = toResponsePromiseWithMeta<
  ListError,
  ListSuccess,
  ListParams
>(listFn);

export const listObservable = toResponseObservableWithMeta<
  ListError,
  ListSuccess,
  ListParams
>(listFn);

/**
 * TopologySynchronizationApi - fetch parameter creator
 * @export
 */
export const TopologySynchronizationApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} identifier
		 * @param {Api.IdentifierType} identifierType
		 * @param {*} [options] Override http request option.
		 */
		getTopologySynchronizationStreamById(identifier: string, identifierType: Api.IdentifierType, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/topology/streams/sync`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (identifier !== undefined) {
				localVarQueryParameter['identifier'] = identifier;
			}
			if (identifierType !== undefined) {
				localVarQueryParameter['identifierType'] = identifierType;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getTopologySynchronizationStreams(options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/topology/streams`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} identifier
		 * @param {Api.IdentifierType} identifierType
		 * @param {*} [options] Override http request option.
		 */
		postTopologySynchronizationStreamClearErrors(identifier: string, identifierType: Api.IdentifierType, options: any = {}): FetchArgs {
			const localVarPath = `/synchronization/topology/streams/clearErrors`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (identifier !== undefined) {
				localVarQueryParameter['identifier'] = identifier;
			}
			if (identifierType !== undefined) {
				localVarQueryParameter['identifierType'] = identifierType;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* TopologySynchronization
*/
export interface GetTopologySynchronizationStreamByIdParams {
  identifier: string;
  identifierType: Api.IdentifierType;
}

export type GetTopologySynchronizationStreamByIdSuccess = Api.TopologyStreamListItemWithErrorDetails;
export type GetTopologySynchronizationStreamByIdError = HTTPError | Api.InvalidSyncIdentifier | Api.TopologySyncError;

/**
 * GetTopologySynchronizationStreamByIdApi - functional programming interface
 * <p>Overview of a specific Topology Stream, queried by node id or sync identifier</p>
 * @export
 */
export const getTopologySynchronizationStreamByIdFn = ({
  identifier,
  identifierType,
 }: GetTopologySynchronizationStreamByIdParams, options: any = {}, configuration?: Configuration): Promise<GetTopologySynchronizationStreamByIdSuccess> => {
  const localVarFetchArgs = TopologySynchronizationApiFetchParamCreator(configuration).getTopologySynchronizationStreamById(identifier, identifierType, options);
  return requestFetch<GetTopologySynchronizationStreamByIdSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getTopologySynchronizationStreamById = toResponsePromiseWithMeta<
  GetTopologySynchronizationStreamByIdError,
  GetTopologySynchronizationStreamByIdSuccess,
  GetTopologySynchronizationStreamByIdParams
>(getTopologySynchronizationStreamByIdFn);

export const getTopologySynchronizationStreamByIdObservable = toResponseObservableWithMeta<
  GetTopologySynchronizationStreamByIdError,
  GetTopologySynchronizationStreamByIdSuccess,
  GetTopologySynchronizationStreamByIdParams
>(getTopologySynchronizationStreamByIdFn);

export interface GetTopologySynchronizationStreamsParams {
}

export type GetTopologySynchronizationStreamsSuccess = Api.TopologyStreamList;
export type GetTopologySynchronizationStreamsError = HTTPError;

/**
 * GetTopologySynchronizationStreamsApi - functional programming interface
 * <p>Overview of the topology synchronization streams</p>
 * @export
 */
export const getTopologySynchronizationStreamsFn = ({
 }: GetTopologySynchronizationStreamsParams, options: any = {}, configuration?: Configuration): Promise<GetTopologySynchronizationStreamsSuccess> => {
  const localVarFetchArgs = TopologySynchronizationApiFetchParamCreator(configuration).getTopologySynchronizationStreams(options);
  return requestFetch<GetTopologySynchronizationStreamsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getTopologySynchronizationStreams = toResponsePromiseWithMeta<
  GetTopologySynchronizationStreamsError,
  GetTopologySynchronizationStreamsSuccess,
  GetTopologySynchronizationStreamsParams
>(getTopologySynchronizationStreamsFn);

export const getTopologySynchronizationStreamsObservable = toResponseObservableWithMeta<
  GetTopologySynchronizationStreamsError,
  GetTopologySynchronizationStreamsSuccess,
  GetTopologySynchronizationStreamsParams
>(getTopologySynchronizationStreamsFn);

export interface PostTopologySynchronizationStreamClearErrorsParams {
  identifier: string;
  identifierType: Api.IdentifierType;
}

export type PostTopologySynchronizationStreamClearErrorsSuccess = void;
export type PostTopologySynchronizationStreamClearErrorsError = HTTPError | Api.InvalidSyncIdentifier | Api.TopologySyncError;

/**
 * PostTopologySynchronizationStreamClearErrorsApi - functional programming interface
 * <p>Clear all the errors related to a specific sync</p>
 * @export
 */
export const postTopologySynchronizationStreamClearErrorsFn = ({
  identifier,
  identifierType,
 }: PostTopologySynchronizationStreamClearErrorsParams, options: any = {}, configuration?: Configuration): Promise<PostTopologySynchronizationStreamClearErrorsSuccess> => {
  const localVarFetchArgs = TopologySynchronizationApiFetchParamCreator(configuration).postTopologySynchronizationStreamClearErrors(identifier, identifierType, options);
  return requestFetch<PostTopologySynchronizationStreamClearErrorsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const postTopologySynchronizationStreamClearErrors = toResponsePromiseWithMeta<
  PostTopologySynchronizationStreamClearErrorsError,
  PostTopologySynchronizationStreamClearErrorsSuccess,
  PostTopologySynchronizationStreamClearErrorsParams
>(postTopologySynchronizationStreamClearErrorsFn);

export const postTopologySynchronizationStreamClearErrorsObservable = toResponseObservableWithMeta<
  PostTopologySynchronizationStreamClearErrorsError,
  PostTopologySynchronizationStreamClearErrorsSuccess,
  PostTopologySynchronizationStreamClearErrorsParams
>(postTopologySynchronizationStreamClearErrorsFn);

/**
 * TracesApi - fetch parameter creator
 * @export
 */
export const TracesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} traceId The id of the trace
		 * @param {string} spanId The id of the span
		 * @param {*} [options] Override http request option.
		 */
		getSpan(traceId: string, spanId: string, options: any = {}): FetchArgs {
			const localVarPath = `/traces/{traceId}/spans/{spanId}`
				.replace('{traceId}', encodeURIComponent(String(traceId)))
				.replace('{spanId}', encodeURIComponent(String(spanId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} traceId The id of the trace
		 * @param {*} [options] Override http request option.
		 */
		getTrace(traceId: string, options: any = {}): FetchArgs {
			const localVarPath = `/traces/{traceId}`
				.replace('{traceId}', encodeURIComponent(String(traceId)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} start Filter spans by start time &gt;&#x3D; value
		 * @param {number} end Filter spans by start time &lt; value
		 * @param {number} bucketsCount The number of histogram buckets.
		 * @param {Api.TraceFilter} request Filter for traces
		 * @param {*} [options] Override http request option.
		 */
		queryDuration(start: number, end: number, bucketsCount: number, request: Api.TraceFilter, options: any = {}): FetchArgs {
			const localVarPath = `/traces/duration/histogram`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (start !== undefined) {
				localVarQueryParameter['start'] = start;
			}
			if (end !== undefined) {
				localVarQueryParameter['end'] = end;
			}
			if (bucketsCount !== undefined) {
				localVarQueryParameter['bucketsCount'] = bucketsCount;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {number} start Filter spans by start time &gt;&#x3D; value
		 * @param {number} end Filter spans by start time &lt; value
		 * @param {number} [pageSize] Number of spans in 1 page
		 * @param {number} [page] Get the specified page (with pageSize # of spans), defaults to page 0
		 * @param {Api.TraceQuery} request Query for traces
		 * @param {*} [options] Override http request option.
		 */
		queryTraces(start: number, end: number, pageSize: number | undefined, page: number | undefined, request: Api.TraceQuery, options: any = {}): FetchArgs {
			const localVarPath = `/traces/query`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (start !== undefined) {
				localVarQueryParameter['start'] = start;
			}
			if (end !== undefined) {
				localVarQueryParameter['end'] = end;
			}
			if (pageSize !== undefined) {
				localVarQueryParameter['pageSize'] = pageSize;
			}
			if (page !== undefined) {
				localVarQueryParameter['page'] = page;
			}
			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.ComponentQuery} request Span properties to find matching components
		 * @param {*} [options] Override http request option.
		 */
		spanComponents(request: Api.ComponentQuery, options: any = {}): FetchArgs {
			const localVarPath = `/traces/components`;
			const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} [contains] Get suggestions based of this partial name
		 * @param {*} [options] Override http request option.
		 */
		suggestionsAttributeName(contains: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/traces/spans/fields/attributes`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (contains !== undefined) {
				localVarQueryParameter['contains'] = contains;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {string} attributeName Get suggestions for this attribute
		 * @param {string} [contains] Get suggestions based on this partial value
		 * @param {*} [options] Override http request option.
		 */
		suggestionsAttributeValue(attributeName: string, contains: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/traces/spans/fields/attributes/{attributeName}/values`
				.replace('{attributeName}', encodeURIComponent(String(attributeName)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (contains !== undefined) {
				localVarQueryParameter['contains'] = contains;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.SpanSuggestionField} field Get suggestions for this field
		 * @param {string} [contains] Get suggestions for this field based on this partial value
		 * @param {*} [options] Override http request option.
		 */
		suggestionsFieldValues(field: Api.SpanSuggestionField, contains: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/traces/spans/fields/{field}/values`
				.replace('{field}', encodeURIComponent(String(field)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (contains !== undefined) {
				localVarQueryParameter['contains'] = contains;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* Traces
*/
export interface GetSpanParams {
  traceId: string;
  spanId: string;
}

export type GetSpanSuccess = Api.SpanResponse;
export type GetSpanError = HTTPError | Api.TraceApiSpanNotFound | Api.TraceApiError;

/**
 * GetSpanApi - functional programming interface
 * <p>Get a single span for a trace</p>
 * @export
 */
export const getSpanFn = ({
  traceId,
  spanId,
 }: GetSpanParams, options: any = {}, configuration?: Configuration): Promise<GetSpanSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).getSpan(traceId, spanId, options);
  return requestFetch<GetSpanSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getSpan = toResponsePromiseWithMeta<
  GetSpanError,
  GetSpanSuccess,
  GetSpanParams
>(getSpanFn);

export const getSpanObservable = toResponseObservableWithMeta<
  GetSpanError,
  GetSpanSuccess,
  GetSpanParams
>(getSpanFn);

export interface GetTraceParams {
  traceId: string;
}

export type GetTraceSuccess = Api.Trace;
export type GetTraceError = HTTPError | Api.TraceApiTraceNotFound | Api.TraceApiError;

/**
 * GetTraceApi - functional programming interface
 * <p>Get a full trace by id only</p>
 * @export
 */
export const getTraceFn = ({
  traceId,
 }: GetTraceParams, options: any = {}, configuration?: Configuration): Promise<GetTraceSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).getTrace(traceId, options);
  return requestFetch<GetTraceSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getTrace = toResponsePromiseWithMeta<
  GetTraceError,
  GetTraceSuccess,
  GetTraceParams
>(getTraceFn);

export const getTraceObservable = toResponseObservableWithMeta<
  GetTraceError,
  GetTraceSuccess,
  GetTraceParams
>(getTraceFn);

export interface QueryDurationParams {
  start: number;
  end: number;
  bucketsCount: number;
  body: Api.TraceFilter;
}

export type QueryDurationSuccess = Api.DurationHistogram;
export type QueryDurationError = HTTPError | Api.TraceApiSpansBadRequest | Api.TraceApiError;

/**
 * QueryDurationApi - functional programming interface
 * <p>Query for durations using filters.  Filters that accept an array of values match if any of the values match (think of a SQL IN expression).</p>
 * @export
 */
export const queryDurationFn = ({
  start,
  end,
  bucketsCount,
 body,
 }: QueryDurationParams, options: any = {}, configuration?: Configuration): Promise<QueryDurationSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).queryDuration(start, end, bucketsCount, body, options);
  return requestFetch<QueryDurationSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const queryDuration = toResponsePromiseWithMeta<
  QueryDurationError,
  QueryDurationSuccess,
  QueryDurationParams
>(queryDurationFn);

export const queryDurationObservable = toResponseObservableWithMeta<
  QueryDurationError,
  QueryDurationSuccess,
  QueryDurationParams
>(queryDurationFn);

export interface QueryTracesParams {
  start: number;
  end: number;
  pageSize?: number;
  page?: number;
  body: Api.TraceQuery;
}

export type QueryTracesSuccess = Api.TraceQueryResponse;
export type QueryTracesError = HTTPError | Api.TraceApiSpansBadRequest | Api.TraceApiError;

/**
 * QueryTracesApi - functional programming interface
 * <p>Query for traces using filters. Filters that accept an array of values match if any of the values match (think of a SQL IN expression).</p>
 * @export
 */
export const queryTracesFn = ({
  start,
  end,
  pageSize,
  page,
 body,
 }: QueryTracesParams, options: any = {}, configuration?: Configuration): Promise<QueryTracesSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).queryTraces(start, end, pageSize, page, body, options);
  return requestFetch<QueryTracesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const queryTraces = toResponsePromiseWithMeta<
  QueryTracesError,
  QueryTracesSuccess,
  QueryTracesParams
>(queryTracesFn);

export const queryTracesObservable = toResponseObservableWithMeta<
  QueryTracesError,
  QueryTracesSuccess,
  QueryTracesParams
>(queryTracesFn);

export interface SpanComponentsParams {
  body: Api.ComponentQuery;
}

export type SpanComponentsSuccess = Api.SpanComponents;
export type SpanComponentsError = HTTPError | Api.TraceApiError;

/**
 * SpanComponentsApi - functional programming interface
 * <p>Based on the resource attributes on a span, retrieve components that have a TraceBinding for it.</p>
 * @export
 */
export const spanComponentsFn = ({
 body,
 }: SpanComponentsParams, options: any = {}, configuration?: Configuration): Promise<SpanComponentsSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).spanComponents(body, options);
  return requestFetch<SpanComponentsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const spanComponents = toResponsePromiseWithMeta<
  SpanComponentsError,
  SpanComponentsSuccess,
  SpanComponentsParams
>(spanComponentsFn);

export const spanComponentsObservable = toResponseObservableWithMeta<
  SpanComponentsError,
  SpanComponentsSuccess,
  SpanComponentsParams
>(spanComponentsFn);

export interface SuggestionsAttributeNameParams {
  contains?: string;
}

export type SuggestionsAttributeNameSuccess = Api.Suggestions;
export type SuggestionsAttributeNameError = HTTPError | Api.TraceApiError;

/**
 * SuggestionsAttributeNameApi - functional programming interface
 * <p>Suggestions for attribute names, both resource and span attributes. Attributes match when their name contains the provided part, at most 100 suggestions will be returned. Make the part longer to get more accurate suggestions.</p>
 * @export
 */
export const suggestionsAttributeNameFn = ({
  contains,
 }: SuggestionsAttributeNameParams, options: any = {}, configuration?: Configuration): Promise<SuggestionsAttributeNameSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).suggestionsAttributeName(contains, options);
  return requestFetch<SuggestionsAttributeNameSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const suggestionsAttributeName = toResponsePromiseWithMeta<
  SuggestionsAttributeNameError,
  SuggestionsAttributeNameSuccess,
  SuggestionsAttributeNameParams
>(suggestionsAttributeNameFn);

export const suggestionsAttributeNameObservable = toResponseObservableWithMeta<
  SuggestionsAttributeNameError,
  SuggestionsAttributeNameSuccess,
  SuggestionsAttributeNameParams
>(suggestionsAttributeNameFn);

export interface SuggestionsAttributeValueParams {
  attributeName: string;
  contains?: string;
}

export type SuggestionsAttributeValueSuccess = Api.Suggestions;
export type SuggestionsAttributeValueError = HTTPError | Api.TraceApiError;

/**
 * SuggestionsAttributeValueApi - functional programming interface
 * <p>Suggestions for attribute values, both resource and span attributes. Attribute values match when the value contains the provided part, at most 100 suggestions will be returned. Make the part longer to get more accurate suggestions.</p>
 * @export
 */
export const suggestionsAttributeValueFn = ({
  attributeName,
  contains,
 }: SuggestionsAttributeValueParams, options: any = {}, configuration?: Configuration): Promise<SuggestionsAttributeValueSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).suggestionsAttributeValue(attributeName, contains, options);
  return requestFetch<SuggestionsAttributeValueSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const suggestionsAttributeValue = toResponsePromiseWithMeta<
  SuggestionsAttributeValueError,
  SuggestionsAttributeValueSuccess,
  SuggestionsAttributeValueParams
>(suggestionsAttributeValueFn);

export const suggestionsAttributeValueObservable = toResponseObservableWithMeta<
  SuggestionsAttributeValueError,
  SuggestionsAttributeValueSuccess,
  SuggestionsAttributeValueParams
>(suggestionsAttributeValueFn);

export interface SuggestionsFieldValuesParams {
  field: Api.SpanSuggestionField;
  contains?: string;
}

export type SuggestionsFieldValuesSuccess = Api.Suggestions;
export type SuggestionsFieldValuesError = HTTPError | Api.TraceApiError;

/**
 * SuggestionsFieldValuesApi - functional programming interface
 * <p>Suggestions for values of of the span fields that can be filtered on except resource and span attributes. Values match when they contain the provided part, at most 100 suggestions will be returned. Make the part longer to get more accurate suggestions.</p>
 * @export
 */
export const suggestionsFieldValuesFn = ({
  field,
  contains,
 }: SuggestionsFieldValuesParams, options: any = {}, configuration?: Configuration): Promise<SuggestionsFieldValuesSuccess> => {
  const localVarFetchArgs = TracesApiFetchParamCreator(configuration).suggestionsFieldValues(field, contains, options);
  return requestFetch<SuggestionsFieldValuesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const suggestionsFieldValues = toResponsePromiseWithMeta<
  SuggestionsFieldValuesError,
  SuggestionsFieldValuesSuccess,
  SuggestionsFieldValuesParams
>(suggestionsFieldValuesFn);

export const suggestionsFieldValuesObservable = toResponseObservableWithMeta<
  SuggestionsFieldValuesError,
  SuggestionsFieldValuesSuccess,
  SuggestionsFieldValuesParams
>(suggestionsFieldValuesFn);

/**
 * UserAuthorizationApi - fetch parameter creator
 * @export
 */
export const UserAuthorizationApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} permission
		 * @param {string} [resourceName]
		 * @param {*} [options] Override http request option.
		 */
		getUserAuthorizationFor(permission: string, resourceName: string | undefined, options: any = {}): FetchArgs {
			const localVarPath = `/user/authorization/for`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			if (permission !== undefined) {
				localVarQueryParameter['permission'] = permission;
			}
			if (resourceName !== undefined) {
				localVarQueryParameter['resourceName'] = resourceName;
			}
			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* UserAuthorization
*/
export interface GetUserAuthorizationForParams {
  permission: string;
  resourceName?: string;
}

export type GetUserAuthorizationForSuccess = void;
export type GetUserAuthorizationForError = HTTPError | "Provided permission does not exist" | "User is not authorized" | "User is forbidden for the provided permission" | Api.GenericErrorsResponse;

/**
 * GetUserAuthorizationForApi - functional programming interface
 * <p>Is the current user authorized for the provided permission and resource</p>
 * @export
 */
export const getUserAuthorizationForFn = ({
  permission,
  resourceName,
 }: GetUserAuthorizationForParams, options: any = {}, configuration?: Configuration): Promise<GetUserAuthorizationForSuccess> => {
  const localVarFetchArgs = UserAuthorizationApiFetchParamCreator(configuration).getUserAuthorizationFor(permission, resourceName, options);
  return requestFetch<GetUserAuthorizationForSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getUserAuthorizationFor = toResponsePromiseWithMeta<
  GetUserAuthorizationForError,
  GetUserAuthorizationForSuccess,
  GetUserAuthorizationForParams
>(getUserAuthorizationForFn);

export const getUserAuthorizationForObservable = toResponseObservableWithMeta<
  GetUserAuthorizationForError,
  GetUserAuthorizationForSuccess,
  GetUserAuthorizationForParams
>(getUserAuthorizationForFn);

/**
 * UserProfileApi - fetch parameter creator
 * @export
 */
export const UserProfileApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		getCurrentUserProfile(options: any = {}): FetchArgs {
			const localVarPath = `/user/profile`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.UserProfile} request
		 * @param {*} [options] Override http request option.
		 */
		saveCurrentUserProfile(request: Api.UserProfile, options: any = {}): FetchArgs {
			const localVarPath = `/user/profile`;
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* UserProfile
*/
export interface GetCurrentUserProfileParams {
}

export type GetCurrentUserProfileSuccess = Api.UserProfile;
export type GetCurrentUserProfileError = HTTPError | Api.UserNotFoundError | Api.GenericErrorsResponse;

/**
 * GetCurrentUserProfileApi - functional programming interface
 * <p>Get current user profile.</p>
 * @export
 */
export const getCurrentUserProfileFn = ({
 }: GetCurrentUserProfileParams, options: any = {}, configuration?: Configuration): Promise<GetCurrentUserProfileSuccess> => {
  const localVarFetchArgs = UserProfileApiFetchParamCreator(configuration).getCurrentUserProfile(options);
  return requestFetch<GetCurrentUserProfileSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getCurrentUserProfile = toResponsePromiseWithMeta<
  GetCurrentUserProfileError,
  GetCurrentUserProfileSuccess,
  GetCurrentUserProfileParams
>(getCurrentUserProfileFn);

export const getCurrentUserProfileObservable = toResponseObservableWithMeta<
  GetCurrentUserProfileError,
  GetCurrentUserProfileSuccess,
  GetCurrentUserProfileParams
>(getCurrentUserProfileFn);

export interface SaveCurrentUserProfileParams {
  body: Api.UserProfile;
}

export type SaveCurrentUserProfileSuccess = Api.UserProfile;
export type SaveCurrentUserProfileError = HTTPError | Api.UserProfileSaveError | Api.GenericErrorsResponse;

/**
 * SaveCurrentUserProfileApi - functional programming interface
 * <p>Save current user profile.</p>
 * @export
 */
export const saveCurrentUserProfileFn = ({
 body,
 }: SaveCurrentUserProfileParams, options: any = {}, configuration?: Configuration): Promise<SaveCurrentUserProfileSuccess> => {
  const localVarFetchArgs = UserProfileApiFetchParamCreator(configuration).saveCurrentUserProfile(body, options);
  return requestFetch<SaveCurrentUserProfileSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const saveCurrentUserProfile = toResponsePromiseWithMeta<
  SaveCurrentUserProfileError,
  SaveCurrentUserProfileSuccess,
  SaveCurrentUserProfileParams
>(saveCurrentUserProfileFn);

export const saveCurrentUserProfileObservable = toResponseObservableWithMeta<
  SaveCurrentUserProfileError,
  SaveCurrentUserProfileSuccess,
  SaveCurrentUserProfileParams
>(saveCurrentUserProfileFn);

/**
 * UserSessionApi - fetch parameter creator
 * @export
 */
export const UserSessionApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {*} [options] Override http request option.
		 */
		getUserSessionAssumedRole(options: any = {}): FetchArgs {
			const localVarPath = `/user/session/assumedRole`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getUserSessionAvailableRoles(options: any = {}): FetchArgs {
			const localVarPath = `/user/session/availableRoles`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {Api.Role} request
		 * @param {*} [options] Override http request option.
		 */
		saveUserSessionAssumedRole(request: Api.Role, options: any = {}): FetchArgs {
			const localVarPath = `/user/session/assumedRole`;
			const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			localVarHeaderParameter['Content-Type'] = 'application/json';

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
			localVarRequestOptions.body =  JSON.stringify(request || {});

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* UserSession
*/
export interface GetUserSessionAssumedRoleParams {
}

export type GetUserSessionAssumedRoleSuccess = Api.Role;
export type GetUserSessionAssumedRoleError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetUserSessionAssumedRoleApi - functional programming interface
 * <p>Get the assumed a role for the current session.</p>
 * @export
 */
export const getUserSessionAssumedRoleFn = ({
 }: GetUserSessionAssumedRoleParams, options: any = {}, configuration?: Configuration): Promise<GetUserSessionAssumedRoleSuccess> => {
  const localVarFetchArgs = UserSessionApiFetchParamCreator(configuration).getUserSessionAssumedRole(options);
  return requestFetch<GetUserSessionAssumedRoleSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getUserSessionAssumedRole = toResponsePromiseWithMeta<
  GetUserSessionAssumedRoleError,
  GetUserSessionAssumedRoleSuccess,
  GetUserSessionAssumedRoleParams
>(getUserSessionAssumedRoleFn);

export const getUserSessionAssumedRoleObservable = toResponseObservableWithMeta<
  GetUserSessionAssumedRoleError,
  GetUserSessionAssumedRoleSuccess,
  GetUserSessionAssumedRoleParams
>(getUserSessionAssumedRoleFn);

export interface GetUserSessionAvailableRolesParams {
}

export type GetUserSessionAvailableRolesSuccess = Api.Roles;
export type GetUserSessionAvailableRolesError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetUserSessionAvailableRolesApi - functional programming interface
 * <p>Get a list of available roles for this session.</p>
 * @export
 */
export const getUserSessionAvailableRolesFn = ({
 }: GetUserSessionAvailableRolesParams, options: any = {}, configuration?: Configuration): Promise<GetUserSessionAvailableRolesSuccess> => {
  const localVarFetchArgs = UserSessionApiFetchParamCreator(configuration).getUserSessionAvailableRoles(options);
  return requestFetch<GetUserSessionAvailableRolesSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getUserSessionAvailableRoles = toResponsePromiseWithMeta<
  GetUserSessionAvailableRolesError,
  GetUserSessionAvailableRolesSuccess,
  GetUserSessionAvailableRolesParams
>(getUserSessionAvailableRolesFn);

export const getUserSessionAvailableRolesObservable = toResponseObservableWithMeta<
  GetUserSessionAvailableRolesError,
  GetUserSessionAvailableRolesSuccess,
  GetUserSessionAvailableRolesParams
>(getUserSessionAvailableRolesFn);

export interface SaveUserSessionAssumedRoleParams {
  body: Api.Role;
}

export type SaveUserSessionAssumedRoleSuccess = Api.Role;
export type SaveUserSessionAssumedRoleError = HTTPError | Api.RoleNotAvailableError | Api.GenericErrorsResponse;

/**
 * SaveUserSessionAssumedRoleApi - functional programming interface
 * <p>Set the assumed role for the current session.</p>
 * @export
 */
export const saveUserSessionAssumedRoleFn = ({
 body,
 }: SaveUserSessionAssumedRoleParams, options: any = {}, configuration?: Configuration): Promise<SaveUserSessionAssumedRoleSuccess> => {
  const localVarFetchArgs = UserSessionApiFetchParamCreator(configuration).saveUserSessionAssumedRole(body, options);
  return requestFetch<SaveUserSessionAssumedRoleSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const saveUserSessionAssumedRole = toResponsePromiseWithMeta<
  SaveUserSessionAssumedRoleError,
  SaveUserSessionAssumedRoleSuccess,
  SaveUserSessionAssumedRoleParams
>(saveUserSessionAssumedRoleFn);

export const saveUserSessionAssumedRoleObservable = toResponseObservableWithMeta<
  SaveUserSessionAssumedRoleError,
  SaveUserSessionAssumedRoleSuccess,
  SaveUserSessionAssumedRoleParams
>(saveUserSessionAssumedRoleFn);

/**
 * ViewApi - fetch parameter creator
 * @export
 */
export const ViewApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * @param {string} viewIdOrIdentifier The system ID or identifier of a QueryView.
		 * @param {*} [options] Override http request option.
		 */
		getView(viewIdOrIdentifier: string, options: any = {}): FetchArgs {
			const localVarPath = `/views/{viewIdOrIdentifier}`
				.replace('{viewIdOrIdentifier}', encodeURIComponent(String(viewIdOrIdentifier)));
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
		/**
		 * @param {*} [options] Override http request option.
		 */
		getViews(options: any = {}): FetchArgs {
			const localVarPath = `/views`;
			const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter = {} as any;
			const localVarQueryParameter = {} as any;

			const requestQuery = Object.assign({}, localVarQueryParameter, options.query);
			localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

			return {
				url: stringifyUrl({ url: localVarPath, query: requestQuery }),
				options: localVarRequestOptions,
			};
		},
	}
};


/**
* View
*/
export interface GetViewParams {
  viewIdOrIdentifier: string;
}

export type GetViewSuccess = Api.View;
export type GetViewError = HTTPError | Api.ViewNotFoundError | Api.GenericErrorsResponse;

/**
 * GetViewApi - functional programming interface
 * <p>Get a QueryView by its ID or identifier.</p>
 * @export
 */
export const getViewFn = ({
  viewIdOrIdentifier,
 }: GetViewParams, options: any = {}, configuration?: Configuration): Promise<GetViewSuccess> => {
  const localVarFetchArgs = ViewApiFetchParamCreator(configuration).getView(viewIdOrIdentifier, options);
  return requestFetch<GetViewSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getView = toResponsePromiseWithMeta<
  GetViewError,
  GetViewSuccess,
  GetViewParams
>(getViewFn);

export const getViewObservable = toResponseObservableWithMeta<
  GetViewError,
  GetViewSuccess,
  GetViewParams
>(getViewFn);

export interface GetViewsParams {
}

export type GetViewsSuccess = Api.ViewList;
export type GetViewsError = HTTPError | Api.GenericErrorsResponse;

/**
 * GetViewsApi - functional programming interface
 * <p>Get a list of all QueryView settings.</p>
 * @export
 */
export const getViewsFn = ({
 }: GetViewsParams, options: any = {}, configuration?: Configuration): Promise<GetViewsSuccess> => {
  const localVarFetchArgs = ViewApiFetchParamCreator(configuration).getViews(options);
  return requestFetch<GetViewsSuccess>(BASE_PATH + localVarFetchArgs.url, localVarFetchArgs.options);
};

export const getViews = toResponsePromiseWithMeta<
  GetViewsError,
  GetViewsSuccess,
  GetViewsParams
>(getViewsFn);

export const getViewsObservable = toResponseObservableWithMeta<
  GetViewsError,
  GetViewsSuccess,
  GetViewsParams
>(getViewsFn);

